export default {
  translation: {


    // App
    'apartment_system': 'نظام إدارة الشقق',
    'apartment_management': 'إدارة الشقق',
    'building_management': 'إدارة المباني',

    // Navigation - updated
    'dashboard': 'لوحة التحكم',
    'user_management': 'إدارة المستخدمين',
    'building_management': 'إدارة المباني',
    'apartment_management': 'إدارة الشقق',
    'owner_management': 'إدارة الملاك',
    'tenant_management': 'إدارة المستأجرين',
    'payment_management': 'إدارة المدفوعات',
    'service_management': 'إدارة الخدمات',
    'report_management': 'التقارير والتحليلات',
    'log_management': 'سجلات النشاط',

    // Buildings
    'buildings': 'المباني',
    'building_list': 'قائمة المباني',
    'add_building': 'إضافة مبنى',
    'edit_building': 'تعديل المبنى',
    'building_details': 'تفاصيل المبنى',
    'building_name': 'اسم المبنى',
    'building_address': 'العنوان',
    'total_floors': 'إجمالي الطوابق',
    'total_apartments': 'إجمالي الشقق',
    'building_view': 'عرض المبنى',
    'showing_all_apartments': 'عرض جميع الشقق',
    'expand_all_floors': 'عرض جميع الطوابق',
    'collapse_all_floors': 'إخفاء جميع الطوابق',
    'all_service_payments': 'جميع مدفوعات الخدمات',
    'manage_all_service_payments_across_buildings': 'إدارة جميع مدفوعات الخدمات عبر المباني',
    'tenants_management': 'إدارة المستأجرين',
    'manage_tenants_and_leases': 'إدارة المستأجرين والعقود',
    'past_tenants': 'المستأجرين السابقين',
    'lease_ended': 'انتهاء العقد',
    'end_lease_confirm_title': 'تأكيد انتهاء العقد',
    'end_lease_confirm_body': 'هل أنت متأكد من رغبتك في إنهاء هذا العقد؟',
    'no_past_tenants': 'لا يوجد مستأجرين سابقين',
    'status_expired_description': 'لقد انتهى هذا العقد. لا يمكن تطبيق أي مدفوعات أخرى عليه.',
    'lease_expired_warning': 'لقد انتهى هذا العقد.',
    'tenant_lease_expired_message': 'لا يمكن تطبيق أي مدفوعات أخرى عليه.',
    'expired_on': 'انتهى في',
    'manage_tenant': 'إدارة المستأجر',
    'move_in_pending': 'الانتقال قيد الانتظار',
    'lease_expired': 'انتهاء العقد',


    // Apartments (renamed from Properties)
    'apartments': 'الشقق',
    'apartment_list': 'قائمة الشقق',
    'add_apartment': 'إضافة شقة',
    'edit_apartment': 'تعديل الشقة',
    'apartment_details': 'تفاصيل الشقة',
    'apartment_number': 'رقم الشقة',
    'apartment_display': 'غرفة {{number}}',
    'floor_number': 'رقم الطابق',
    'floor_display': 'الطابق {{number}}',
    'monthly_rent': 'الإيجار الشهري',
    'apartment_status': 'الحالة',
    'vacant': 'شاغرة',
    'occupied': 'مشغولة',
    'under_maintenance': 'تحت الصيانة',
    'key_status': 'حالة المفتاح',
    'at_office': 'في المكتب',
    'with_tenant': 'مع المستأجر',
    'with_maintenance': 'مع الصيانة',
    'lost': 'مفقود',
    'key_handover': 'تسليم المفاتيح',
    'give_out_keys': 'تسليم مفاتيح',
    'return_keys': 'استرجاع مفاتيح',
    'keys': 'مفاتيح',
    'remotes': 'أجهزة تحكم',
    'fobs': 'بطاقات دخول',
    'possession_date': 'تاريخ الحيازة',
    'key_details': 'تفاصيل المفاتيح',
    'key_history': 'سجل المفاتيح',
    'record_handover': 'تسجيل التسليم',
    'confirm_and_record': 'تأكيد وتسجيل',
    'add_notes': 'أضف أي ملاحظات إضافية هنا...',
    'no_key_history': 'لم يتم العثور على سجل لتسليم المفاتيح.',
    'loading_history': 'جاري تحميل السجل...',
    'by': 'بواسطة',
    'warning_handover_no_tenant': 'يتم تسجيل التسليم بدون مستأجر مرتبط.',
    'key_handover_success': 'تم تسجيل تسليم المفاتيح بنجاح',
    'failed_to_record_handover': 'فشل تسجيل تسليم المفاتيح',
    'failed_to_load_history': 'فشل تحميل سجل المفاتيح',
    'key_management': 'إدارة المفاتيح',
    'manage_keys': 'إدارة المفاتيح',
    'total_handovers': 'إجمالي الأحداث',
    'given_out': 'تم التسليم',
    'returned': 'تم الإرجاع',
    'currently_out': 'خارج حالياً',

    // Services
    'services': 'الخدمات',
    'service_payments': 'مدفوعات الخدمات',
    'generate_services': 'إنشاء مدفوعات الخدمات',
    'service_statistics': 'إحصائيات الخدمات',
    'service_type': 'نوع الخدمة',
    'service_amount': 'المبلغ',
    'service_date': 'تاريخ الخدمة',
    'service_status': 'حالة الدفع',
    'service_paid': 'مدفوع',
    'service_unpaid': 'غير مدفوع',

    // Reports - updated
    'revenue_report': 'تقرير الإيرادات',
    'payment_logs': 'سجلات المدفوعات',
    'occupancy_report': 'تقرير الإشغال',
    'monthly_payments_report': 'تقرير المدفوعات الشهرية',
    'monthly_payments_subtitle': 'عرض شامل لمدفوعات إيجار المستأجرين ودفعات الخدمات',
    'all_paid': 'جميعها مدفوعة',
    'try_adjusting_filters': 'جرب تعديل الشهر أو السنة أو الفلاتير',
    'pending': 'معلق',
    'total': 'المجموع',
    'print_receipt': 'طباعة إيصال',
    'monthly_revenue': 'الإيراد الشهري',
    'building_revenue': 'إيرادات المبنى',
    'owner_revenue': 'إيرادات المالك',
    'paid_until': 'مدفوع حتى',
    'tenant_payments': 'حالة مدفوعات المستأجر',
    'next_billing_date': 'تاريخ الفاتورة القادمة',
    'current_tenant': 'المستأجر الحالي',
    'future_tenant_upcoming': 'المستأجر القادم',

    // Logs
    'activity_logs': 'سجلات النشاط',
    'all_user_activities': 'جميع أنشطة المستخدمين',
    'all_user_activities_desc': 'عرض جميع أنشطة المستخدمين والتغييرات',
    'tenant_logs': 'سجل المستأجرين',
    'tenant_activity_desc': 'عرض جميع الأنشطة المتعلقة بالمستأجرين',
    'revenue_by_user': 'الإيرادات حسب المستخدم',
    'monthly_revenue_by_user': 'الإيرادات الشهرية حسب المستخدم',
    'revenue_breakdown_desc': 'عرض تفاصيل الإيرادات حسب المستخدم لشهر معين',
    'time': 'الوقت',
    'entity': 'الكيان',
    'details': 'التفاصيل',
    'amount': 'المبلغ',
    'search_logs': 'البحث في السجلات...',
    'filter_activities': 'تصفية الأنشطة',
    'action_type': 'نوع الإجراء',
    'entity_type': 'نوع الكيان',
    'apply_filter': 'تطبيق التصفية',
    'entries': 'مداخل',
    'no_logs_matching_search': 'لا توجد سجلات تطابق معايير البحث الخاصة بك',
    'no_logs_available': 'لا توجد سجلات نشاط متاحة',
    'showing_range': 'عرض {{start}} إلى {{end}} من أصل {{total}} مدخل',
    'select_month': 'اختر الشهر',
    'payment_count': 'عدد المدفوعات',
    'total_amount': 'إجمالي المبلغ',
    'percentage': 'النسبة المئوية',
    'no_revenue_data': 'لا توجد بيانات إيرادات متاحة لهذا الشهر',
    'january': 'يناير',
    'february': 'فبراير',
    'march': 'مارس',
    'april': 'أبريل',
    'may': 'مايو',
    'june': 'يونيو',
    'july': 'يوليو',
    'august': 'أغسطس',
    'september': 'سبتمبر',
    'october': 'أكتوبر',
    'november': 'نوفمبر',
    'december': 'ديسمبر',
    'notification_log': 'سجل التنبيهات',
    'all_notifications': 'جميع التنبيهات',
    'all_channels': 'جميع القنوات',
    'all_statuses': 'جميع الحالات',
    'all_recipients': 'جميع المستلمين',
    'sent_at': 'تم الإرسال في',
    'template_subject': 'النموذج / الموضوع',
    'email_templates': 'نماذج البريد الإلكتروني',
    'active_templates_count_one': 'نموذج واحد نشط',
    'active_templates_count_other': '{{count}} نماذج نشطة',
    'new_template': 'نموذج جديد',
    'test_email_placeholder': 'عنوان البريد الإلكتروني للاختبار (يستخدم لجميع أزرار اختبار الإرسال)',
    'no_email_templates': 'لا توجد نماذج بريد إلكتروني بعد',
    'create_first_template': 'إنشاء أول نموذج',
    'rent_due': 'استحقاق الإيجار',
    'late_payment': 'دفعة متأخرة',
    'lease_renewal': 'تجديد عقد الإيجار',
    'lease_expiry': 'انتهاء عقد الإيجار',
    'move_in': 'الانتقال للداخل',
    'move_out': 'الانتقال للخارج',
    'violation': 'مخالفة',
    'maintenance': 'صيانة',
    'inspection': 'تفتيش',
    'owner_payout': 'دفع للمالك',
    'email_template_form_desc': 'تصميم رسائل بريد إلكتروني مؤتمتة للمستأجرين والملاك',
    'update_template': 'تحديث النموذج',
    'create_template': 'إنشاء نموذج',
    'visual': 'مرئي',
    'html': 'HTML',
    'live_preview': 'معاينة مباشرة',
    'subject_line': 'سطر الموضوع',
    'email_content': 'محتوى البريد الإلكتروني',
    'event_trigger': 'مشغل الحدث',
    'internal_name': 'الاسم الداخلي',
    'dynamic_tags': 'العلامات الديناميكية',
    'starter_templates': 'نماذج البداية',
    'starter_templates_desc': 'اختر أساساً للبدء بالتصميم بشكل أسرع',
    'apply_design': 'تطبيق التصميم',
    'payment_settings': 'إعدادات الدفع',
    'accept_online_payments': 'قبول المدفوعات عبر الإنترنت',
    'stripe_connect_desc': 'قم بتوصيل حساب Stripe الخاص بك لتمكين المستأجرين من دفع الإيجار مباشرة من خلال البوابة. يتم إيداع الأموال مباشرة في حسابك المصرفي، ويقوم نظامنا بتتبع كل شيء تلقائياً.',
    'why_stripe_connect': 'لماذا تستخدم Stripe Connect؟',
    'stripe_benefit_1': 'تحصيل الإيجار وتتبعه آلياً',
    'stripe_benefit_2': 'إيداعات مباشرة في حسابك المصرفي',
    'stripe_benefit_3': 'معالجة آمنة ومتوافقة مع PCI',
    'stripe_benefit_4': 'دعم تقسيم رسوم المنصة',
    'start_stripe_onboarding': 'بدأ الربط مع Stripe',
    'stripe_account_status': 'حالة حساب Stripe',
    'active_verified': 'نشط وموثق',
    'pending_onboarding': 'مطلوب اتخاذ إجراء: انتظار إكمال البيانات',
    'complete_setup': 'إكمال الإعداد',
    'payments_enabled': 'تم تمكين المدفوعات',
    'payouts_enabled': 'تم تمكين السحب',
    'account_id': 'معرف الحساب',
    'payment_configuration': 'تكوين الدفع',
    'platform_fee_type': 'نوع رسوم المنصة',
    'no_fee_direct': 'بدون رسوم (دفع مباشر)',
    'percentage_soon': 'نسبة مئوية (قريباً)',
    'fixed_soon': 'مبلغ ثابت (قريباً)',
    'platform_fee_disabled': 'رسوم منصة QuadCores معطلة حالياً لمنظمتك.',
    'yes': 'نعم',
    'no': 'لا',
    'general_settings': 'الإعدادات العامة',
    'enable_whatsapp_notifications': 'تفعيل تنبيهات واتساب',
    'whatsapp_enable_desc': 'تشغيل أو إيقاف جميع رسائل واتساب الآلية',
    'default_country_code': 'رمز الدولة الافتراضي',
    'default_message_language': 'لغة الرسائل الافتراضية',
    'rent_reminder': 'تذكير الإيجار',
    'enable_rent_reminders': 'تفعيل تذكيرات الإيجار',
    'rent_reminders_desc': 'إرسال للمستأجرين الذين لديهم دفعات إيجار متأخرة أو قادمة',
    'days_before_due': 'أيام قبل الاستحقاق',
    'service_fee_reminder': 'تذكير رسوم الخدمة',
    'enable_service_fee_reminders': 'تفعيل تذكيرات رسوم الخدمة',
    'service_fee_reminders_desc': 'تنبيه المستأجرين والملاك المقيمين بشأن رسوم الخدمة غير المدفوعة',
    'owner_reminder': 'تذكير المالك',
    'enable_owner_reminders': 'تفعيل تذكيرات الملاك',
    'owner_reminders_desc': 'تنبيه ملاك العقارات عندما يكون لدى مستأجريهم دفعات متأخرة',
    'payment_confirmation': 'تأكيد الدفع',
    'send_payment_confirmation': 'إرسال تأكيد الدفع',
    'payment_confirmation_desc': 'تنبيه المستأجر تلقائياً عبر واتساب عند تسجيل الدفعة',
    'sms_twilio': 'SMS (Twilio)',
    'enable_sms_notifications': 'تفعيل تنبيهات SMS (Twilio)',
    'sms_enable_desc': 'تشغيل أو إيقاف جميع رسائل SMS الآلية',
    'sender': 'المرسل',
    'send_test_sms': 'إرسال رسالة SMS تجريبية',
    'test_sms_desc': 'تحقق من تكامل Twilio الخاص بك عن طريق إرسال رسالة تجريبية إلى أي رقم هاتف.',
    'phone_number': 'رقم الهاتف',
    'send_test': 'إرسال تجربة',
    'preview_reminders': 'معاينة التذكيرات',
    'confirm_send_all': 'تأكيد وإرسال الكل',
    'notification_settings': 'إعدادات التنبيهات',
    'notification_settings_desc': 'تكوين تذكيرات واتساب وSMS للمستأجرين والملاك',
    'preview_send': 'معاينة وإرسال',
    'save_settings': 'حفظ الإعدادات',
    'failed_load_notification_settings': 'فشل تحميل إعدادات التنبيهات',
    'settings_saved': 'تم حفظ الإعدادات',
    'settings_save_failed': 'فشل الحفظ',
    'preview_failed': 'فشلت المعاينة',
    'reminders_sent': 'تم إرسال التذكيرات',
    'no_pending_reminders': 'لا توجد تذكيرات معلقة حالياً.',
    'recipient_pending': 'مستلم(ين) في الانتظار',
    'confirm_replace_content': 'سيؤدي هذا إلى استبدال المحتوى الحالي. هل تريد الاستمرار؟',
    'applied_template': 'تم تطبيق نموذج {{name}}',
    'webhooks': 'Webhooks',
    'webhooks_desc': 'دفع الأحداث إلى أنظمتك عند حدوث أشياء في APS',
    'add_endpoint': 'إضافة نقطة نهاية',
    'failed_load_webhooks': 'فشل تحميل الـ Webhooks',
    'failed_load_deliveries': 'فشل تحميل عمليات التسليم',
    'failed_update': 'فشل التحديث',
    'failed_delete': 'فشل الحذف',
    'deleted': 'تم الحذف',
    'rotate_secret_confirm': 'تدوير السر؟ يجب على العميل الخاص بك تحديث منطق التحقق الخاص به.',
    'secret_rotated': 'تم تدوير السر - احفظه الآن، لن يتم عرضه مرة أخرى',
    'failed_rotate': 'فشل التدوير',
    'copied_to_clipboard': 'تم النسخ إلى الحافظة',
    'no_webhooks_yet': 'لا توجد نقاط نهاية Webhook بعد',
    'no_webhooks_desc': 'أضف واحدة لبدء تلقي الأحداث.',
    'failures': 'إخفاقات',
    'recent_deliveries': 'آخر عمليات التسليم',
    'no_deliveries_yet': 'لا توجد عمليات تسليم بعد.',
    'event': 'حدث',
    'http': 'HTTP',
    'duration': 'المدة',
    'sent_at': 'أرسلت في',
    'delete_webhook_confirm': 'حذف Webhook إلى {{url}}؟',
    'rotate_secret': 'تدوير السر',
    'disable': 'تعطيل',
    'enable': 'تمكين',
    'ok_200': '200 OK',
    'failed': 'فشل',
    'uploading': 'جارٍ الرفع...',
    'save_changes': 'حفظ التغييرات',
    'contact_email': 'البريد الإلكتروني للتواصل',
    'contact_phone': 'هاتف التواصل',
    'office_address': 'عنوان المكتب',
    'organization_logo': 'شعار المنظمة',
    'failed_to_load_system_data': 'فشل تحميل بيانات النظام',
    'logo_upload_success': 'تم رفع الشعار بنجاح',
    'error_uploading_logo': 'خطأ في رفع الشعار',
    'error_updating_system_settings': 'خطأ في تحديث إعدادات النظام',
    'manage_your_subscription_and_billing': 'إدارة اشتراكك وفواتيرك',
    'previous': 'السابق',
    'next': 'التالي',
    'active_properties': 'عقارات نشطة',
    'occupancy_rate_desc': '{{rate}}% معدل الإشغال',
    'vs_last_month': 'مقارنة بالشهر الماضي',
    'overdue_amount': '{{amount}} متأخرات',
    'payment_desc': 'دفع {{type}} - شقة {{number}}',
    'overdue_payments': 'مدفوعات متأخرة',
    'overdue_payments_msg': '{{count}} مستأجرين لديهم مدفوعات معلقة بإجمالي {{amount}}',
    'view_details': 'عرض التفاصيل',
    'lease_expiring_soon': 'عقد الإيجار ينتهي قريباً',
    'lease_expiring_msg': '{{count}} اتفاقيات إيجار تنتهي خلال 30 يوماً',
    'review_leases': 'مراجعة العقود',
    'trial_ending_soon': 'الفترة التجريبية تنتهي قريباً',
    'trial_ending_msg': 'تنتهي فترتك التجريبية خلال {{days}} أيام. يرجى الاشتراك لتجنب انقطاع الخدمة.',
    'upgrade_plan': 'ترقية الخطة',
    'last_7_days': 'آخر 7 أيام',
    'last_30_days': 'آخر 30 يوماً',
    'last_3_months': 'آخر 3 أشهر',
    'last_year': 'العام الماضي',
    'error_loading_dashboard': 'خطأ في تحميل لوحة القيادة',
    'reports_dashboard': 'لوحة تقارير الأداء',
    'overview_of_financial_performance': 'نظرة عامة على الأداء المالي وإحصائيات العقارات',
    'view_all_reports': 'عرض جميع التقارير',
    'total_revenue': 'إجمالي الإيرادات',
    'total_payments_count': '{{count}} دفعة',
    'total_tenants': 'إجمالي المستأجرين',
    'new_tenants_this_year': '{{count}} مستأجر جديد هذا العام',
    'total_buildings_count': '{{count}} مبنى',
    'total_owners': 'الملاك المقيمون ',
    'urgent_action': 'إجراء عاجل',
    'ended_contracts_count': '{{count}} عقد منتهي',
    'monthly_revenue_year': 'الإيرادات الشهرية - {{year}}',
    'occupancy_rate': 'معدل الإشغال',
    'quick_reports': 'تقارير سريعة',
    'annual_revenue': 'الإيرادات السنوية',
    'yearly_breakdown': 'تفصيل سنوي لجميع الإيرادات',
    'building_revenue': 'إيرادات المباني',
    'revenue_by_building': 'تفصيل الإيرادات حسب المبنى',
    'owner_revenue': 'إيرادات الملاك',
    'revenue_by_owner': 'تفصيل الإيرادات حسب مالك العقار',
    'detailed_payment_history': 'سجل مدفوعات مفصل وسجلات',
    'occupied': 'مشغول',
    'vacant': 'شاغر',
    'maintenance': 'صيانة',
    'excellent': 'ممتاز',
    'good': 'جيد',
    'needs_improvement': 'بحاجة لتحسين',
    'rent': 'إيجار',
    'service': 'خدمة',
    'deposit': 'تأمين',
    'commission': 'عمولة',
    'insurance': 'تأمين',
    'total': 'الإجمالي',
    'no_recent_payments': 'لا توجد مدفوعات حديثة',
    'no_overdue_payments': 'لا توجد مدفوعات متأخرة',
    'overdue': 'متأخر',
    'partial': 'جزئي',
    'expired': 'منتهي',
    'legend_upcoming': 'قادم',
    'pending': 'قيد الانتظار',
    'paid': 'مدفوع',
    'apt': 'شقة',
    'days_overdue': 'أيام تأخير',
    'more_overdue_tenants': 'مستأجرين آخرين متأخرين',
    'error_fetching_occupancy': 'خطأ في جلب بيانات الإشغال',
    'failed_load_occupancy': 'فشل في تحميل إحصائيات الإشغال',
    'error_fetching_payments': 'خطأ في جلب المدفوعات الحديثة',
    'failed_load_payments': 'فشل في تحميل المدفوعات الحديثة',
    'error_fetching_tenant_status': 'خطأ في جلب حالة دفع المستأجر',
    'failed_load_tenant_status': 'فشل في تحميل حالة دفع المستأجر',
    'failed_to_load_report_data': 'فشل في تحميل بيانات التقرير',
    'mgmt_fee_collected': 'رسوم الإدارة المحصّلة (السنة الحالية)',
    'mgmt_fee_outstanding': 'رسوم الإدارة المتبقية',
    'active_tenant_arrears': 'متأخرات المستأجرين النشطين',
    'all_accounts_settled': 'جميع الحسابات مسوّاة',
    'recent_transactions': 'المعاملات الحديثة',
    'alerts_notifications': 'التنبيهات والإشعارات',
    'create_hold': 'إنشاء حجز',
    'billing_subscription': 'الفواتير والاشتراك',
    'current_plan': 'الخطة الحالية',
    'subscribe_now': 'اشترك الآن',
    'manage_your_subscription_and_billing': 'إدارة اشتراكك وفواتيرك',
    'view_payment_logs': 'عرض سجلات المدفوعات',
    'view_activity_logs': 'عرض سجلات النشاط',
    'view_revenue_report': 'عرض تقرير الإيرادات',
    'view_occupancy_report': 'عرض تقرير الإشغال',
    'view_tenant_logs': 'عرض سجلات المستأجرين',
    'login_success': 'تم تسجيل الدخول بنجاح',
    'logout_success': 'تم تسجيل الخروج بنجاح',
    'record_payment': 'تسجيل دفعة',
    'occupied_status': 'مشغول',
    'owner_payments': 'مدفوعات المالك',
    'all_months': 'جميع الشهور',


    "floor_number": "الطابق {{number}}",
    "apartment_number": "غرفة {{number}}",


    // Common
    'loading': 'جاري التحميل...',
    'save': 'حفظ',
    'cancel': 'إلغاء',
    'edit': 'تعديل',
    'delete': 'حذف',
    'add': 'إضافة',
    'view': 'عرض',
    'search': 'بحث',
    'filter': 'تصفية',
    'actions': 'الإجراءات',
    'status': 'الحالة',
    'refresh': 'تحديث',
    'active': 'نشط',
    'inactive': 'غير نشط',
    'yes': 'نعم',
    'no': 'لا',
    'confirm': 'تأكيد',
    'success': 'نجح',
    'error': 'خطأ',
    'warning': 'تحذير',
    'info': 'معلومات',

    // App
    'apartment_system': 'نظام الشقق',
    'apartment_management': 'إدارة الشقق',

    // Authentication
    'login': 'تسجيل الدخول',
    'logout': 'تسجيل الخروج',
    'username': 'اسم المستخدم',
    'password': 'كلمة المرور',
    'email': 'البريد الإلكتروني',
    'remember_me': 'تذكرني',
    'forgot_password': 'نسيت كلمة المرور؟',
    'forgot_password_instructions': 'أدخل اسم المستخدم أو البريد الإلكتروني لتلقي رمز التحقق',
    'send_code': 'إرسال رمز التحقق',
    'reset_password': 'إعادة تعيين كلمة المرور',
    'password_reset_success': 'تمت إعادة تعيين كلمة المرور بنجاح',
    'password_min_length': 'يجب أن تتكون كلمة المرور من 8 أحرف على الأقل',
    'login_failed': 'فشل تسجيل الدخول',
    'invalid_credentials': 'بيانات غير صحيحة',
    'security_verification': 'التحقق الأمني',
    'verification_code_sent': 'تم إرسال رمز التحقق إلى جهازك المسجل.',
    'enter_valid_otp': 'الرجاء إدخال رمز التحقق الصحيح',
    'verification_failed': 'فشل التحقق',
    'code_resent_success': 'تم إعادة إرسال رمز التحقق بنجاح.',
    'too_many_attempts': 'عدد كبير من المحاولات. يرجى المحاولة مرة أخرى لاحقاً.',
    'check_device_for_code': 'تحقق من جهازك للحصول على الرمز',
    'verifying': 'جاري التحقق...',

    // Navigation
    'dashboard': 'لوحة القيادة',
    'core': 'الأساسي',
    'user_management': 'إدارة المستخدمين',
    'property_management': 'إدارة العقارات',
    'maintenance_operations': 'الصيانة والعمليات',
    'financial_management': 'الإدارة المالية',
    'financial_payments': 'المدفوعات',
    'financial_accounting': 'المحاسبة',
    'financial_portfolio': 'المحفظة والمؤشرات',
    'portfolio_kpis': 'المحفظة والمؤشرات',
    'reports_analytics': 'التقارير والتحليلات',
    'logs_audit': 'السجلات والتدقيق',
    'all_activities': 'جميع الأنشطة',
    'tenant_activities': 'أنشطة المستأجرين',
    'system': 'النظام',
    'bookings': 'الحجوزات',
    'booking_list': 'قائمة الحجوزات',
    'new_booking': 'حجز جديد',
    'booking_calendar': 'تقويم الحجوزات',
    'waitlist': 'قائمة الانتظار',
    'analytics': 'التحليلات',
    'subscription': 'الاشتراك',
    'whatsapp': 'واتساب',
    'manage_services': 'إدارة الخدمات',
    'generate_payments': 'إنشاء المدفوعات',
    'reports_dashboard': 'لوحة التقارير',

    // Users
    'system_users': 'مستخدمي النظام',
    'user_list': 'قائمة المستخدمين',
    'add_user': 'إضافة مستخدم',
    'edit_user': 'تعديل المستخدم',
    'user_profile': 'ملف المستخدم',
    'first_name': 'الاسم الأول',
    'last_name': 'اسم العائلة',
    'phone_number': 'رقم الهاتف',
    'role': 'الدور',
    'administrator': 'المدير',
    'front_desk': 'الاستقبال',
    'created_at': 'تاريخ الإنشاء',
    'last_login': 'آخر تسجيل دخول',
    'never': 'أبداً',

    // Properties
    'properties': 'العقارات',
    'property_list': 'قائمة العقارات',
    'add_property': 'إضافة عقار',
    'property_owners': 'ملاك العقارات',
    'owner_list': 'قائمة الملاك',
    'add_owner': 'إضافة مالك',
    'owners': 'الملاك',

    // Tenants
    'tenants': 'المستأجرين',
    'tenant_list': 'قائمة المستأجرين',
    'add_tenant': 'إضافة مستأجر',
    'owner_living': 'سكن المالك',
    'future_tenant': 'مستأجر مستقبلي',
    'overdue_rent': 'الإيجارات المتأخرة',

    // Payments
    'payments': 'المدفوعات',
    'all_payments': 'جميع المدفوعات',
    'record_payment': 'تسجيل دفعة',
    'overdue_payments': 'المدفوعات المتأخرة',
    'receipts': 'الإيصالات',

    // Reports
    'reports': 'التقارير',
    'all_reports': 'جميع التقارير',
    'financial_reports': 'التقارير المالية',
    'payment_reports': 'تقارير المدفوعات',
    'property_reports': 'تقارير العقارات',
    'reports_1099_desc': 'تقرير IRS 1099-MISC لتوزيعات العقارات على الملاك',
    'vendor_1099_nec': 'مورد 1099-NEC',
    'vendor_1099_desc': 'التقرير السنوي لمصلحة الضرائب - الموردون الذين تقاضوا ≥ 600 دولار كتعويض غير موظفين',
    'rent_roll_desc': 'لقطة لجميع الوحدات وحالة الإشغال والإيجار وتفاصيل عقود الإيجار',
    'ar_aging_desc': 'مبالغ المستأجرين المستحقة مقسمة حسب العمر (0، 1-30، 31-60، 61-90، 90+)',
    'total_vendors': 'إجمالي الموردين',
    'require_1099': 'مطلوب 1099',
    'total_reportable': 'إجمالي المبالغ القابلة للتقرير',
    '1099_required': '1099 مطلوب',
    'below_threshold': 'تحت الحد الأدنى',
    'occupancy_rate': 'معدل الإشغال',
    'scheduled_rent': 'الإيجار المقرر',
    'aging_breakdown': 'تفاصيل التعمير',

    // Report Templates
    'report_templates': 'قوالب التقارير',
    'report_templates_subtitle': 'إنشاء وإدارة تكوينات التقارير القابلة لإعادة الاستخدام',
    'create_template': 'قالب جديد',
    'create_first_template': 'إنشاء أول قالب',
    'template_name': 'اسم القالب',
    'template_description': 'الوصف',
    'template_config': 'الإعدادات (JSON)',
    'no_templates': 'لا توجد قوالب تقارير',
    'no_templates_message': 'احفظ تكوينات التقارير التي تستخدمها كثيراً كقوالب قابلة لإعادة الاستخدام.',
    'template_created': 'تم إنشاء القالب بنجاح',
    'template_updated': 'تم تحديث القالب بنجاح',
    'template_deleted': 'تم حذف القالب',
    'delete_template_title': 'حذف القالب',
    'delete_template_message': 'هل أنت متأكد من حذف "{{name}}"؟ لا يمكن التراجع عن هذا الإجراء.',

    // Settings
    'settings': 'الإعدادات',
    'profile_settings': 'إعدادات الملف الشخصي',
    'system_settings': 'إعدادات النظام',
    'profile': 'الملف الشخصي',
    'personal_details': 'التفاصيل الشخصية',
    'security_settings': 'إعدادات الأمان',
    'change_password': 'تغيير كلمة المرور',
    'current_password': 'كلمة المرور الحالية',
    'new_password': 'كلمة المرور الجديدة',
    'confirm_new_password': 'تأكيد كلمة المرور الجديدة',
    'organization_settings': 'إعدادات المؤسسة',
    'organization_name': 'اسم المؤسسة',
    'timezone': 'المنطقة الزمنية',
    'subscription_plan': 'خطة الاشتراك',
    'standard_plan': 'الخطة القياسية',
    'enterprise_plan': 'خطة المؤسسات',
    'trial_period': 'فترة تجريبية',
    'days_left': 'متبقي {{days}} يوم',
    'subscription_required': 'الاشتراك مطلوب',
    'subscription_expired_message': 'الوصول إلى مساحة العمل الخاصة بك مقفل حالياً. يرجى تجديد اشتراكك لمتابعة إدارة عقاراتك.',
    'premium_experience_notice': 'مساحة عمل متميزة مطلوبة',
    'feature_locked_message': 'هذه الميزة غير متوفرة في خطتك الحالية. يرجى الترقية للوصول.',
    'renew_subscription': 'تجديد الاشتراك',
    'update_profile_success': 'تم تحديث الملف الشخصي بنجاح',
    'update_password_success': 'تم تغيير كلمة المرور بنجاح',
    'update_system_success': 'تم تحديث إعدادات النظام بنجاح',

    // Notifications
    'notifications': 'الإشعارات',
    'view_all_notifications': 'عرض جميع الإشعارات',

    // WhatsApp Settings
    'whatsapp_settings': 'إعدادات الواتساب',
    'whatsapp_settings_description': 'إشعارات الواتساب المؤتمتة للمستأجرين والمالكين',
    'send_reminders_now': 'إرسال التذكيرات الآن',
    'general_settings': 'الإعدادات العامة',
    'whatsapp_enable': 'تفعيل إشعارات الواتساب',
    'whatsapp_enable_sub': 'تشغيل أو إيقاف جميع رسائل الواتساب المؤتمتة',
    'default_country_code': 'رمز الدولة الافتراضي',
    'default_messaging_language': 'لغة الرسائل الافتراضية',
    'default_language_help': 'تستخدم إذا لم يكن لدى المستأجر لغة مفضلة محددة.',
    'tenant_rent_reminder': 'تذكير إيجار المستأجر',
    'enable_tenant_rent_reminders': 'تفعيل التذكيرات',
    'tenant_rent_reminder_sub': 'إرسال تذكير للمستأجرين قبل أو بعد تاريخ استحقاق الدفع',
    'days_before_due': 'الأيام قبل الاستحقاق',
    'service_fee_reminder': 'تذكير رسوم الخدمة',
    'enable_service_fee_reminder': 'تفعيل تذكير رسوم الخدمة',
    'service_fee_reminder_sub': 'إخطار المستأجرين بمدفوعات رسوم الخدمة القادمة',
    'owner_reminder': 'تذكير المالك',
    'enable_owner_reminders': 'تفعيل تذكيرات المالك',
    'owner_reminder_sub': 'إخطار المالكين عندما يكون لدى مستأجريهم مدفوعات متأخرة',
    'payment_confirmation': 'تأكيد الدفع',
    'send_on_payment': 'إرسال عند الدفع',
    'payment_confirmation_sub': 'يتم إرسالها تلقائياً للمستأجر عند تسجيل الدفعة',
    'preview_reminders': 'معاينة التذكيرات المؤتمتة',
    'notification_log_desc': 'سجل تدقيق لجميع التنبيهات الصادرة',
    'total_sent': 'إجمالي المرسل',
    'failed_bounced': 'فشل / ارتد',
    'email_templates_desc': 'تصميم رسائل بريد إلكتروني مؤتمتة لمستأجريك وملاكك',
    'test_email_address': 'عنوان البريد الإلكتروني للاختبار',
    'payment_settings': 'إعدادات الدفع',
    'accept_online_payments': 'قبول المدفوعات عبر الإنترنت',
    'connect_stripe_desc': 'اربط حساب Stripe الخاص بك لتمكين المستأجرين من دفع الإيجار مباشرة عبر البوابة.',
    'start_stripe_onboarding': 'بدء تهيئة Stripe',
    'active_verified': 'نشط ومحقق',
    'action_required_onboarding': 'إجراء مطلوب: التهيئة قيد الانتظار',
    'webhooks_desc': 'إرسال الأحداث إلى أنظمتك عند حدوث أشياء في APS',
    'recent_deliveries': 'التسليمات الأخيرة',
    'failed_to_load_settings': 'فشل تحميل الإعدادات',
    'settings_saved': 'تم حفظ الإعدادات بنجاح',
    'failed_to_save': 'فشل الحفظ',
    'server_error': 'خطأ في الخادم',

    // Forms
    'personal_information': 'المعلومات الشخصية',
    'account_information': 'معلومات الحساب',
    'security': 'الأمان',
    'enter_first_name': 'أدخل الاسم الأول',
    'enter_last_name': 'أدخل اسم العائلة',
    'enter_email': 'أدخل البريد الإلكتروني',
    'enter_username': 'أدخل اسم المستخدم',
    'enter_password': 'أدخل كلمة المرور',
    'enter_phone_number': 'أدخل رقم الهاتف',
    'confirm_password': 'تأكيد كلمة المرور',
    'leave_blank_to_keep_current': 'اتركه فارغاً للاحتفاظ بكلمة المرور الحالية',

    // Validation
    'first_name_required': 'الاسم الأول مطلوب',
    'last_name_required': 'اسم العائلة مطلوب',
    'email_required': 'البريد الإلكتروني مطلوب',
    'invalid_email': 'يرجى إدخال بريد إلكتروني صحيح',
    'username_required': 'اسم المستخدم مطلوب',
    'username_too_short': 'اسم المستخدم يجب أن يكون 3 أحرف على الأقل',
    'password_required': 'كلمة المرور مطلوبة',
    'password_too_short': 'كلمة المرور يجب أن تكون 6 أحرف على الأقل',
    'passwords_do_not_match': 'كلمات المرور غير متطابقة',
    'phone_invalid_format': 'يرجى إدخال رقم هاتف صحيح',

    // Actions
    'saving': 'جاري الحفظ...',
    'deleting': 'جاري الحذف...',
    'loading_users': 'جاري تحميل المستخدمين...',
    'loading_user_data': 'جاري تحميل بيانات المستخدم...',
    'update': 'تحديث',
    'activate': 'تفعيل',
    'deactivate': 'إلغاء تفعيل',
    'show_all': 'عرض الكل',
    'hide_inactive': 'إخفاء غير النشط',
    'all_roles': 'جميع الأدوار',
    'retry': 'إعادة المحاولة',

    // Messages
    'no_users_found': 'لا يوجد مستخدمين',
    'user_created_successfully': 'تم إنشاء المستخدم بنجاح',
    'user_updated_successfully': 'تم تحديث المستخدم بنجاح',
    'user_deleted_successfully': 'تم حذف المستخدم بنجاح',
    'confirm_deletion': 'تأكيد الحذف',
    'delete_user_confirmation': 'هل أنت متأكد من حذف {{name}}؟ لا يمكن التراجع عن هذا الإجراء.',

    // Dashboard
    'welcome_back': 'مرحباً بعودتك',
    'dashboard_subtitle': 'إليك ما يحدث مع عقاراتك اليوم.',
    'total_properties': 'إجمالي العقارات',
    'active_tenants': 'المستأجرين النشطين',
    'monthly_revenue': 'الإيرادات الشهرية',
    'pending_payments': 'المدفوعات المعلقة',
    'recent_activity': 'النشاط الأخير',
    'quick_actions': 'الإجراءات السريعة',
    'showing': 'عرض',
    'of': 'من',
    'users': 'مستخدمين',
    'contact': 'جهة الاتصال',
    'user': 'المستخدم',

    // Sidebar specific translations
    'core': 'الأساسي',
    "accounting": "المحاسبة",
    'user_management': 'إدارة المستخدمين',
    'property_management': 'إدارة العقارات',
    'maintenance_operations': 'الصيانة والعمليات',
    'financial_management': 'الإدارة المالية',
    'financial_payments': 'المدفوعات',
    'financial_accounting': 'المحاسبة',
    'financial_portfolio': 'المحفظة والمؤشرات',
    'reports_analytics': 'التقارير والتحليلات',
    'logs_audit': 'السجلات والتدقيق',
    'system': 'النظام',

    'system_users': 'مستخدمي النظام',
    'user_list': 'قائمة المستخدمين',
    'add_user': 'إضافة مستخدم',

    'buildings': 'المباني',
    'building_list': 'قائمة المباني',
    'add_building': 'إضافة مبنى',

    'apartments': 'الشقق',
    'apartment_list': 'قائمة الشقق',
    'add_apartment': 'إضافة شقة',

    'owners': 'الملاك',
    'owner_list': 'قائمة الملاك',
    'add_owner': 'إضافة مالك',

    'tenants': 'المستأجرين',
    'tenant_list': 'قائمة المستأجرين',
    'add_tenant': 'إضافة مستأجر',
    'overdue_rent': 'إيجار متأخر',

    'payments': 'المدفوعات',
    'all_payments': 'جميع المدفوعات',
    'record_payment': 'تسجيل دفعة',
    'payment_stats': 'إحصائيات الدفع',

    'service_payments': 'مدفوعات الخدمات',
    'manage_services': 'إدارة الخدمات',
    'generate_payments': 'إنشاء مدفوعات',
    'service_statistics': 'إحصائيات الخدمات',
    'finance': 'المالية',
    'transactions': 'المعاملات',
    'service_charges': 'رسوم الخدمة',
    'owner_installments': 'أقساط المالك',
    'messages': 'الرسائل',
    'announcements_manager': 'مدير الإعلانات',
    'all_announcements': 'جميع الإعلانات',
    'sales': 'المبيعات',
    'sales_management': 'إدارة المبيعات',
    'inspections': 'الفحوصات',
    'all_inspections': 'جميع الفحوصات',
    'renewal_risk': 'مخاطر التجديد',
    'lease_renewals': 'تجديد العقود',
    'lease_applications': 'طلبات الإيجار',
    'application_links': 'روابط التقديم',
    'leases': 'عقود الإيجار',
    'violations': 'المخالفات',
    'notices': 'الإشعارات',
    'screening': 'الفحص',
    'documents': 'المستندات',
    'amenities_parking': 'المرافق والمواقف',

    // AI Intelligence & Sidebar
    'ai_intelligence': 'الذكاء الاصطناعي',
    'rent_pricing_ai': 'تسعير الإيجار بالذكاء الاصطناعي',
    'churn_prediction': 'توقعات مغادرة المستأجرين',
    'showings': 'معاينات العقارات',
    'tenant_surveys': 'استبيانات المستأجرين',
    'insurance': 'التأمين',
    'vendor_1099': 'مورد 1099',
    'rent_roll': 'سجل الإيجارات',
    'ar_aging': 'تقادم الحسابات المدينة',
    'webhooks': 'Webhooks',

    // AI Rent Pricing Page
    'ai_rent_pricing': 'تسعير الإيجار بالذكاء الاصطناعي',
    'ai_rent_pricing_desc': 'احصل على اقتراحات إيجار السوق المدعومة بالذكاء الاصطناعي بناءً على مقارنات محفظتك والإشغال واتجاهات التجديد',
    'select_unit_to_analyze': 'اختر وحدة لتحليلها',
    'choose_an_apartment': 'اختر شقة...',
    'analyze': 'تحليل',
    'analyzing': 'جاري التحليل...',
    'ai_recommended_rent': 'الإيجار الموصى به من قبل الذكاء الاصطناعي',
    'range': 'النطاق',
    'high_confidence': 'عالية',
    'medium_confidence': 'متوسطة',
    'low_confidence': 'منخفضة',
    'confidence_suffix': 'ثقة',
    'comparable_units_found': 'الوحدات المماثلة (تم العثور على {{count}})',
    'avg_comparable_rent': 'المتوسط: {{amount}}/شهرياً',
    'vs_suggestion': 'مقابل الاقتراح',
    'select_unit_analyze_desc': 'اختر وحدة وانقر على تحليل',
    'claude_analyze_desc': 'سيقوم الذكاء الاصطناعي بتحليل المقارنات والإشغال واتجاهات التجديد لاقتراح الإيجار الأمثل',

    // Churn Prediction Page
    'churn_prediction_desc': 'احتمالية التجديد بالذكاء الاصطناعي لجميع المستأجرين النشطين',
    'run_ai_scoring': 'تشغيل تقييم الذكاء الاصطناعي',
    'running': 'جاري التشغيل...',
    'high_churn_risk': 'مخاطر مغادرة عالية',
    'medium_risk': 'مخاطر متوسطة',
    'likely_to_renew': 'من المرجح أن يجدد',
    'no_churn_scores': 'لا توجد تقييمات مغادرة بعد',
    'run_scoring_desc': 'انقر على "تشغيل تقييم الذكاء الاصطناعي" لتحليل جميع المستأجرين النشطين',
    'run_scoring_now': 'شغل التقييم الآن',
    'renewal_score': 'درجة التجديد',
    'risk_level': 'مستوى المخاطر',
    'lease_ends': 'ينتهي العقد',
    'key_factors': 'العوامل الرئيسية',
    'send_offer': 'إرسال عرض',
    'late_payments_6m': '{{count}} دفعات متأخرة',
    'current_balance_factor': 'رصيد بقيمة ${{amount}}',
    'prior_renewals_factor': '{{count}} تجديدات سابقة',

    // Showings Page
    'showings_desc': 'جدولة وتتبع معاينات العقارات للمستأجرين المحتملين',
    'schedule_showing': 'جدولة معاينة',
    'upcoming': 'قادمة',
    'today': 'اليوم',
    'no_shows': 'عدم حضور',
    'all': 'الكل',
    'no_showings_found': 'لم يتم العثور على معاينات',
    'schedule_first_showing': 'جدولة أول معاينة',
    'prospect': 'مستأجر محتمل',
    'unit': 'وحدة',
    'date_and_time': 'التاريخ والوقت',
    'scheduled': 'مجدولة',
    'completed': 'مكتملة',
    'cancelled': 'ملغاة',
    'no_show': 'عدم حضور',
    'edit_showing': 'تعديل المعاينة',
    'prospect_name': 'اسم المستأجر المحتمل',
    'prospect_phone': 'الهاتف',
    'prospect_email': 'البريد الإلكتروني',
    'start_time': 'وقت البدء',
    'end_time': 'وقت الانتهاء',
    'assigned_to': 'مكلف بـ',
    'notes': 'ملاحظات',

    // Insurance Page
    'insurance_tracking': 'تتبع التأمين',
    'insurance_desc': 'إدارة وثائق تأمين المستأجر والمالك والمبنى',
    'add_policy': 'إضافة وثيقة',
    'expiring_30d': 'ينتهي خلال 30 يوم',
    'total_coverage': 'إجمالي التغطية',
    'all_status': 'جميع الحالات',
    'all_types': 'جميع الأنواع',
    'no_policies_found': 'لم يتم العثور على وثائق',
    'add_first_policy': 'إضافة أول وثيقة',
    'entity': 'الكيان',
    'insurer': 'المؤمن',
    'policy_type': 'نوع الوثيقة',
    'coverage': 'التغطية',
    'expiry': 'تاريخ الانتهاء',
    'expired_days_ago': 'انتهت منذ {{days}} يوم',
    'days_left': 'متبقى {{days}} يوم',
    'edit_policy': 'تعديل الوثيقة',
    'entity_type': 'نوع الكيان',
    'policy_number': 'رقم الوثيقة',
    'coverage_amount': 'مبلغ التغطية',
    'annual_premium': 'القسط السنوي',
    'start_date': 'تاريخ البدء',
    'expiry_date': 'تاريخ الانتهاء',
    'document_url': 'رابط المستند (COI)',

    // Survey Results Page
    'tenant_surveys_desc': 'تقييمات رضا العملاء وملاحظات المستأجرين',
    'overall_rating': 'التقييم العام',
    'distribution': 'التوزيع',
    'by_category': 'حسب الفئة',
    'no_surveys_yet': 'لا توجد استبيانات بعد',
    'tenants_submit_feedback_desc': 'يمكن للمستأجرين تقديم ملاحظاتهم من خلال البوابة الخاصة بهم',

    // Messages
    'messages_title': 'الرسائل',
    'tenants_tab': 'المستأجرين',
    'owners_tab': 'الملاك',
    'no_conversations': 'لا توجد محادثات بعد',
    'select_conversation_hint': 'اختر محادثة من اليسار لبدء المراسلة',
    'type_message_placeholder': 'اكتب رسالة...',
    'your_inbox': 'صندوق الوارد',
    'you_label': 'أنت: ',
    'mark_as_read': 'تحديد كمقروء',
    'failed_to_load_messages': 'فشل تحميل الرسائل',
    'failed_to_load_chat_history': 'فشل تحميل سجل الدردشة',
    'failed_to_send_message': 'فشل إرسال الرسالة',

    // Expenses
    'expenses_title': 'المصاريف',
    'expenses_subtitle': 'تتبع المصاريف التشغيلية مع آلية الموافقة',
    'new_expense': 'مصروف جديد',
    'new_expense_subtitle': 'تسجيل مصروف تشغيلي',
    'total_expenses': 'إجمالي المصاريف',
    'approved_amount': 'تمت الموافقة',
    'how_it_works': 'كيف يعمل',
    'expense_hint1': 'سجل أي تكلفة مدفوعة للمبنى: إصلاحات، تنظيف، رسوم إدارة، إلخ.',
    'expense_hint2': 'المصاريف المحددة كـ "قيد الانتظار" تحتاج للموافقة قبل أن تؤثر على صافي دخل التشغيل',
    'expense_hint3': '"تحميل على المالك" يرحل المصروف مباشرة إلى سجل المالك',
    'expense_hint4': 'صافي دخل التشغيل = الإيجار المحصل - المصاريف المعتمدة',
    'search_expenses': 'البحث بالوصف، المورد، الفئة...',
    'expense_records': 'سجلات المصاريف',
    'no_expenses_found': 'لم يتم العثور على مصاريف',

    // Storage / Inventory
    'storage_title': 'المخزون',
    'storage_subtitle': 'تتبّع العناصر في المخزون وصرفها إلى الشقق — تُرحَّل تلقائيًا إلى المصاريف',
    'add_stock': 'إضافة مخزون',
    'stock_value': 'قيمة المخزون',
    'items_in_storage': 'العناصر في المخزون',
    'total_issued': 'إجمالي المصروف',
    'stock_on_hand': 'المخزون المتوفر',
    'issuance_history': 'سجل الصرف',
    'quantity_on_hand': 'المتوفر',
    'issue_to_apartment': 'صرف إلى شقة',
    'issue': 'صرف',
    'storage_hint1': 'سجّل العناصر في المخزون أولًا: أبواب، نوافذ، تجهيزات، إلخ — لا حاجة لتحديد شقة بعد',
    'storage_hint2': '"صرف إلى شقة" ينقل المخزون إلى وحدة ويُرحّل التكلفة تلقائيًا',
    'storage_hint3': 'تكلفة الصرف تُرحَّل كمصروف بانتظار الموافقة',
    'storage_hint4': 'ملخص الصرف حسب الشقة يعرض إجمالي التكلفة لكل وحدة، بناءً على ما تم صرفه فعليًا',
    'search_materials': 'البحث بالعنصر، الشقة، المورد...',
    'no_materials_found': 'لا يوجد شيء هنا بعد',
    'spend_by_apartment': 'الصرف حسب الشقة',
    'apartment_label': 'الشقة',
    'item_name': 'العنصر',
    'item_name_placeholder': 'مثال: باب داخلي، نافذة مزدوجة الزجاج',
    'items_logged': 'العناصر',
    'quantity': 'الكمية',
    'quantity_required': 'الكمية مطلوبة',
    'quantity_exceeds_stock': 'يتوفر {{available}} فقط في المخزون',
    'available_short': 'متوفر {{qty}}',
    'unit_cost': 'تكلفة الوحدة',
    'total_cost': 'التكلفة الإجمالية',
    'select_apartment': 'اختر الشقة',
    'stock_added': 'تمت إضافة المخزون',
    'material_issued': 'تم الصرف إلى الشقة وترحيله إلى المصاريف',
    'failed_to_load_materials': 'فشل تحميل بيانات المخزون',
    'failed_to_load_apartments': 'فشل تحميل الشقق — تحقق من اتصالك وحاول مرة أخرى',

    'approve': 'موافقة',
    'void': 'إلغاء',
    'confirm_void': 'إلغاء هذا المصروف؟ لا يمكن التراجع عن هذه الخطوة.',
    'expense_description_placeholder': 'مثال: خدمة مكافحة الحشرات الشهرية',
    'select_category': '— اختر الفئة —',
    'charge_to_owner': 'تحميل على المالك (سيتم ترحيله لسجل المالك)',
    'create_expense': 'إنشاء مصروف',
    'expense_created': 'تم إنشاء المصروف',
    'expense_approved': 'تمت الموافقة على المصروف',
    'expense_voided': 'تم إلغاء المصروف',
    'invoice_number': 'رقم الفاتورة',
    'all_statuses': 'جميع الحالات',
    'failed_to_load_expenses': 'فشل تحميل المصاريف',
    'expense_rejected': 'تم رفض المصروف',
    'confirm_reject': 'رفض هذا المصروف؟ لا يمكن التراجع عن هذا.',
    'date_from': 'من تاريخ',
    'date_to': 'إلى تاريخ',
    'failed_to_load': 'فشل تحميل البيانات',
    'assign_failed': 'فشل التعيين',
    'unavailable': 'غير متاح',
    'filtered_by': 'تصفية حسب:',
    'calendar': 'تقويم',
    'notes_placeholder': 'ملاحظات إضافية…',
    'no_amenities_match_filter': 'لا توجد مرافق تطابق الفلتر المحدد.',
    'all_amenities': 'جميع المرافق',
    'no_bookings_on_day': 'لا توجد حجوزات في هذا اليوم.',
    'parking_assigned': 'تم تعيين موقف السيارة',
    'parking_unassigned': 'تم إلغاء تعيين موقف السيارة',
    'parking_space_deleted': 'تم حذف موقف السيارة',
    'parking_space_created': 'تم إنشاء موقف السيارة',
    'parking_space_updated': 'تم تحديث موقف السيارة',
    'parking_spaces_generated': 'تم إنشاء مواقف السيارات بالجملة',
    'booking_deleted': 'تم حذف الحجز',
    'parking_layout_hint': 'قم بتعيين الصفوف عبر تعديل المساحة لتنظيم تخطيط مواقف السيارات',
    'delete_amenity_title': 'حذف المرفق',
    'confirm_delete_amenity': 'هل أنت متأكد من حذف هذا المرفق؟ لا يمكن التراجع عن هذا.',
    'delete_parking_space_title': 'حذف موقف السيارة',
    'confirm_delete_parking': 'هل أنت متأكد من حذف موقف السيارة هذا؟ لا يمكن التراجع عن هذا.',
    'delete_booking_title': 'حذف الحجز',
    'confirm_delete_booking': 'هل أنت متأكد من حذف هذا الحجز؟ لا يمكن التراجع عن هذا.',
    'unassign_parking_title': 'إلغاء تعيين موقف السيارة',
    'confirm_unassign_parking': 'هل أنت متأكد من إلغاء تعيين موقف السيارة هذا؟',
    'start_end_required': 'أرقام البداية والنهاية مطلوبة',
    'space_number_required': 'رقم المساحة مطلوب',
    'row_zone': 'الصف / المنطقة',
    'row_zone_hint': 'لتنظيم مخطط الخريطة',
    'status_pending_approval': 'قيد الانتظار',
    'status_approved': 'تمت الموافقة',
    'status_voided': 'ملغى',
    'status_rejected': 'مرفوض',
    'owner_label': 'المالك',
    'select_building': '— اختر المبنى —',
    'payment_method': 'طريقة الدفع',
    'method_bank_transfer': 'تحويل بنكي',
    'method_cash': 'نقداً',
    'method_check': 'شيك',
    'method_credit_card': 'بطاقة ائتمان',
    'method_stripe': 'Stripe',
    'method_wire': 'تحويل برقي',
    'method_other': 'أخرى',
    'items_plural': 'عناصر',
    'item_singular': 'عنصر',
    'all_buildings': 'جميع المباني',

    // Late Fees
    'late_fee_mgmt': 'إدارة رسوم التأخير',
    'pending_charges': 'الرسوم المعلقة',
    'history_tab': 'السجل',
    'fee_settings': 'إعدادات الرسوم',
    'late_fees_disabled_hint': 'رسوم التأخير معطلة - قم بتفعيلها في الإعدادات',
    'tenants_due_fee': 'المستأجرين المستحق عليهم رسوم تأخير',
    'next_cron_run': 'تشغيل الجدولة القادم في الساعة 10:00 صباحاً بتوقيت المؤسسة',
    'apply_now': 'تطبيق الآن',
    'applying': 'جاري التطبيق...',
    'waive': 'إعفاء',
    'waive_late_fee': 'إعفاء من رسوم التأخير',
    'waive_reason_label': 'السبب',
    'waive_reason_placeholder': 'مثال: تم الاتفاق على ترتيبات الدفع، إعفاء للمرة الأولى، إلخ.',
    'confirm_waiver': 'تأكيد الإعفاء',
    'waiving': 'جاري الإعفاء...',
    'failed_to_load_pending': 'فشل تحميل الرسوم المعلقة',
    'failed_to_load_history': 'فشل تحميل السجل',
    'fee_waived': 'تم الإعفاء من الرسوم',
    'failed_to_waive': 'فشل الإعفاء',
    'late_fee_assessed': 'تم تقدير رسوم التأخير',
    'failed_to_assess': 'فشل التقدير',
    'days_overdue': 'أيام التأخير',
    'projected_fee': 'الرسوم المتوقعة',
    'last_fee': 'آخر رسوم',
    'waive_amount_label': 'مبلغ الإعفاء ($)',
    'not_found': 'غير موجود',
    'never': 'أبداً',
    'balance': 'الرصيد',
    'source': 'المصدر',
    'auto_label': 'تلقائي',
    'manual_label': 'يدوي',
    'late_fees_disabled': 'رسوم التأخير معطلة',
    'of_rent': 'من الإيجار',
    'day_grace': 'فترة سماح باليوم',
    'no_pending_late_fees': 'لا يوجد مستأجرون قيد انتظار رسوم تأخير حالياً.',
    'enable_late_fees_hint': 'قم بتفعيل رسوم التأخير في الإعدادات لبدء التتبع.',
    'no_late_fee_records': 'لم يتم العثور على سجلات لرسوم التأخير.',
    'all_late_fee_charges': 'جميع رسوم التأخير المسجلة',
    'failed_to_load_owner_balances': 'فشل تحميل أرصدة الملاك',
    'select_at_least_one_owner': 'يرجى اختيار مالك واحد على الأقل',
    'confirm_bulk_payout': 'دفع لـ {{count}} مالك(ين) بمبلغ إجمالي {{amount}}؟',
    'bulk_payout_success': 'تم الدفع لـ {{count}} مالك(ين) — الإجمالي {{amount}}',
    'bulk_payout_failed': 'فشلت عملية الدفع الجماعي',
    'bulk_owner_payout': 'دفع تعويضات الملاك بالجملة',
    'bulk_payout_subtitle': 'دفع لجميع الملاك الذين لديهم أرصدة مستحقة في دفعة واحدة',
    'total_owed_all': 'إجمالي المستحق (جميع الملاك)',
    'owners_with_balance': 'الملاك الذين لديهم رصيد',
    'selected_to_pay': 'المختار للدفع',
    'balance_owed': 'الرصيد المستحق',
    'last_payout': 'آخر دفعة',
    'payout_settings': 'إعدادات الدفع',
    'period_month': 'شهر الفترة',
    'payout_notes_placeholder': 'مثال: التوزيع الشهري',
    'pay_owners_btn': 'دفع لـ {{count}} مالك(ين) · {{amount}}',
    'last_batch_results': 'نتائج الدفعة الأخيرة',
    'wire_transfer': 'تحويل برقي',
    'status_held': 'محتجز',
    'status_returned': 'مسترد',
    'status_not_collected': 'غير محصل',
    'error_loading_deposits': 'فشل تحميل التأمينات',
    'deposit_collected': 'تم تحصيل مبلغ التأمين',
    'deposit_returned': 'تم رد مبلغ التأمين',
    'security_deposits_subtitle': 'تتبع مبالغ التأمين المتوافقة مع اللوائح — منفصلة قانوناً عن الإيجار',
    'total_held': 'إجمالي المحتجز',
    'active_deposits': 'التأمينات النشطة',
    'deposits_returned': 'التأمينات المستردة',
    'all_tenants_deposit_status': 'جميع المستأجرين — حالة التأمين',
    'paid_on': 'تاريخ الدفع',
    'collect': 'تحصيل',
    'return': 'رد',
    'collect_security_deposit': 'تحصيل مبلغ تأمين',
    'return_security_deposit': 'رد مبلغ تأمين',
    'damages_unpaid_rent': 'الأضرار، الإيجار غير المدفوع، إلخ.',
    'optional_notes': 'ملاحظات اختيارية...',
    'record_collection': 'تسجيل التحصيل',
    'record_return': 'تسجيل الرد',
    'deposit_amount_placeholder': 'مثال: 1500.00',
    'error_loading_utility_data': 'فشل تحميل بيانات المرافق',
    'utility_account_created': 'تم إنشاء حساب المرافق بنجاح',
    'reading_recorded_generate_bills': 'تم تسجيل القراءة — قم بإنشاء الفواتير أدناه',
    'rubs_complete_msg': 'اكتملت عملية RUBS — تم إصدار فواتير لـ {{count}} مستأجرين بقيمة {{amount_each}} لكل منهم (إجمالي {{total}})',
    'no_pending_bills_to_charge': 'لا توجد فواتير معلقة للتحصيل',
    'confirm_charge_all_bills': 'هل تريد ترحيل {{count}} فواتير معلقة إلى سجلات المستأجرين؟',
    'confirm_charge_all_bills_title': 'تحميل جميع الفواتير المعلقة',
    'charge_all_success_msg': 'تم ترحيل {{count}} فواتير!{{failed_msg}}',
    'generate_bills_btn': 'توليد الفواتير',
    'generate_from_meters': 'توليد من العدادات',
    'charge_all_btn': 'تحصيل الكل ({{count}})',
    'bills_generated_msg': 'تم توليد {{count}} فاتورة مرافق',
    'rubs_failed': 'فشل حساب RUBS',
    'failed_to_update_account': 'فشل تحديث الحساب',
    'utility_management': 'إدارة المرافق',
    'utility_subtitle': 'تتبع العدادات والقراءات وإصدار فواتير الاستهلاك للمستأجرين',
    'add_account': 'إضافة حساب',
    'utility_accounts': 'حسابات المرافق',
    'no_utility_accounts': 'لا توجد حسابات مرافق — أضف حساباً للبدء',
    'provider': 'المزود',
    'account_number_label': 'رقم الحساب',
    'meter_number_label': 'رقم العداد',
    'utility_bills': 'فواتير المرافق',
    'no_bills_found_msg': 'لم يتم العثور على فواتير — استخدم "إنشاء الفواتير" لإصدارها',
    'period': 'الفترة',
    'usage': 'الاستهلاك',
    'charge_tenant': 'تحميل المستأجر',
    'add_utility_account': 'إضافة حساب مرافق',
    'add_utility_account_subtitle': 'تسجيل عداد جديد أو خدمة مرافق',
    'utility_type': 'نوع المرفق',
    'provider_name': 'اسم المزود',
    'provider_placeholder': 'مثلاً: شركة الكهرباء الوطنية',
    'shared_meter': 'عداد مشترك (يغطي المبنى بالكامل)',
    'add_meter_reading': 'إضافة قراءة عداد',
    'reading_value': 'القراءة الحالية',
    'reading_date': 'تاريخ القراءة',
    'record_reading': 'تسجيل القراءة',
    'error_loading_kpi_data': 'فشل تحميل بيانات مؤشرات الأداء',
    'snapshot_complete': 'اكتملت اللقطة بنجاح',
    'snapshot_failed': 'فشلت عملية أخذ اللقطة',
    'kpi_dashboard': 'لوحة مؤشرات الأداء (KPI)',
    'kpi_subtitle': 'أداء المحفظة المباشر — الإشغال، صافي الدخل التشغيلي، معدل العائد، معدل التحصيل',
    'capturing': 'جاري الالتقاط...',
    'snapshot_now': 'لقطة الآن',
    'occupancy_rate': 'معدل الإشغال',
    'annual_gross_rent': 'إجمالي الإيجار السنوي',
    'portfolio_value': 'قيمة المحفظة',
    'total_units': 'إجمالي الوحدات',
    'units_occupied_msg': '{{occupied}} من {{total}} وحدات مشغولة',
    'per_month_suffix': '{{amount}} / شهر',
    'equity_label_val': '{{amount}} حقوق الملكية',
    'vacant_units_count': '{{count}} شاغرة',
    'kpi_step1': 'انقر على "لقطة الآن" لحساب مقاييس اليوم لجميع المباني',
    'kpi_step2': 'يتم تشغيل اللقطة تلقائياً كل ليلة',
    'kpi_step3': 'قم بتسجيل تقييمات العقارات في صفحة المحفظة لتفعيل معدل العائد والإنتاجية',
    'per_building_metrics': 'مقاييس كل مبنى',
    'no_snapshots_yet': 'لا توجد لقطات بعد — انقر على "لقطة الآن" للإنشاء',
    'collection_rate': 'التحصيل',
    'monthly_noi': 'الدخل التشغيلي الشهري',
    'cap_rate': 'معدل العائد (Cap Rate)',
    'gross_yield': 'العائد الإجمالي',
    'overdue_tenants': 'متأخرات',
    'investment_summary': 'ملخص الاستثمار',
    'current_value': 'القيمة الحالية',
    'purchase_cost': 'تكلفة الشراء',
    'equity': 'حقوق الملكية',
    'error_loading_portfolio_data': 'فشل تحميل بيانات المحفظة الاستثمارية',
    'valuation_recorded': 'تم تسجيل التقييم بنجاح',
    'investment_portfolio': 'المحفظة الاستثمارية',
    'investment': 'الاستثمار',
    'portfolio_subtitle': 'تقييم المحفظة، حقوق الملكية، معدل العائد، والإنتاجية لكل مبنى',
    'record_valuation': 'تسجيل تقييم',
    'total_portfolio_value': 'قيمة المحفظة',
    'annualized_amount': '{{amount}} سنوياً',
    'avg_cap_rate': 'متوسط معدل العائد',
    'annualized': 'سنوي',
    'avg_gross_yield': 'متوسط العائد الإجمالي',
    'gross_rent_on_value': 'إجمالي الإيجار / القيمة',
    'portfolio_step1': 'انقر على "تسجيل تقييم" لإدخال القيمة السوقية الحالية للمبنى',
    'portfolio_step2': 'معدل العائد = صافي الدخل التشغيلي السنوي ÷ قيمة العقار × 100',
    'portfolio_step3': 'العائد الإجمالي = إجمالي الإيجار السنوي ÷ قيمة العقار × 100',
    'portfolio_step4': 'تأتي بيانات صافي الدخل من لوحة مؤشرات الأداء — قم بأخذ لقطة أولاً',
    'per_building_breakdown': 'تفاصيل كل مبنى',
    'no_portfolio_data': 'لا توجد بيانات محفظة — قم بتشغيل لقطة مؤشرات الأداء أولاً، ثم سجل التقييمات',
    'last_valuation': 'آخر تقييم',
    'occupied_short': 'مشغول',
    'no_valuation': 'لا يوجد تقييم',
    'update_value': 'تحديث القيمة',
    'record_valuation_subtitle': 'تسجيل القيمة السوقية الحالية للمبنى',
    'appraised_value': 'القيمة التقديرية',
    'valuation_date': 'تاريخ التقييم',
    'method': 'الطريقة',
    'record': 'تسجيل',
    'error_loading_accounts': 'فشل تحميل الحسابات',
    'error_loading_journal_entries': 'فشل تحميل قيود اليومية',
    'error_loading_trial_balance': 'فشل تحميل ميزان المراجعة',
    'error_loading_pnl': 'فشل تحميل بيان الأرباح والخسائر',
    'gl_account_required_fields': 'الكود، الاسم، والنوع مطلوبة',
    'account_created': 'تم إنشاء الحساب',
    'journal_min_lines_error': 'يجب توفر سطرين على الأقل',
    'entry_out_of_balance_error': 'القيد غير متوازن: المدين {{debits}} ≠ الدائن {{credits}}',
    'journal_account_required_error': 'يجب اختيار حساب لجميع الأسطر',
    'journal_entry_posted': 'تم ترحيل قيد اليومية',
    'reason_for_reversal_prompt': 'سبب العكس:',
    'entry_reversed': 'تم عكس القيد',
    'reversal_failed': 'فشل عكس القيد',
    'chart_of_accounts': 'دليل الحسابات',
    'journal_entries': 'قيود اليومية',
    'trial_balance': 'ميزان المراجعة',
    'pnl_statement': 'بيان الأرباح والخسائر',
    'general_ledger': 'دفتر الأستاذ العام',
    'gl_subtitle': 'دليل الحسابات، قيود اليومية، ميزان المراجعة والأرباح والخسائر',
    'new_gl_account': 'حساب أستاذ جديد',
    'normal_balance': 'الرصيد الطبيعي',
    'no_accounts_found': 'لم يتم العثور على حسابات',
    'all_sources': 'جميع المصادر',
    'new_entry': 'قيد جديد',
    'new_journal_entry': 'قيد يومية جديد',
    'select_account': 'اختر حساب...',
    'line_description_placeholder': 'وصف السطر',
    'balanced_msg': '✓ متوازن',
    'out_of_balance_amount': 'غير متوازن بمقدار {{amount}}',
    'add_line': '+ إضافة سطر',
    'post_entry': 'ترحيل القيد',
    'posting': 'جاري الترحيل...',
    'no_journal_entries_found': 'لم يتم العثور على قيود يومية',
    'reversed': 'معكوس',
    'posted': 'مرحل',
    'draft': 'مسودة',
    'lines_count': '{{count}} أسطر',
    'as_of_date': 'اعتباراً من تاريخ',
    'balanced': 'متوازن',
    'out_of_balance': 'غير متوازن',
    'net': 'الصافي',
    'total_revenue': 'إجمالي الإيرادات',
    'total_expenses': 'إجمالي المصاريف',
    'net_income': 'صافي الدخل',
    'no_revenue_entries': 'لا توجد قيود إيرادات',
    'no_expense_entries': 'لا توجد قيود مصاريف',
    'select_date_range_run_msg': 'اختر نطاقاً زمنياً واضغط تشغيل',
    'asset': 'أصل',
    'liability': 'خصم (التزام)',
    'revenue': 'إيراد',
    'expense': 'مصروف',
    'market': 'سوقي',
    'income': 'دخل',
    'cost': 'تكلفة',
    'broker_opinion': 'رأي الوسيط',
    'appraisal': 'تثمين',
    'waive_confirm_hint': 'إعفاء من رسوم تأخير لـ {{name}}. هذا سيؤدي لإضافة قيّد دائن في السجل — الرسم الأصلي سيظل محفوظاً للتدقيق.',
    'enter_reason_error': 'يرجى إدخال السبب',
    'enter_valid_amount_error': 'يرجى إدخال مبلغ صحيح',
    'confirm_manual_assess': 'تقدير رسوم تأخير يدوياً لـ {{name}}؟',
    'search_late_fees': 'البحث بالمستأجر، الوحدة، المبنى...',
    'page_info': 'صفحة {{current}} من {{total}}',

    'reports': 'التقارير',
    'reports_dashboard': 'لوحة التقارير',
    'revenue_report': 'تقرير الإيرادات',
    'payment_logs': 'سجلات الدفع',
    'occupancy_report': 'تقرير الإشغال',
    'tenant_payments': 'مدفوعات المستأجرين',
    'building_revenue': 'إيرادات المبنى',
    'owner_revenue': 'إيرادات المالك',

    'activity_logs': 'سجلات النشاط',
    'all_activities': 'كل الأنشطة',
    'tenant_activities': 'أنشطة المستأجرين',
    'monthly_revenue': 'الإيراد الشهري',

    'settings': 'الإعدادات',
    'profile_settings': 'إعدادات الملف الشخصي',
    'system_settings': 'إعدادات النظام',

    'logout': 'تسجيل الخروج',
    'sales': 'المبيعات',
    'inspections': 'عمليات التفتيش',
    'maintenance_hub': 'مركز الصيانة',
    'vendors': 'الموردين',
    'finance': 'المالية',
    'transactions': 'المعاملات',
    'service_charges': 'رسوم الخدمات',
    'owner_installments': 'أقساط المالك',
    'financial_matrix': 'المصفوفة المالية',
    'cash_flow_forecast': 'توقعات 7 أيام',
    'receivables': 'الذمم المدينة',
    'receivables_sub': 'الأموال المستحقة لك، حسب مدة التأخر.',
    'receivables_short': 'الذمم',
    'no_receivables': 'لا أحد مدين بأي مبلغ.',
    'books_need_attention': 'الدفاتر تحتاج إلى مراجعة',
    'books_tie_out': 'الذمم المدينة مطابقة لدفتر الأستاذ العام',
    'ar_gl_drift': 'الذمم المدينة غير مطابقة لدفتر الأستاذ العام',
    'unmirrored_charges': 'رسوم',
    'unmirrored_payments': 'مدفوعات',
    'not_in_receivables': 'لم تُدرج بعد في الذمم المدينة',
    'closed_periods': 'فترة/فترات مغلقة',
    'fix_now': 'إصلاح الآن',
    'fixing': 'جارٍ الإصلاح…',
    'accounting_statement': 'كشف الحساب ←',
    'statement': 'كشف حساب',
    'open_full_record': 'فتح السجل الكامل ←',
    'credit_on_account': 'رصيد دائن في الحساب',
    'opening_balance': 'الرصيد الافتتاحي',
    'closing_balance': 'الرصيد الختامي',
    'no_activity': 'لا يوجد نشاط في هذه الفترة.',
    'charge': 'رسوم',
    'kind_rent': 'إيجار',
    'kind_service': 'رسوم خدمة',
    'kind_late_fee': 'رسوم تأخير',
    'kind_utility': 'مرافق',
    'kind_parking': 'موقف سيارات',
    'kind_deposit': 'تأمين',
    'kind_sale_installment': 'قسط بيع',
    'kind_management_fee': 'رسوم إدارة',
    'kind_maintenance_fee': 'رسوم صيانة',
    'kind_payment': 'دفعة',
    'ledger_activity_report': 'نشاط السجل',
    'management_fee_report': 'رسوم الإدارة',
    'messages': 'الرسائل',
    'announcements_manager': 'مدير الإعلانات',
    'all_announcements': 'جميع الإعلانات',
    'subscription': 'الاشتراك',
    'contract_templates': 'نماذج العقود',
    'whatsapp_and_sms': 'واتساب ورسائل نصية',
    'late_fees_org_config': 'رسوم التأخير وتكوين المؤسسة',
    'building_amenities': 'مرافق المبنى',
    'parking_spaces': 'مواقف السيارات',
    'amenity_bookings': 'حجوزات المرافق',
    'pm_schedules': 'جداول PM',
    'work_orders': 'أوامر العمل',
    'security_deposits': 'تأمين الودائع',
    'expenses': 'المصاريف',
    'late_fees': 'رسوم التأخير',
    'bulk_owner_payout': 'مدفوعات المالك بالجملة',
    'utilities': 'المرافق',
    'kpi_dashboard': 'لوحة KPI',
    'portfolio': 'المحفظة',
    'general_ledger': 'دفتر الأستاذ العام',
    'reports_1099': 'تقارير 1099',
    'notification_log': 'سجل الإشعارات',
    'all_messages': 'جميع الرسائل',

    // Financial Matrix
    'financial_matrix_subtitle': 'عرض موحد لجميع الأنشطة المالية عبر كل وحدة',
    'total_charged': 'إجمالي الرسوم',
    'total_collected': 'إجمالي المحصل',
    'overdue_balance': 'الرصيد المتأخر',
    'partial_balance': 'الرصيد الجزئي',
    'all_floors': 'جميع الطوابق',
    'floor_label': 'طابق',
    'legend_paid': 'مدفوع',
    'legend_partial': 'جزئي',
    'legend_overdue': 'متأخر',
    'legend_no_charges': 'لا توجد رسوم',
    'table_unit': 'وحدة',
    'table_now': 'الآن',
    'no_apartments_found_building': 'لم يتم العثور على شقق لهذا المبنى.',
    'view_all': 'الكل',
    'view_rent': 'إيجار',
    'view_service': 'خدمة',
    'view_sales': 'مبيعات',

    // Cash Flow Forecast
    'cash_flow_subtitle': 'المدفوعات المتوقعة القادمة عبر المستأجرين والملاك',
    'expected_this_period': 'المتوقع لهذه الفترة',
    'total_overdue_balance': 'إجمالي الرصيد المتأخر',
    'collected_today': 'المحصل اليوم',
    'no_upcoming_payments': 'لا توجد مدفوعات قادمة في هذه الفترة.',
    'today': 'اليوم',
    'overdue_label': 'متأخر',
    'expected_label': 'متوقع',

    // Quick Pay
    'quick_pay': 'دفع سريع',
    'recording': 'جاري التسجيل...',
    'record_payment_btn': 'تسجيل دفع {{amount}}',
    'no_active_tenant_error': 'لا يوجد مستأجر نشط - لا يمكن تسجيل الدفع هنا.',
    'view_full_ledger': 'عرض الدفتر الكامل لـ {{name}}',
    'full_payment_form': 'نموذج الدفع الكامل',
    'enter_valid_amount': 'أدخل مبلغاً صالحاً',
    'no_active_tenant_found': 'لم يتم العثور على مستأجر نشط لهذه الوحدة',
    'payment_recorded_success': 'تم تسجيل الدفعة بنجاح',
    'treasury_quick_pay': 'الخزينة - دفع سريع',
    'payment_amount': 'مبلغ الدفع',
    'memo': 'مذكرة / مرجع',
    'add_a_note_about_this_treasury_event': 'أضف ملاحظة حول هذه الحركة...',
    'confirm_and_record': 'تأكيد وتسجيل',
    'view_owner_file_and_distribution': 'عرض ملف المالك والتوزيعات',
    'view_resident_ledger': 'عرض سجل المستأجر',
    'processing': 'جاري المعالجة...',
    'no_entity_found': 'لم يتم العثور على مستأجر أو مالك لهذه الوحدة',
    'owner_view': 'مالك',
    'tenant_view': 'مستأجر',
    'search_owner_unit_building': 'البحث عن مالك أو وحدة أو مبنى...',
    'showing_all_installments': 'عرض جميع {{count}} قسط',
    'showing_overdue_within_days': 'عرض المتأخرات + المستحقة خلال {{days}} يوماً · {{hidden}} قسط مستقبلي مخفي',
    'hide_future_count': 'إخفاء المستقبلية ({{count}})',
    'show_all_future_count': 'عرض جميع المستقبلية ({{count}})',
    'no_overdue_upcoming_all_clear': 'لا توجد مدفوعات متأخرة أو قادمة — كل شيء نظيف!',
    'no_records_match_search': 'لا توجد سجلات تطابق بحثك.',

    // Months Short
    'jan_short': 'يناير', 'feb_short': 'فبراير', 'mar_short': 'مارس', 'apr_short': 'أبريل', 'may_short': 'مايو', 'jun_short': 'يونيو',
    'jul_short': 'يوليو', 'aug_short': 'أغسطس', 'sep_short': 'سبتمبر', 'oct_short': 'أكتوبر', 'nov_short': 'نوفمبر', 'dec_short': 'ديسمبر',

    // Months Full
    'january': 'يناير', 'february': 'فبراير', 'march': 'مارس', 'april': 'أبريل', 'may': 'مايو', 'june': 'يونيو',
    'july': 'يوليو', 'august': 'أغسطس', 'september': 'سبتمبر', 'october': 'أكتوبر', 'november': 'نوفمبر', 'december': 'ديسمبر',

    // AI Assistant
    'ai_assistant': 'مساعد الذكاء الاصطناعي',
    'ask_ai': 'اسأل الذكاء الاصطناعي',
    'ai_greeting': "مرحباً! أنا محللك المالي بالذكاء الاصطناعي. كيف يمكنني مساعدتك اليوم؟",
    'ai_error': "عذراً، لم أتمكن من معالجة ذلك. يرجى المحاولة مرة أخرى.",
    'analyzing_data': 'تحليل البيانات...',
    'ai_placeholder': 'ماذا تود أن تعرف؟',
    'overdue_tenants_q': 'من هم المستأجرون المتأخرون؟',
    'revenue_30d_q': 'إيرادات آخر 30 يوماً؟',
    'expenses_month_q': 'المصاريف هذا الشهر؟',
    'utility_pending_q': 'فواتير الخدمات المعلقة؟',
    'kpi_noi_summary_q': 'ملخص KPI و NOI؟',
    'security_deposits_q': 'تأمين الودائع المحتفظ بها؟',
    'late_fees_q': 'رسوم التأخير المفروضة؟',
    'owner_payouts_q': 'مدفوعات المالك هذا الشهر؟',

    // Apartment Detail View
    'loading_apartment_details': 'جاري تحميل تفاصيل الشقة...',
    'error_loading_apartment': 'خطأ في تحميل تفاصيل الشقة',
    'try_again': 'حاول مرة أخرى',
    'back_to_apartments': 'العودة إلى الشقق',
    'apartment_not_found': 'الشقة غير موجودة',
    'apartment_not_found_message': 'الشقة التي تبحث عنها غير موجودة أو تم حذفها.',

    'building_and_location': 'المبنى والموقع',
    'building': 'المبنى',
    'floor': 'الطابق',
    'address': 'العنوان',

    'apartment_details': 'تفاصيل الشقة',
    'apartment_type': 'النوع',
    'size': 'المساحة',
    'furnished': 'مؤثثة',

    'owner_information': 'معلومات المالك',
    'owner_name': 'الاسم',
    'owner_contact': 'الاتصال',

    'additional_information': 'معلومات إضافية',
    'created_at': 'تاريخ الإنشاء',
    'updated_at': 'آخر تحديث',

    'status_management': 'إدارة الحالة',
    'status_vacant': 'شاغرة',
    'status_occupied': 'مشغولة',
    'status_maintenance': 'تحت الصيانة',
    'status_vacant_description': 'متاحة للإيجار أو التأجير',
    'status_occupied_description': 'مؤجرة حالياً لمستأجر',
    'status_maintenance_description': 'تحت الصيانة أو التجديد',
    'status_sold_description': 'تم بيع هذه الوحدة',
    'change_status': 'تغيير الحالة إلى',

    'quick_actions': 'إجراءات سريعة',
    'create_lease': 'إنشاء عقد إيجار',
    'view_tenant_info': 'عرض معلومات المستأجر',
    'mark_maintenance_complete': 'تعليم الصيانة كمكتملة',
    'view_building': 'عرض المبنى',
    'edit_apartment': 'تعديل الشقة',

    'same_building_apartments': 'نفس المبنى',
    'view_all_apartments_in_building': 'عرض جميع الشقق في المبنى',
    'view_vacant_apartments': 'عرض الشقق الشاغرة',

    // Delete confirmation
    'delete_apartment_confirmation': 'هل أنت متأكد من حذف الشقة "{{name}}"؟ لا يمكن التراجع عن هذا الإجراء.',


    // Apartment Form
    'loading_apartment_data': 'جاري تحميل بيانات الشقة...',
    'edit_apartment': 'تعديل الشقة',
    'add_new_apartment': 'إضافة شقة جديدة',

    'basic_information': 'المعلومات الأساسية',
    'apartment_number': 'رقم الشقة',
    'enter_apartment_number': 'أدخل رقم الشقة',
    'floor_number': 'رقم الطابق',
    'enter_floor_number': 'أدخل رقم الطابق',
    'size_sqm': 'المساحة (م²)',
    'enter_size': 'أدخل المساحة بالمتر المربع',
    'apartment_type': 'نوع الشقة',
    'select_apartment_type': 'اختر نوع الشقة',
    'select_building': 'اختر المبنى',
    'furnished': 'مؤثثة',

    // Validation messages
    'floor_required': 'رقم الطابق مطلوب',
    'apartment_number_required': 'رقم الشقة مطلوب',
    'size_required': 'المساحة مطلوبة',
    'type_required': 'نوع الشقة مطلوب',
    'building_required': 'المبنى مطلوب',
    'invalid_size': 'يجب أن تكون المساحة أكبر من الصفر',

    // Form actions
    'update': 'تحديث',
    'save': 'حفظ',
    'saving': 'جاري الحفظ...',


    // Apartment List
    'apartments': 'الشقق',
    'search_apartments': 'ابحث عن شقق...',
    'filter': 'تصفية',
    'grid_view': 'شبكة',
    'list_view': 'قائمة',
    'add_apartment': 'إضافة شقة',
    'all_buildings': 'جميع المباني',
    'all_types': 'جميع الأنواع',
    'all_statuses': 'جميع الحالات',
    'all': 'الكل',
    'vacant_apartments': 'شقق شاغرة',
    'occupied_apartments': 'شقق مشغولة',
    'maintenance_apartments': 'تحت الصيانة',
    'loading_apartments': 'جاري تحميل الشقق...',
    'error_loading_apartments': 'خطأ في تحميل الشقق',
    'no_apartments_found': 'لا توجد شقق',
    'no_apartments_message': 'لا توجد شقق في النظام حتى الآن.',
    'create_first_apartment': 'إنشاء أول شقة',
    'showing_filtered_results': 'عرض {{showing}} من أصل {{total}} شقة',

    // Statuses
    'vacant': 'شاغرة',
    'occupied': 'مشغولة',
    'maintenance': 'تحت الصيانة',

    // Apartment card
    'furnished': 'مؤثثة',

    // Delete confirmation
    'delete_apartment_confirmation': 'هل أنت متأكد من حذف الشقة "{{name}}"؟ لا يمكن التراجع عن هذا الإجراء.',
    'deleting': 'جاري الحذف...',


    // Bulk Apartment Creator
    'bulk_apartment_creation': 'إنشاء شقق بالجملة',
    'preview': 'معاينة',
    'apartment_number_format': 'تنسيق رقم الشقة',
    'format_pattern': 'نمط التنسيق',
    'format_pattern_help': 'استخدم {floor} لرقم الطابق و {unit} لرقم الوحدة. مثال: {floor}{unit} = 0201',
    'preview_example': 'مثال المعاينة',
    'floor_plans': 'خطط الطوابق',
    'add_floor_plan': 'إضافة خطة طابق',
    'floor_plan_number': 'خطة الطابق {number}',
    'floors_comma_separated': 'الطوابق (مفصولة بفواصل)',
    'unit_types': 'أنواع الوحدات',
    'add_unit_type': 'إضافة نوع وحدة',
    'unit_type_number': 'نوع الوحدة {number}',
    'name': 'الاسم',
    'quantity': 'الكمية',
    'type': 'النوع',
    'area_sqm': 'المساحة (م²)',
    'furnished': 'مؤثثة',
    'apartment_preview_count': 'معاينة الشقق ({count} وحدة)',
    'floor_unit_type': 'طابق {floor} • {type}',
    'close': 'إغلاق',
    'create_apartments': 'إنشاء شقق',
    'create_apartments_count': 'إنشاء {count} شقة',
    'creating_apartments': 'جاري إنشاء الشقق...',
    'add_at_least_one_floor_plan': 'الرجاء إضافة خطة طابق واحدة على الأقل',
    'no_apartments_to_create': 'لا توجد شقق لإنشائها',


    'building_name_required': 'اسم المبنى مطلوب',
    'building_address_required': 'عنوان المبنى مطلوب',
    'invalid_floors': 'يجب أن يكون عدد الطوابق 1 على الأقل',
    'invalid_apartments': 'يجب أن يكون عدد الشقق 0 على الأقل',
    'loading_building_data': 'جاري تحميل بيانات المبنى...',
    'edit_building': 'تعديل المبنى',
    'add_new_building': 'إضافة مبنى جديد',
    'basic_information': 'المعلومات الأساسية',
    'building_name': 'اسم المبنى',
    'enter_building_name': 'أدخل اسم المبنى',
    'total_floors': 'إجمالي الطوابق',
    'number_of_floors': 'عدد الطوابق',
    'total_apartments': 'إجمالي الشقق',
    'number_of_apartments': 'عدد الشقق',
    'address': 'العنوان',
    'enter_complete_building_address': 'أدخل عنوان المبنى الكامل',
    'cancel': 'إلغاء',
    'saving': 'جاري الحفظ...',
    'update': 'تحديث',
    'save': 'حفظ',


    'buildings': 'المباني',
    'switch_building': 'تبديل المبنى',
    'search_buildings': 'ابحث عن المباني...',
    'bulk_add_apartments': 'إضافة شقق بالجملة',
    'add_building': 'إضافة مبنى',
    'loading_buildings': 'جاري تحميل المباني...',
    'error_loading_buildings': 'خطأ في تحميل المباني',
    'try_again': 'حاول مرة أخرى',
    'no_buildings_found': 'لم يتم العثور على مباني',
    'no_buildings_yet': 'لا توجد مباني بعد',
    'no_buildings_match_search': 'لا توجد مباني تطابق "{{search}}"',
    'no_buildings_message': 'لا توجد مباني في النظام حتى الآن. أضف مبنى أول لتبدأ.',
    'create_first_building': 'إنشاء أول مبنى',
    'showing_filtered_results': 'عرض {{showing}} من أصل {{total}} مبنى',
    'floors': 'طوابق',
    'apartments': 'شقق',
    'occupancy': 'الإشغال',
    'vacant': 'شاغرة',
    'occupied': 'مشغولة',
    'no_apartments_yet': 'لا توجد شقق بعد',
    'add_apartments': '+ إضافة شقق',
    'confirm_deletion': 'تأكيد الحذف',
    'delete_building_confirmation': 'هل أنت متأكد أنك تريد حذف المبنى "{{name}}"؟ لا يمكن التراجع عن هذا الإجراء.',
    'cancel': 'إلغاء',
    'deleting': 'جاري الحذف...',
    'delete': 'حذف',
    'create_building_first': 'الرجاء إنشاء مبنى أولاً',
    'create': 'إنشاء شقق',
    'unnamed_building': 'مبنى بدون اسم',
    'no_address_provided': 'لا يوجد عنوان',

    'select_building_for_bulk_creation': 'اختر المبنى لإضافة شقق بالجملة',

    'loading_building_details': 'جاري تحميل تفاصيل المبنى...',
    'error_loading_building': 'خطأ في تحميل المبنى',
    'try_again': 'حاول مرة أخرى',
    'back_to_buildings': 'العودة إلى المباني',
    'building_not_found': 'المبنى غير موجود',
    'building_not_found_message': 'المبنى الذي تبحث عنه غير موجود أو تم إزالته.',
    'add_apartment': 'إضافة شقة',
    'edit_building': 'تعديل المبنى',
    'generate_reports': 'إنشاء تقارير',
    'total_apartments': 'إجمالي الشقق',
    'units': 'وحدة',
    'across_floors': 'عبر {{floors}} طوابق',
    'vacant_apartments': 'شاغرة',
    'available_for_rent': 'متاحة للإيجار',
    'no_vacancies': 'لا توجد شقق شاغرة',
    'occupancy_rate': 'معدل الإشغال',
    'occupied_units': 'وحدات مشغولة',
    'maintenance_apartments': 'صيانة',
    'needs_attention': 'تحتاج إلى اهتمام',
    'average_apartment_size': 'متوسط المساحة',
    'furnished_apartments': 'مفروشة',
    'utility_status': 'حالة المرافق',
    'water': 'ماء',
    'electricity': 'كهرباء',
    'internet': 'إنترنت',
    'hide_details': 'إخفاء التفاصيل',
    'show_details': 'عرض التفاصيل',
    'search_apartments': 'ابحث عن شقق، ملاك، مستأجرين...',
    'all_statuses': 'جميع الحالات',
    'vacant': 'شاغرة',
    'occupied': 'مشغولة',
    'maintenance': 'صيانة',
    'top_floor_first': 'الطابق العلوي أولاً',
    'ground_floor_first': 'الطابق الأرضي أولاً',
    'showing_results': 'عرض {{count}} من {{total}} شقة',
    'matching': 'تطابق',
    'with_status': 'بحالة',
    'no_apartments_found': 'لم يتم العثور على شقق',
    'no_apartments_match_filters': 'لا توجد شقق تطابق عوامل التصفية الحالية.',
    'clear_filters': 'مسح الفلاتر',
    'floor_number': 'الطابق {{number}}',
    'apartments': 'شقق',
    'owner': 'المالك',
    'status': 'الحالة',
    'vacant_status': 'متاحة',
    'maintenance_status': 'تحت الصيانة',
    'furnished': 'مفروشة',
    'unfurnished': 'غير مفروشة',
    'no_matching_apartments_on_floor': 'لا توجد شقق في الطابق {{floor}} تطابق عوامل التصفية الحالية.',
    'construction_year': 'سنة البناء: {{year}}',

    'activity_logs': 'سجل النشاطات',
    'track_all_system_activities': 'تتبع جميع نشاطات النظام والتغييرات',
    'filter': 'تصفية',
    'export_to_excel': 'تصدير إلى إكسل',
    'exporting': 'جاري التصدير...',
    'filter_logs': 'تصفية السجلات',
    'action_type': 'نوع الإجراء',
    'all_actions': 'جميع الإجراءات',
    'entity_type': 'نوع الكيان',
    'all_entities': 'جميع الكيانات',
    'entries_per_page': 'عدد المدخلات لكل صفحة',
    'start_date': 'تاريخ البدء',
    'end_date': 'تاريخ الانتهاء',
    'reset': 'إعادة تعيين',
    'apply_filter': 'تطبيق التصفية',
    'previous': 'السابق',
    'next': 'التالي',
    'tenant_activity_logs': 'سجل نشاطات المستأجرين',
    'payment_activity_logs': 'سجل نشاطات الدفعات',
    'building_activity_logs': 'سجل نشاطات المباني',
    'apartment_activity_logs': 'سجل نشاطات الشقق',
    'owner_activity_logs': 'سجل نشاطات الملاك',
    'user_activity_logs': 'سجل نشاطات المستخدمين',
    'system_activity_logs': 'سجل نشاطات النظام',

    'monthly_revenue_by_user': 'الإيرادات الشهرية حسب المستخدم',
    'export_to_excel': 'تصدير إلى إكسل',
    'exporting': 'جاري التصدير...',
    'total_revenue': 'إجمالي الإيرادات',
    'total_payments': 'إجمالي المدفوعات',
    'recorded_by': 'مسجل بواسطة',
    'average_payment': 'متوسط المدفوعات',
    'per_transaction': 'لكل معاملة',
    'revenue_by_user': 'الإيرادات حسب المستخدم',
    'no_revenue_data': 'لا توجد بيانات إيرادات',
    'no_revenue_data_message': 'لا توجد سجلات مدفوعات لـ {{month}} {{year}}. حاول اختيار شهر أو سنة مختلفة.',

    'loading_owner_data': 'جاري تحميل بيانات المالك',
    'error_loading_owner': 'خطأ في تحميل المالك',
    'back_to_owners': 'العودة إلى الملاك',
    'send_reminder': 'إرسال تذكير',
    'edit': 'تعديل',
    'overview': 'نظرة عامة',
    'properties': 'الشقق',
    'payments': 'المدفوعات',
    'outstanding': 'المستحقات',
    'contact_information': 'معلومات الاتصال',
    'property_overview': 'نظرة عامة على العقارات',
    'add_apartment': 'إضافة شقة',
    'no_properties': 'لا توجد شقق',
    'no_properties_message': 'هذا المالك لا يمتلك أي شقق بعد.',
    'add_first_property': 'إضافة أول شقة',
    'view_details': 'عرض التفاصيل',
    'payment_history': 'سجل المدفوعات',
    'no_payments': 'لا توجد مدفوعات',
    'no_payments_message': 'لم يتم تسجيل أي مدفوعات بعد.',
    'outstanding_fees': 'المستحقات المعلقة',
    'no_outstanding_fees': 'لا توجد مستحقات معلقة',
    'all_fees_paid': 'جميع المستحقات محدثة.',
    'total_outstanding': 'إجمالي المستحقات',
    'add_payment': 'إضافة دفعة',
    'property': 'الشقة',
    'select_property': 'اختر شقة',
    'amount': 'المبلغ',
    'payment_date': 'تاريخ الدفع',
    'payment_method': 'طريقة الدفع',
    'cash': 'نقداً',
    'bank_transfer': 'تحويل بنكي',
    'check': 'شيك',
    'credit_card': 'بطاقة ائتمان',
    'online_payment': 'دفع إلكتروني',
    'reference_number': 'رقم المرجع',
    'notes': 'ملاحظات',
    'cancel': 'إلغاء',

    'owner_information': 'معلومات المالك',
    'name': 'الاسم',
    'phone': 'الهاتف',
    'owner_lives_property': 'المالك يعيش في العقار',
    'select_apartments': 'اختر الشقق',
    'available_apartments': 'شقق متاحة',
    'no_apartments_available': 'لا توجد شقق متاحة. جميع الشقق لديها ملاك بالفعل.',
    'apartment_number': 'الشقة {{number}}',
    'floor': 'الطابق',
    'size': 'المساحة',
    'type': 'النوع',
    'status': 'الحالة',
    'cancel': 'إلغاء',
    'saving': 'جاري الحفظ...',
    'update_owner': 'تحديث المالك',
    'create_owner': 'إنشاء مالك',
    'edit_property_owner': 'تعديل مالك العقار',
    'add_property_owner': 'إضافة مالك عقار',

    'resident_owner': 'مالك مقيم',
    'apartments_count': 'عدد الشقق',
    'show_apartments': 'عرض الشقق',
    'hide_apartments': 'إخفاء الشقق',
    'size_unit_sqm': 'حجم الوحدة متر مربع',

    'property_owners': 'مالكو العقارات',
    'add_owner': 'إضافة مالك',
    'search_owners': 'بحث عن الملاك...',
    'filter': 'تصفية',
    'list_view': 'قائمة',
    'grid_view': 'شبكة',
    'export': 'تصدير',
    'exporting': 'جاري التصدير...',
    'living_status': 'حالة السكن',
    'all': 'الكل',
    'living_on_property': 'مقيم في العقار',
    'not_living_on_property': 'غير مقيم في العقار',
    'country': 'البلد',
    'all_countries': 'جميع البلدان',
    'apartment_status': 'حالة الشقة',
    'all_statuses': 'جميع الحالات',
    'with_vacant': 'مع شقق شاغرة',
    'fully_occupied': 'مشغول بالكامل',
    'with_maintenance': 'مع صيانة',
    'min_apartments': 'الحد الأدنى للشقق',
    'max_apartments': 'الحد الأقصى للشقق',
    'min_occupancy_rate': 'نسبة الإشغال الدنيا (%)',
    'clear_filters': 'مسح الفلاتر',
    'apply_filters': 'تطبيق الفلاتر',
    'total_owners': 'إجمالي الملاك',
    'resident_owners': 'الملاك المقيمين',
    'with_apartments': 'مع شقق',
    'without_apartments': 'بدون شقق',
    'loading_owners': 'جاري تحميل الملاك...',
    'error_loading_owners': 'خطأ في تحميل الملاك',
    'try_again': 'حاول مرة أخرى',
    'no_owners_found': 'لم يتم العثور على ملاك',
    'no_owners_message': 'لا يوجد ملاك للعقارات في النظام حتى الآن. انقر فوق زر \'إضافة مالك\' لإنشاء أول مالك لك.',
    'create_first_owner': 'إنشاء أول مالك',
    'showing_filtered_results': 'عرض {showing} من أصل {total} من الملاك',
    'confirm_deletion': 'تأكيد الحذف',
    'delete_owner_confirmation': 'هل أنت متأكد أنك تريد حذف المالك "{name}"؟ لا يمكن التراجع عن هذا الإجراء.',
    'cancel': 'إلغاء',
    'delete': 'حذف',
    'deleting': 'جاري الحذف...',

    "loading": "جاري التحميل...",
    "edit_property_owner": "تعديل مالك العقار",
    "add_property_owner": "إضافة مالك عقار",
    "owner_information": "معلومات المالك",
    "name": "الاسم",
    "phone": "رقم الهاتف",
    "owner_lives_on_property": "المالك يعيش في العقار",
    "select_apartments": "اختر الشقق ({{count}})",
    "available_apartments": "{{count}} شقة متاحة",
    "no_apartments_available": "لا توجد شقق متاحة. جميع الشقق لديها مالكون بالفعل.",
    "floor": "الطابق",
    "size": "المساحة",
    "size_unit_sqm": "م²",
    "type": "النوع",
    "status": "الحالة",
    "cancel": "إلغاء",
    "saving": "جاري الحفظ...",
    "update_owner": "تحديث المالك",
    "create_owner": "إنشاء مالك",
    "failed_to_load_data": "فشل في تحميل البيانات",
    "failed_to_save_owner": "فشل في حفظ بيانات المالك",

    "activity_logs": "سجلات النشاط",
    "tenant_activity_logs": "سجلات نشاط المستأجرين",
    "payment_activity_logs": "سجلات نشاط المدفوعات",
    "building_activity_logs": "سجلات نشاط المباني",
    "apartment_activity_logs": "سجلات نشاط الشقق",
    "owner_activity_logs": "سجلات نشاط المالكين",
    "user_activity_logs": "سجلات نشاط المستخدمين",
    "system_activity_logs": "سجلات نشاط النظام",
    "track_all_system_activities": "تتبع جميع أنشطة وتغييرات النظام",
    "filter": "تصفية",
    "export_to_excel": "تصدير إلى إكسل",
    "exporting": "جاري التصدير...",
    "search_logs_placeholder": "البحث في السجلات حسب الاسم أو المستخدم أو التفاصيل...",
    "showing_entries": "عرض {{showing}} من {{total}} سجل",
    "filter_logs": "تصفية السجلات",
    "action_type": "نوع الإجراء",
    "all_actions": "جميع الإجراءات",
    "entity_type": "نوع الكيان",
    "all_entities": "جميع الكيانات",
    "entries_per_page": "عدد السجلات في الصفحة",
    "start_date": "تاريخ البدء",
    "end_date": "تاريخ الانتهاء",
    "reset": "إعادة تعيين",
    "apply_filter": "تطبيق التصفية",
    "time": "الوقت",
    "user": "المستخدم",
    "action": "الإجراء",
    "entity": "الكيان",
    "details": "التفاصيل",
    "view": "عرض",
    "system": "النظام",
    "view_entity_details": "عرض تفاصيل {{type}}",
    "no_logs_matching_search": "لا توجد سجلات نشاط تطابق معايير البحث",
    "no_logs_for_filters": "لا توجد سجلات نشاط للفلاتر المحددة",
    "showing_range": "عرض {{start}} إلى {{end}} من {{total}} سجل",
    "previous": "السابق",
    "next": "التالي",
    "failed_to_load_logs": "فشل في تحميل سجلات النشاط",
    "failed_to_export_logs": "فشل في تصدير السجلات إلى إكسل",

    "tenant": "مستأجر",
    "payment": "دفعة",
    "building": "مبنى",
    "apartment": "شقة",
    "owner": "مالك",
    "user": "مستخدم",
    "system": "نظام",

    "created": "تم الإنشاء",
    "updated": "تم التحديث",
    "deleted": "تم الحذف",
    "viewed": "تم العرض",
    "login": "تسجيل الدخول",
    "logout": "تسجيل الخروج",
    "payment_made": "تم الدفع",
    "payment_received": "تم استلام الدفعة",
    "status_changed": "تم تغيير الحالة",
    "approved": "تمت الموافقة",
    "rejected": "تم الرفض",
    "maintenance_request": "طلب صيانة",
    "maintenance_completed": "اكتملت الصيانة",


    "loading": "جاري التحميل...",
    "edit_payment": "تعديل الدفعة",
    "record_payment": "تسجيل دفعة",
    "payment_information": "معلومات الدفع",
    "tenant": "المستأجر",
    "select_tenant": "اختر المستأجر",
    "apt": "شقة",
    "no_apartment": "لا توجد شقة",
    "amount": "المبلغ",
    "payment_date": "تاريخ الدفع",
    "payment_type": "نوع الدفعة",
    "payment_period": "فترة الدفع",
    "period_start": "بداية الفترة",
    "period_end": "نهاية الفترة",
    "additional_information": "معلومات إضافية",
    "notes": "ملاحظات",
    "notes_placeholder": "أي ملاحظات إضافية حول هذه الدفعة...",
    "cancel": "إلغاء",
    "saving": "جاري الحفظ...",
    "update_payment": "تحديث الدفعة",
    "failed_to_load_tenants_format": "فشل في تحميل المستأجرين: صيغة بيانات غير متوقعة",
    "failed_to_load_tenants": "فشل في تحميل المستأجرين. يرجى المحاولة مرة أخرى.",
    "failed_to_load_payment_data": "فشل في تحميل بيانات الدفع",
    "failed_to_save_payment": "فشل في حفظ الدفعة",

    "rent": "إيجار",
    "service": "رسوم خدمة",
    "deposit": "تأمين",
    "maintenance": "صيانة",
    "other": "أخرى",

    "payments": "المدفوعات",
    "refresh": "تحديث",
    "refresh_payments": "تحديث المدفوعات",
    "stats": "إحصائيات",
    "toggle_statistics": "تبديل عرض الإحصائيات",
    "search_payments": "ابحث في المدفوعات...",
    "filter": "تصفية",
    "record_payment": "تسديد دفعة",
    "confirm_deletion": "تأكيد الحذف",
    "confirm_delete_payment": "هل أنت متأكد أنك تريد حذف دفعة {amount} للمستأجر {tenantName}؟ لا يمكن التراجع عن هذا الإجراء.",
    "cancel": "إلغاء",
    "deleting": "جاري الحذف...",
    "delete": "حذف",
    "filter_payments": "تصفية المدفوعات",
    "reset_all": "إعادة تعيين الكل",
    "payment_type": "نوع الدفعة",
    "all_types": "جميع الأنواع",
    "payment_type_rent": "إيجار",
    "payment_type_service": "خدمة",
    "payment_type_deposit": "وديعة",
    "payment_type_other": "أخرى",

    "payment_type_commission": "عمولة",
    "payment_type_security_deposit": "وديعة ضمان",    "building": "المبنى",
    "all_buildings": "جميع المباني",
    "from_date": "من تاريخ",
    "to_date": "إلى تاريخ",
    "total_payments": "إجمالي المدفوعات",
    "payment": "دفعة",
    "payments": "مدفوعات",
    "recorded": "مسجلة",
    "rent_payments": "مدفوعات الإيجار",
    "service_payments": "مدفوعات الخدمة",
    "payment_statistics": "إحصائيات المدفوعات",
    "payments_by_month": "المدفوعات حسب الشهر",
    "payment_types_distribution": "توزيع أنواع المدفوعات",
    "recent_activity": "النشاط الأخير",
    "close_statistics": "إغلاق الإحصائيات",
    "loading_payments": "جاري تحميل المدفوعات...",
    "this_may_take_moment": "قد يستغرق هذا بعض الوقت",
    "error_loading_payments": "خطأ في تحميل المدفوعات",
    "try_again": "حاول مرة أخرى",
    "no_payments_found": "لا توجد مدفوعات",
    "no_payments_match_filters": "لا توجد مدفوعات تطابق عوامل التصفية الحالية. حاول تعديل معايير التصفية لرؤية المزيد من النتائج.",
    "no_payments_in_system": "لا توجد مدفوعات في النظام بعد. ابدأ بتسجيل أول دفعة.",
    "reset_filters": "إعادة تعيين الفلاتر",
    "record_first_payment": "تسجيل أول دفعة",
    "unknown_period": "فترة غير معروفة",
    "to": "إلى",
    "invalid_period_data": "بيانات فترة غير صالحة",
    "unknown_type": "نوع غير معروف",
    "apt": "شقة",
    "print_receipt": "طباعة الإيصال",
    "view_details": "عرض التفاصيل",
    "edit_payment": "تعديل الدفعة",
    "delete_payment": "حذف الدفعة",
    "showing_payments": "عرض {{start}}-{{end}} من أصل {{total}} مدفوعات",
    "showing_filtered_payments": "عرض {{filtered}} من أصل {{total}} مدفوعات بناءً على بحثك",
    "authentication_required": "مطلوب مصادقة",
    "failed_load_payments": "فشل تحميل بيانات المدفوعات",
    "auth_failed_login_again": "فشل المصادقة. يرجى تسجيل الدخول مرة أخرى.",
    "access_denied_admin_required": "تم الرفض. مطلوب دور المسؤول.",
    "server_error_check_backend": "خطأ في الخادم. يرجى التحقق مما إذا كان الخلفية قيد التشغيل.",
    "cannot_connect_server": "لا يمكن الاتصال بالخادم. يرجى التحقق مما إذا كان الخلفية قيد التشغيل.",
    "error_fetching_payments": "خطأ في جلب المدفوعات",
    "error_deleting_payment": "خطأ في حذف الدفعة",
    "failed_delete_payment": "فشل حذف الدفعة",

    "occupancy_report": "تقرير الإشغال",
    "loading": "جاري التحميل...",
    "refresh": "تحديث",
    "back": "رجوع",
    "error_fetching_occupancy": "خطأ في جلب بيانات الإشغال",
    "failed_load_occupancy": "فشل تحميل بيانات الإشغال",
    "occupied": "مشغولة",
    "vacant": "شاغرة",
    "maintenance": "صيانة",
    "apartments": "شقق",
    "occupancy_rate": "معدل الإشغال",
    "of": "من",
    "vacant_apartments": "الشقق الشاغرة",
    "of_total": "من الإجمالي",
    "maintenance_apartments": "قيد الصيانة",
    "potential_income": "الدخل الشهري المحتمل",
    "buildings": "مباني",
    "occupancy_distribution": "توزيع الإشغال",
    "occupancy_by_building": "الإشغال حسب المبنى",
    "building": "المبنى",
    "total_apartments": "إجمالي الشقق",
    "print_report": "طباعة التقرير",
    "export_report": "تصدير التقرير",

    "rent": "إيجار",
    "service": "خدمة",
    "commission": "عمولة",
    "insurance": "تأمين",
    "total": "المجموع",

    "occupied": "مشغولة",
    "vacant": "شاغرة",
    "maintenance": "صيانة",
    "apartments": "شقق",
    "of": "من",
    "excellent": "ممتاز",
    "good": "جيد",
    "needs_improvement": "يحتاج تحسين",
    "error_fetching_occupancy": "خطأ في جلب بيانات الإشغال",
    "failed_load_occupancy": "فشل تحميل بيانات الإشغال",


    "overdue": "متأخر",
    "pending": "قيد الانتظار",
    "paid": "مدفوع",
    "no_overdue_payments": "لا توجد مدفوعات متأخرة",
    "apt": "شقة",
    "days_overdue": "يوم متأخر",
    "more_overdue_tenants": "مستأجرين متأخرين إضافيين...",
    "error_fetching_tenant_status": "خطأ في جلب حالة دفع المستأجر",
    "failed_load_tenant_status": "فشل تحميل حالة دفع المستأجر",

    "rent": "إيجار",
    "service": "خدمة",
    "deposit": "وديعة",
    "no_recent_payments": "لا توجد مدفوعات حديثة",
    "error_fetching_payments": "خطأ في جلب المدفوعات الحديثة",
    "failed_load_payments": "فشل تحميل المدفوعات الحديثة",

    "payment_logs": "سجلات الدفع",
    "filter": "تصفية",
    "back": "رجوع",
    "search_payment_logs_placeholder": "البحث في سجلات الدفع...",
    "showing_entries": "عرض {{showing}} من {{total}} سجل",
    "filter_payments": "تصفية المدفوعات",
    "time_period": "الفترة الزمنية",
    "start_date": "تاريخ البداية",
    "end_date": "تاريخ النهاية",
    "payment_type": "نوع الدفع",
    "all_types": "جميع الأنواع",
    "entries_per_page": "عدد السجلات في الصفحة",
    "reset": "إعادة تعيين",
    "apply_filter": "تطبيق التصفية",
    "payment_id": "رقم الدفعة",
    "date": "التاريخ",
    "tenant": "المستأجر",
    "building": "المبنى",
    "type": "النوع",
    "amount": "المبلغ",
    "actions": "الإجراءات",
    "print_receipt": "طباعة الإيصال",
    "view_details": "عرض التفاصيل",
    "no_logs_matching_search": "لا توجد سجلات دفع تطابق معايير البحث",
    "no_logs_for_period": "لا توجد سجلات دفع متاحة للفترة الزمنية المحددة",
    "showing_range": "عرض {{start}} إلى {{end}} من {{total}} سجل",
    "previous": "السابق",
    "next": "التالي",
    "print_report": "طباعة التقرير",
    "export_to_excel": "تصدير إلى إكسل",
    "failed_to_load_payment_logs": "فشل في تحميل سجلات الدفع",

    "current_month": "الشهر الحالي",
    "last_month": "الشهر الماضي",
    "current_quarter": "الربع الحالي",
    "current_year": "السنة الحالية",
    "custom": "نطاق مخصص",

    "rent": "إيجار",
    "service": "خدمة",
    "commission": "عمولة",
    "insurance": "تأمين",
    "other": "أخرى",

    "reports_dashboard": "لوحة التقارير",
    "overview_of_financial_performance": "نظرة عامة على الأداء المالي وإحصاءات العقارات",
    "view_all_reports": "عرض جميع التقارير",
    "failed_to_load_report_data": "فشل في تحميل بيانات التقرير",
    "total_revenue": "إجمالي الإيرادات",
    "total_payments_count": "{{count}} دفعة",
    "total_tenants": "إجمالي المستأجرين",
    "new_tenants_this_year": "{{count}} جديد هذا العام",
    "total_properties": "إجمالي العقارات",
    "total_buildings_count": "{{count}} مبنى",
    "total_owners": "إجمالي الملاك",
    "ended_contracts_count": "{{count}} عقد منتهي",
    "monthly_revenue_year": "الإيرادات الشهرية - {{year}}",
    "view_details": "عرض التفاصيل",
    "occupancy_rate": "معدل الإشغال",
    "recent_payments": "الدفعات الأخيرة",
    "view_all": "عرض الكل",
    "overdue_payments": "الدفعات المتأخرة",
    "quick_reports": "تقارير سريعة",
    "annual_revenue": "الإيرادات السنوية",
    "yearly_breakdown": "تفصيل سنوي لجميع الإيرادات",
    "building_revenue": "إيرادات المباني",
    "revenue_by_building": "تفصيل الإيرادات حسب المبنى",
    "owner_revenue": "إيرادات الملاك",
    "revenue_by_owner": "تفصيل الإيرادات حسب مالك العقار",
    "payment_logs": "سجلات الدفع",
    "detailed_payment_history": "سجل مفصل لتاريخ الدفعات",


    "revenue_report": "تقرير الإيرادات",
    "filter": "تصفية",
    "loading": "جاري التحميل...",
    "refresh": "تحديث",
    "back": "رجوع",
    "filter_report": "تصفية التقرير",
    "time_period": "الفترة الزمنية",
    "start_date": "تاريخ البداية",
    "end_date": "تاريخ النهاية",
    "cancel": "إلغاء",
    "apply_filter": "تطبيق التصفية",
    "failed_to_load_revenue_data": "فشل في تحميل بيانات الإيرادات",
    "total_revenue": "إجمالي الإيرادات",
    "total_payments_count": "{{count}} دفعة",
    "rent_revenue": "إيرادات الإيجار",
    "percent_of_total": "{{percent}}% من الإجمالي",
    "service_revenue": "إيرادات الخدمات",
    "unique_tenants": "المستأجرين الفريدين",
    "avg_per_tenant": "متوسط {{amount}} لكل مستأجر",
    "revenue_by_building": "الإيرادات حسب المبنى",
    "view_details": "عرض التفاصيل",
    "building": "المبنى",
    "tenants": "المستأجرين",
    "no_building_revenue_data": "لا توجد بيانات إيرادات متاحة للمباني",
    "revenue_by_owner": "الإيرادات حسب المالك",
    "owner": "المالك",
    "apartments": "الشقق",
    "no_owner_revenue_data": "لا توجد بيانات إيرادات متاحة للملاك",
    "print_report": "طباعة التقرير",
    "export_report": "تصدير التقرير",

    "current_month": "الشهر الحالي",
    "last_month": "الشهر الماضي",
    "current_quarter": "الربع الحالي",
    "current_year": "السنة الحالية",
    "custom": "نطاق مخصص",


    "service_payments_management": "إدارة مدفوعات الخدمات",
    "refresh": "تحديث",
    "back_to_dashboard": "العودة إلى لوحة المعلومات",
    "building": "المبنى",
    "select_building": "اختر المبنى",
    "year": "السنة",
    "search": "بحث",
    "search_apartments_tenants": "البحث عن شقق، مستأجرين...",
    "generate_payments": "إنشاء المدفوعات",
    "view_statistics": "عرض الإحصائيات",
    "filter_by_status": "تصفية حسب الحالة",
    "all": "الكل",
    "paid": "مدفوع",
    "unpaid": "غير مدفوع",
    "clear_filters": "مسح التصفية",
    "loading_service_data": "جاري تحميل بيانات مدفوعات الخدمات...",
    "no_building_selected": "لم يتم اختيار مبنى",
    "please_select_building": "الرجاء اختيار مبنى لعرض مدفوعات الخدمات.",
    "no_search_results": "لا توجد نتائج بحث",
    "no_matching_apartments": "لا توجد شقق أو مستأجرين تطابق معايير البحث.",
    "service_payments_for_building_year": "مدفوعات الخدمات لـ {{building}} - {{year}}",
    "floor_number": "الطابق {{number}}",
    "apartments": "شقق",
    "rate": "معدل",
    "tenant_owner": "المستأجر/المالك",
    "vacant": "شاغر",
    "mark_as_paid": "تعليم كمدفوع",
    "mark_as_unpaid": "تعليم كغير مدفوع",
    "view_details": "عرض التفاصيل",
    "summary": "ملخص",
    "floor_apartment_count": "{{floors}} طابق، {{apartments}} شقة",
    "no_floors_available": "لا توجد طوابق متاحة",
    "no_floors_message": "لا توجد طوابق بها شقق في هذا المبنى، أو لم يتم إنشاء مدفوعات الخدمات بعد.",
    "failed_to_load_buildings": "فشل في تحميل المباني. الرجاء المحاولة مرة أخرى.",
    "failed_to_load_floors": "فشل في تحميل الطوابق",
    "failed_to_load_building_floors": "فشل في تحميل طوابق المبنى",
    "failed_to_load_floor_data": "فشل في تحميل بيانات الطابق",
    "data_refreshed_successfully": "تم تحديث البيانات بنجاح.",
    "failed_to_refresh_data": "فشل في تحديث البيانات",
    "marked_as_paid_via_service_management": "تم تعليمه كمدفوع عبر إدارة الخدمات",
    "marked_as_unpaid_via_service_management": "تم تعليمه كغير مدفوع عبر إدارة الخدمات",
    "payment_marked_as_paid": "تم تعليم الدفعة كمدفوعة بنجاح.",
    "payment_marked_as_unpaid": "تم تعليم الدفعة كغير مدفوعة بنجاح.",
    "failed_to_update_payment": "فشل في تحديث الدفعة",
    "payment_details": "تفاصيل الدفعة",
    "payment_due": "دفعة مستحقة",
    "amount": "المبلغ",
    "status": "الحالة",
    "paid_on": "تم الدفع في",
    "no_apartments_on_floor": "لا توجد شقق في هذا الطابق.",

    "month_1": "يناير",
    "month_2": "فبراير",
    "month_3": "مارس",
    "month_4": "أبريل",
    "month_5": "مايو",
    "month_6": "يونيو",
    "month_7": "يوليو",
    "month_8": "أغسطس",
    "month_9": "سبتمبر",
    "month_10": "أكتوبر",
    "month_11": "نوفمبر",
    "month_12": "ديسمبر",

    "service_payment_details": "تفاصيل دفعة الخدمة",
    "print_receipt": "طباعة الإيصال",
    "loading": "جاري التحميل...",
    "failed_to_load_payment_details": "فشل في تحميل تفاصيل الدفعة",
    "api_endpoint_missing_message": "يشير هذا الخطأ إلى نقطة نهاية API مفقودة على خادم الواجهة الخلفية. لإصلاح ذلك، أضف مسارًا لـ GET /api/services/:id في ملف serviceRoutes.js الخاص بك.",
    "payment_information": "معلومات الدفع",
    "apartment": "الشقة",
    "period": "الفترة",
    "amount": "المبلغ",
    "status": "الحالة",
    "tenant": "المستأجر",
    "owner": "المالك",
    "payment_date": "تاريخ الدفع",
    "paid_by": "دفع بواسطة",
    "notes": "ملاحظات",
    "update_payment": "تحديث الدفعة",
    "mark_as_paid": "تعليم كمدفوع",
    "currency": "العملة",
    "select_payer": "اختر الدافع",
    "management": "الإدارة",
    "other": "آخر",
    "payment_notes_placeholder": "أدخل أي ملاحظات إضافية حول هذه الدفعة...",
    "cancel": "إلغاء",
    "saving": "جاري الحفظ...",
    "payment_history": "سجل الدفعات",
    "date": "التاريخ",
    "action": "الإجراء",
    "by": "بواسطة",
    "paid": "مدفوع",
    "unpaid": "غير مدفوع",
    "payment_marked_as_paid": "تم تعليم الدفعة كمدفوعة بنجاح.",
    "payment_marked_as_unpaid": "تم تعليم الدفعة كغير مدفوعة بنجاح.",
    "failed_to_update_payment": "فشل في تحديث الدفعة",
    "service_payment_receipt": "إيصال دفع الخدمة",
    "property_management": "إدارة العقارات",
    "receipt_generated": "تم إنشاء هذا الإيصال في {{date}} الساعة {{time}}",
    "automated_receipt_notice": "هذا إيصال تم إنشاؤه تلقائيًا ولا يتطلب توقيعًا.",
    "us_dollar": "دولار أمريكي",
    "iraqi_dinar": "دينار عراقي",
    "euro": "يورو",

    "month_1": "يناير",
    "month_2": "فبراير",
    "month_3": "مارس",
    "month_4": "أبريل",
    "month_5": "مايو",
    "month_6": "يونيو",
    "month_7": "يوليو",
    "month_8": "أغسطس",
    "month_9": "سبتمبر",
    "month_10": "أكتوبر",
    "month_11": "نوفمبر",
    "month_12": "ديسمبر",

    "tenant": "مستأجر",
    "owner": "مالك",
    "management": "إدارة",
    "other": "آخر",

    "generate_service_payments": "إنشاء مدفوعات الخدمة",
    "recipients": "المستلمون",
    "entire_building": "المبنى بأكمله",
    "generate_for_all_apartments": "إنشاء لجميع الشقق في المبنى",
    "specific_tenants": "المستأجرين المحددين",
    "generate_for_selected_tenants": "إنشاء للمستأجرين المحددين فقط",
    "specific_owners": "المالكين المحددين",
    "generate_for_selected_owners": "إنشاء للمالكين المحددين فقط",
    "select_building": "اختر المبنى",
    "include_vacant_apartments": "تضمين الشقق الشاغرة",
    "selected_tenants": "المستأجرين المحددين",
    "selected_owners": "المالكين المحددين",
    "select_tenants": "اختر المستأجرين",
    "select_owners": "اختر المالكين",
    "no_tenants_selected": "لم يتم اختيار مستأجرين",
    "no_owners_selected": "لم يتم اختيار مالكين",
    "payment_details": "تفاصيل الدفع",
    "amount": "المبلغ",
    "currency": "العملة",
    "us_dollar": "دولار أمريكي",
    "iraqi_dinar": "دينار عراقي",
    "euro": "يورو",
    "initial_status": "الحالة الأولية",
    "unpaid": "غير مدفوع",
    "paid": "مدفوع",
    "notes": "ملاحظات",
    "payment_notes_placeholder": "أدخل أي ملاحظات إضافية حول هذه المدفوعات...",
    "time_period": "الفترة الزمنية",
    "generation_type": "نوع الإنشاء",
    "single_month": "شهر واحد",
    "multiple_months": "عدة أشهر",
    "month_range": "نطاق شهري",
    "year": "السنة",
    "month": "الشهر",
    "select_months": "اختر الأشهر",
    "from": "من",
    "to": "إلى",
    "selected_months": "الأشهر المحددة",
    "payment_generation_summary": "ملخص إنشاء المدفوعات",
    "all_apartments_in": "جميع الشقق في",
    "selected_building": "المبنى المحدد",
    "tenants": "مستأجرين",
    "owners": "مالكين",
    "cancel": "إلغاء",
    "generating": "جاري الإنشاء...",
    "generate_payments": "إنشاء المدفوعات",
    "search": "بحث",
    "search_by_tenant_name_or_phone": "البحث باسم المستأجر أو الهاتف أو رقم الشقة...",
    "search_by_owner_name_or_phone": "البحث باسم المالك أو الهاتف...",
    "no_results_found": "لم يتم العثور على نتائج",
    "selected": "محدد",
    "done": "تم",
    "no_tenants_available": "لا يوجد مستأجرين متاحين. الرجاء إضافة مستأجرين أولاً.",
    "no_owners_available": "لا يوجد مالكين متاحين. الرجاء إضافة مالكين أولاً.",
    "apt": "شقة",
    "january": "يناير",
    "february": "فبراير",
    "march": "مارس",
    "april": "أبريل",
    "may": "مايو",
    "june": "يونيو",
    "july": "يوليو",
    "august": "أغسطس",
    "september": "سبتمبر",
    "october": "أكتوبر",
    "november": "نوفمبر",
    "december": "ديسمبر",
    "failed_to_load_buildings": "فشل في تحميل المباني. يرجى المحاولة مرة أخرى.",
    "failed_to_load_tenants": "فشل في تحميل المستأجرين. يرجى المحاولة مرة أخرى.",
    "failed_to_load_owners": "فشل في تحميل المالكين. يرجى المحاولة مرة أخرى.",
    "please_select_building": "الرجاء اختيار مبنى",
    "please_select_at_least_one_recipient": "الرجاء اختيار {{recipient}} واحد على الأقل",
    "please_enter_valid_amount": "الرجاء إدخال مبلغ صحيح",
    "please_select_month": "الرجاء اختيار شهر",
    "please_select_at_least_one_month": "الرجاء اختيار شهر واحد على الأقل",
    "end_month_must_be_after_start_month": "يجب أن يكون الشهر النهائي بعد الشهر البدائي",
    "successfully_generated_payments": "تم إنشاء {{count}} مدفوعات خدمة عبر {{months}} شهر (أشهر). {{skipped}} مدفوعات تم إنشاؤها مسبقًا.",
    "failed_to_generate_service_payments": "فشل في إنشاء مدفوعات الخدمة",
    "tenant": "مستأجر",
    "owner": "مالك",

    "service_payment_statistics": "إحصائيات مدفوعات الخدمة",
    "back_to_services": "العودة إلى الخدمات",
    "building": "المبنى",
    "year": "السنة",
    "loading_statistics": "جاري تحميل الإحصائيات...",
    "no_building_selected": "لم يتم اختيار مبنى",
    "please_select_building_statistics": "الرجاء اختيار مبنى لعرض إحصائيات مدفوعات الخدمة.",
    "overall_statistics": "الإحصائيات العامة",
    "total_collection": "إجمالي التحصيل",
    "of": "من",
    "payment_rate": "معدل الدفع",
    "payments": "مدفوعات",
    "outstanding_amount": "المبلغ المستحق",
    "unpaid_payments": "مدفوعات غير مسددة",
    "monthly_statistics": "الإحصائيات الشهرية",
    "no_monthly_data": "لا توجد بيانات شهرية متاحة للسنة المحددة.",
    "month": "الشهر",
    "total_amount": "إجمالي المبلغ",
    "collected": "تم تحصيله",
    "outstanding": "مستحق",
    "progress": "التقدم",
    "failed_to_load_service_statistics": "فشل في تحميل إحصائيات الخدمة",

    "loading_tenant_data": "جاري تحميل بيانات المستأجر...",
    "error_loading_tenant": "خطأ في تحميل المستأجر",
    "tenant_not_found": "المستأجر غير موجود",
    "back_to_tenants": "العودة إلى المستأجرين",
    "record_payment": "تسجيل دفعة",
    "edit": "تعديل",
    "status_unknown": "الحالة غير معروفة",
    "apartment": "الشقة",
    "apt": "شقة",
    "none": "لا يوجد",
    "monthly_rent": "الإيجار الشهري",
    "payment_date": "تاريخ الدفع",
    "overview": "نظرة عامة",
    "leases": "عقود الإيجار",
    "payments": "المدفوعات",
    "contact_information": "معلومات الاتصال",
    "lease_information": "معلومات عقد الإيجار",
    "contract_period": "فترة العقد",
    "rent": "الإيجار",
    "discount": "الخصم",
    "rent_after_discount": "الإيجار بعد الخصم",
    "additional_fees": "الرسوم الإضافية",
    "service_fee": "رسوم الخدمة",
    "office_commission": "عمولة المكتب",
    "insurance": "التأمين",
    "notes": "ملاحظات",
    "no_leases": "لا توجد عقود إيجار",
    "no_leases_message": "هذا المستأجر ليس لديه شقة مخصصة بعد.",
    "active_leases": "عقود الإيجار النشطة",
    "inactive_leases": "عقود الإيجار غير النشطة",
    "active": "نشط",
    "ended": "منتهي",
    "expiring_soon": "ينتهي قريباً",
    "end_lease": "إنهاء عقد الإيجار",
    "start_date": "تاريخ البدء",
    "end_date": "تاريخ الانتهاء",
    "duration": "المدة",
    "remaining": "المتبقي",
    "months": "أشهر",
    "security_deposit": "مبلغ التأمين",
    "total_value": "القيمة الإجمالية",
    "no_payments": "لا توجد مدفوعات",
    "no_payments_message": "هذا المستأجر ليس لديه مدفوعات مسجلة بعد.",
    "record_first_payment": "تسجيل الدفعة الأولى",
    "payment_period": "فترة الدفع",
    "reference": "المرجع",
    "payment_type": "نوع الدفع",
    "rent_payment": "دفع الإيجار",
    "additional_fee": "رسوم إضافية",
    "utility_payment": "دفع المرافق",
    "other_payment": "دفعة أخرى",
    "start": "البداية",
    "end": "النهاية",
    "reference_number": "رقم المرجع",
    "cancel": "إلغاء",
    "unknown_period": "فترة غير معروفة",
    "invalid_period_format": "تنسيق فترة غير صالح",
    "to": "إلى",
    "invalid_period_data": "بيانات الفترة غير صالحة",
    "please_enter_valid_payment_amount": "الرجاء إدخال مبلغ دفع صحيح",
    "end_date_must_be_after_start_date": "يجب أن يكون تاريخ الانتهاء بعد تاريخ البدء",
    "failed_to_add_payment": "فشل في إضافة الدفعة",
    "maintenance_requests_not_supported": "طلبات الصيانة غير مدعومة في هيكل قاعدة البيانات الحالي",
    "failed_to_create_maintenance_request": "فشل في إنشاء طلب صيانة",
    "confirm_end_lease": "هل أنت متأكد أنك تريد إنهاء عقد الإيجار هذا؟ لا يمكن التراجع عن هذا الإجراء.",
    "lease_ended_by_administrator": "تم إنهاء عقد الإيجار من قبل المسؤول",
    "failed_to_end_lease": "فشل في إنهاء عقد الإيجار",
    "failed_to_load_tenant_data": "فشل في تحميل بيانات المستأجر",
    "actual_end_date": "تاريخ الانتهاء الفعلي",
    "deposit": "تأمين",

    "edit_tenant": "تعديل المستأجر",
    "add_tenant": "إضافة مستأجر",
    "basic_information": "المعلومات الأساسية",
    "first_name": "الاسم الأول",
    "last_name": "اسم العائلة",
    "email": "البريد الإلكتروني",
    "phone": "الهاتف",
    "apartment": "الشقة",
    "select_apartment": "اختر الشقة",
    "floor": "الطابق",
    "rent_amount": "مبلغ الإيجار",
    "discount": "الخصم",
    "service_fee": "رسوم الخدمة",
    "office_commission": "عمولة المكتب",
    "insurance": "التأمين",
    "contract_start_date": "تاريخ بدء العقد",
    "contract_end_date": "تاريخ انتهاء العقد",
    "payment_date": "تاريخ الدفع",
    "payment_end_date": "تاريخ انتهاء الدفع",
    "rent_status": "حالة الإيجار",
    "additional_information": "معلومات إضافية",
    "notes": "ملاحظات",
    "tenant_notes_placeholder": "أي ملاحظات إضافية حول هذا المستأجر...",
    "cancel": "إلغاء",
    "saving": "جاري الحفظ...",
    "update_tenant": "تحديث المستأجر",
    "create_tenant": "إنشاء مستأجر",
    "loading": "جاري التحميل...",
    "failed_to_load_tenant_data": "فشل في تحميل بيانات المستأجر",
    "failed_to_save_tenant": "فشل في حفظ المستأجر",
    "pending": "قيد الانتظار",
    "paid": "مدفوع",
    "late": "متأخر",
    "overdue": "متأخر جداً",
    "unpaid": "غير مدفوع",

    "tenants": "المستأجرون",
    "refresh_tenants": "تحديث المستأجرين",
    "selected": "محدد",
    "delete_selected_tenants": "حذف المستأجرين المحددين",
    "search_tenants": "البحث عن المستأجرين...",
    "filter": "تصفية",
    "switch_to_list_view": "التبديل إلى عرض القائمة",
    "switch_to_grid_view": "التبديل إلى عرض الشبكة",
    "list_view": "قائمة",
    "grid_view": "شبكة",
    "hide_inactive_tenants": "إخفاء المستأجرين غير النشطين",
    "show_inactive_tenants": "إظهار المستأجرين غير النشطين",
    "hide_inactive": "إخفاء غير النشطين",
    "show_inactive": "إظهار غير النشطين",
    "add_tenant": "إضافة مستأجر",
    "rent_status": "حالة الإيجار",
    "all_statuses": "جميع الحالات",
    "all_buildings": "جميع المباني",
    "all_apartments": "جميع الشقق",
    "min_rent": "الحد الأدنى للإيجار",
    "max_rent": "الحد الأقصى للإيجار",
    "unlimited": "غير محدود",
    "contracts_ending_before": "العقود التي تنتهي قبل",
    "clear_filters": "مسح التصفية",
    "apply_filters": "تطبيق التصفية",
    "active_tenants": "المستأجرون النشطون",
    "inactive_tenants": "المستأجرون غير النشطين",
    "with_apartments": "مع شقق",
    "without_apartments": "بدون شقق",
    "loading_tenants": "جاري تحميل المستأجرين...",
    "error_loading_tenants": "خطأ في تحميل المستأجرين",
    "try_again": "حاول مرة أخرى",
    "no_tenants_found": "لم يتم العثور على مستأجرين",
    "no_tenants_message": "لا يوجد مستأجرين في النظام حتى الآن. انقر على زر 'إضافة مستأجر' لإنشاء أول مستأجر لديك.",
    "create_first_tenant": "إنشاء أول مستأجر",
    "page": "صفحة",
    "showing_items": "عرض {start}-{end} من {total}",
    "first_page": "الصفحة الأولى",
    "previous_page": "الصفحة السابقة",
    "next_page": "الصفحة التالية",
    "last_page": "الصفحة الأخيرة",
    "showing_filtered_results": "عرض {showing} من {total} مستأجر",
    "confirm_deletion": "تأكيد الحذف",
    "delete_tenant_confirmation": "هل أنت متأكد أنك تريد حذف المستأجر \"{name}\"؟ هذا الإجراء لا يمكن التراجع عنه.",
    "cancel": "إلغاء",
    "deleting": "جاري الحذف...",
    "delete": "حذف",
    "tenant": "المستأجر",
    "apartment": "شقة",
    "rent": "الإيجار",
    "contract": "العقد",
    "status": "الحالة",
    "actions": "الإجراءات",
    "apt": "شقة",
    "unknown_building": "مبنى غير معروف",
    "no_apartment_assigned": "لم يتم تعيين شقة",
    "status_unknown": "حالة غير معروفة",
    "monthly_rent": "الإيجار الشهري",
    "after_discount": "بعد الخصم",
    "payment_date": "تاريخ الدفع",
    "not_set": "غير محدد",
    "contract_start": "بداية العقد",
    "contract_end": "نهاية العقد",
    "service": "خدمة",
    "commission": "عمولة",
    "insurance": "تأمين",
    "hide_owner_details": "إخفاء تفاصيل المالك",
    "show_owner_details": "عرض تفاصيل المالك",
    "apartment_owner": "مالك الشقة",
    "loading_owner_details": "جاري تحميل تفاصيل المالك...",
    "no_owner_information": "لا توجد معلومات عن المالك",
    "lives_on_property": "يعيش في العقار",
    "yes": "نعم",
    "no": "لا",
    "total_apartments": "إجمالي الشقق",
    "apartment_details": "تفاصيل الشقة",
    "apartment_number": "رقم الشقة",
    "unknown": "غير معروف",
    "floor": "الطابق",
    "apartment_type": "نوع الشقة",
    "standard": "قياسي",
    "furnished": "مفروشة",
    "view_owner_profile": "عرض ملف المالك",
    "mark_as_inactive": "تعيين كغير نشط",
    "mark_as_active": "تعيين كنشط",
    "record_payment": "تسجيل دفعة",
    "view_details": "عرض التفاصيل",
    "edit_tenant": "تعديل المستأجر",
    "delete_tenant": "حذف المستأجر",
    "to": "إلى",
    "payment": "الدفع",
    "apartment_financial_details": "تفاصيل الشقة والمالية",
    "not_authenticated": "غير مصرح. الرجاء تسجيل الدخول.",
    "authentication_required": "التوثيق مطلوب",
    "authentication_failed": "فشل التوثيق. الرجاء تسجيل الدخول مرة أخرى.",
    "access_denied": "تم رفض الوصول. دور المسؤول مطلوب.",
    "server_error": "خطأ في الخادم. يرجى التحقق مما إذا كان الخادم الخلفي يعمل.",
    "cannot_connect_to_server": "لا يمكن الاتصال بالخادم. يرجى التحقق مما إذا كان الخادم الخلفي يعمل على المنفذ 3000.",
    "failed_to_load_tenants_data": "فشل في تحميل بيانات المستأجرين",
    "unknown_error": "خطأ غير معروف",
    "failed_to_delete_tenant": "فشل في حذف المستأجر",
    "confirm_bulk_delete": "هل أنت متأكد أنك تريد حذف {count} مستأجرين؟ هذا الإجراء لا يمكن التراجع عنه.",
    "failed_to_delete_tenants": "فشل في حذف المستأجرين",
    "failed_to_update_tenant_status": "فشل في تحديث حالة المستأجر",
    "pending": "قيد الانتظار",
    "paid": "مدفوع",
    "late": "متأخر",
    "overdue": "متأخر جداً",

    "loading_payment_data": "جاري تحميل بيانات الدفع...",
    "error_loading_payment": "خطأ في تحميل الدفعة",
    "payment_not_found": "لم يتم العثور على الدفعة",
    "back_to_payments": "العودة إلى المدفوعات",
    "confirm_deletion": "تأكيد الحذف",
    "delete_payment_confirmation": "هل أنت متأكد من حذف هذه الدفعة البالغة {{amount}}؟ لا يمكن التراجع عن هذا الإجراء.",
    "cancel": "إلغاء",
    "deleting": "جاري الحذف...",
    "delete": "حذف",
    "print_receipt": "طباعة الإيصال",
    "edit": "تعديل",
    "tenant": "المستأجر",
    "unknown_tenant": "مستأجر غير معروف",
    "apartment": "الشقة",
    "apt": "شقة",
    "none": "لا يوجد",
    "payment_period": "فترة الدفع",
    "payment_details": "تفاصيل الدفع",
    "tenant_information": "معلومات المستأجر",
    "payment_information": "معلومات الدفع",
    "amount": "المبلغ",
    "payment_date": "تاريخ الدفع",
    "payment_type": "نوع الدفع",
    "created": "تم الإنشاء",
    "last_updated": "آخر تحديث",
    "notes": "ملاحظات",
    "view_tenant": "عرض المستأجر",
    "unknown_period": "فترة غير معروفة",
    "to": "إلى",
    "invalid_period_data": "بيانات فترة غير صالحة",
    "unknown_type": "نوع غير معروف",
    "unknown": "غير معروف",
    "failed_to_load_payment_data": "فشل في تحميل بيانات الدفع",
    "failed_to_delete_payment": "فشل في حذف الدفعة",

    "rent": "إيجار",
    "service": "رسوم خدمة",
    "deposit": "تأمين",
    "maintenance": "صيانة",
    "other": "أخرى",

    "generate": "أضف",
    "generated": "تمت الإضافة",

    "generate_payment_for": "إنشاء دفعة لـ",
    "payment_amount": "مبلغ الدفع",
    "enter_amount": "أدخل المبلغ",
    "mark_as_paid_immediately": "وضع علامة كمدفوع فوراً",
    "notes": "ملاحظات",
    "payment_notes": "ملاحظات الدفع",
    "required_fields": "الحقول المطلوبة",
    "cancel": "إلغاء",
    "generate_payment": "إنشاء الدفعة",

    'add_new_user': 'إضافة مستخدم جديد',
    'search_users': 'بحث المستخدمين',
    'total_users': 'إجمالي المستخدمين',
    'active_users': 'المستخدمون النشطون',
    'inactive_users': 'المستخدمون غير النشطين',
    'financial_summary': 'الملخص المالي',
    'filters': 'المرشحات',
    'search_tenant_by_name_phone_or_apartment': 'البحث عن المستأجر حسب الاسم أو الهاتف أو الشقة',
    'view_profile': 'عرض الملف الشخصي',

    // WhatsApp
    'whatsapp_settings': 'إعدادات واتساب',
    'whatsapp_settings_description': 'إشعارات واتساب التلقائية للمستأجرين والملاك',
    'whatsapp_enable': 'تفعيل إشعارات واتساب',
    'whatsapp_enable_sub': 'تشغيل أو إيقاف جميع رسائل واتساب التلقائية',
    'general_settings': 'الإعدادات العامة',
    'default_country_code': 'رمز البلد الافتراضي',
    'tenant_rent_reminder': 'تذكير إيجار المستأجر',
    'tenant_rent_reminder_sub': 'إرسال تذكير للمستأجرين قبل أو بعد موعد الدفع',
    'days_before_due': 'عدد الأيام قبل الاستحقاق',
    'reminder_message_template': 'نص الرسالة',
    'service_fee_reminder': 'تذكير رسوم الخدمة',
    'enable_service_fee_reminder': 'تفعيل تذكير رسوم الخدمة',
    'service_fee_reminder_sub': 'إشعار المستأجرين بمدفوعات الخدمة القادمة',
    'owner_reminder': 'تذكير المالك',
    'enable_owner_reminders': 'تفعيل تذكيرات الملاك',
    'owner_reminder_sub': 'إشعار الملاك عند تأخر المستأجرين في الدفع',
    'owner_message_template': 'نص رسالة المالك',
    'payment_confirmation': 'تأكيد الدفع',
    'send_on_payment': 'إرسال تأكيد عند تسجيل الدفعة',
    'payment_confirmation_sub': 'يُرسل تلقائياً للمستأجر فور تسجيل دفعته',
    'payment_confirmation_template': 'نص رسالة تأكيد الدفع',
    'whatsapp_test_send': 'إرسال رسالة اختبارية',
    'test_message': 'الرسالة',
    'send_test_message': 'إرسال رسالة اختبارية',
    'whatsapp_test_sent': 'تم إرسال رسالة الاختبار!',
    'whatsapp_test_default_message': 'رسالة اختبارية من نظام إدارة العقارات',
    'send_reminders_now': 'إرسال التذكيرات الآن',
    'send_reminders_now_description': 'إرسال فوري للتذكيرات لجميع المستأجرين والملاك الذين يحتاجونها الآن.',
    'whatsapp_must_be_enabled': 'يجب تفعيل واتساب أولاً',
    'failed_to_load_settings': 'فشل تحميل الإعدادات',
    'settings_saved': 'تم حفظ الإعدادات بنجاح',
    'failed_to_save': 'فشل الحفظ',
    'failed_to_send': 'فشل الإرسال',
    'server_error': 'خطأ في الاتصال بالخادم',
    'sent': 'تم الإرسال',
    'errors': 'أخطاء',
    'skipped': 'تجاوز',

    // Bookings
    'bookings': 'الحجوزات',
    'booking_management': 'إدارة الحجوزات',
    'new_booking': 'حجز جديد',
    'create_booking': 'إنشاء حجز',
    'edit_booking': 'تعديل الحجز',
    'booking_details': 'تفاصيل الحجز',
    'prospect': 'العميل المتوقع',
    'prospect_name': 'اسم العميل',
    'prospect_name_placeholder': 'مثال: محمد أحمد',
    'prospect_phone': 'رقم الهاتف',
    'prospect_phone_placeholder': '+964 770 000 0000',
    'prospect_email_placeholder': 'john@example.com',
    'prospect_email': 'البريد الإلكتروني',
    'move_in_date': 'تاريخ الانتقال للسكن',
    'move_out_date': 'تاريخ المغادرة',
    'hold_duration': 'مدة الحجز',
    'hold_hours': 'ساعات الحجز',
    'hold_expiration': 'انتهاء الحجز',
    'internal_notes': 'ملاحظات داخلية',
    'check_availability': 'التحقق من التوفر',
    'checking_availability': 'جاري التحقق من التوفر...',
    'no_bookings_found': 'لم يتم العثور على حجوزات',
    'calendar_view': 'عرض التقويم',
    'waitlist': 'قائمة الانتظار',
    'new_booking_hold': 'حجز وحدة جديد',
    'property_information': 'معلومات العقار',
    'prospect_details': 'تفاصيل العميل',
    'requested_dates': 'التواريخ المطلوبة',
    'conflict_detected': 'تم اكتشاف تعارض',
    'booking_timeline': 'الجدول الزمني للحجوزات',
    'monthly_view_holds': 'عرض شهري للحجوزات النشطة',
    'confirmed_hold': 'حجز مؤكد',
    'pending_payment': 'في انتظار الدفع',
    'move_in': 'تاريخ الدخول',
    'move_out': 'تاريخ الخروج',
    'convert_to_tenant': 'تحويل إلى مستأجر',
    'confirm_booking': 'تأكيد الحجز',
    'cancel_booking': 'إلغاء الحجز',
    'at_12_pm': 'الساعة 12:00 ظهراً',
    'extending': 'جارٍ التمديد...',
    'renewing': 'جارٍ التجديد...',
    'cancel_booking_question': 'هل أنت متأكد من إلغاء هذا الحجز؟',
    'yes_cancel': 'نعم، إلغاء',
    'keep_it': 'إبقاء',
    'cancellation_reason': 'سبب الإلغاء',
    'booking_confirmed': 'تم تأكيد الحجز',
    'booking_cancelled': 'تم إلغاء الحجز',
    'booking_converted': 'تم تحويل الحجز إلى مستأجر بنجاح!',
    'process_to_booking': 'تحويل إلى حجز',
    'waitlist_management': 'إدارة قائمة الانتظار',
    'waitlist_empty': 'قائمة الانتظار فارغة',
    'search_waitlist': 'البحث في قائمة الانتظار...',
    'priority': 'الأولوية',
    'desired_unit': 'الوحدة المطلوبة',
    'move_in_preference': 'تفضيل تاريخ الدخول',
    'added': 'تمت الإضافة',
    'rank': 'المرتبة',
    'process_waitlist_success': 'تم التحويل إلى حجز معلق بنجاح!',
    'remove_from_waitlist': 'هل أنت متأكد من حذف هذا الإدخال من قائمة الانتظار؟',
    'entry_removed': 'تم حذف الإدخال',
    'hold_expires': 'ينتهي الحجز',
    'hours': 'ساعات',
    'optional': 'اختياري',
    'apartment_element': 'عنصر الشقة',
    'select_unit': 'اختر الوحدة',
    'error_loading_data': 'فشل تحميل البيانات',
    'error_saving_booking': 'خطأ في حفظ الحجز',
    'save_changes': 'حفظ التغييرات',
    'select_apartment_move_in_date_error': 'يرجى اختيار الشقة وتاريخ الدخول للتحقق من التوفر',
    'apartment_available': 'الشقة متاحة لهذه التواريخ!',
    'error_checking_availability': 'خطأ في التحقق من التوفر',
    'confirm_conflict_booking': 'هناك تعارض في المواعيد. هل أنت متأكد من المتابعة؟',
    'booking_updated': 'تم تحديث الحجز بنجاح',
    'booking_number': 'حجز رقم {{id}}',
    'created_at': 'تم الإنشاء في {{date}}',
    'created_by': 'بواسطة {{name}}',
    'system': 'النظام',
    'confirm': 'تأكيد',
    'target_property': 'العقار المستهدف',
    'furnished': 'مؤثث',
    'unfurnished': 'غير مؤثث',
    'booking_window': 'فترة الحجز',
    'indefinite': 'غير محدد',
    'created_source': 'تم الإنشاء ({{source}})',
    'view_tenant_profile': 'عرض الملف الشخصي للمستأجر',
    'convert_to_active_tenant': 'التحويل إلى مستأجر نشط',
    'lease_details_move_in_instruction': 'أكمل تفاصيل العقد التالية لنقل {{name}} إلى الوحدة {{unit}}.',
    'monthly_rent': 'الإيجار الشهري',
    'first_payment_date': 'تاريخ الدفعة الأولى',
    'contract_start': 'بداية العقد',
    'contract_end': 'نهاية العقد',
    'confirm_convert': 'تأكيد وتحويل',
    'confirm_booking_question': 'تأكيد الحجز: هل أنت متأكد من رغبتك في تثبيت هذا الحجز وحجز الوحدة لهذا العميل؟',
    'reason_optional': 'يرجى تقديم سبب (اختياري):',
    'amount': 'المبلغ',
    'today': 'اليوم',
    'sun': 'الأحد',
    'mon': 'الأثنين',
    'tue': 'الثلاثاء',
    'wed': 'الأربعاء',
    'thu': 'الخميس',
    'fri': 'الجمعة',
    'sat': 'السبت',
    'more': 'أكثر',
    'close': 'إغلاق',
    'hold_expiration': 'انتهاء صلاحية الحجز',
    'view_details': 'عرض التفاصيل',
    'waitlist_management': 'إدارة قائمة الانتظار',
    'search_waitlist': 'البحث في قائمة الانتظار...',
    'waitlist_empty': 'قائمة الانتظار فارغة',
    'no_prospective_tenants_waiting': 'لا يوجد مستأجرون محتملون ينتظرون توفر الشقق حالياً.',
    'priority': 'الأولوية',
    'rank': 'المرتبة: {{priority}}',
    'desired_unit': 'الوحدة المطلوبة',
    'move_in_preference': 'تفضيل الانتقال',
    'process_to_booking': 'المعالجة إلى حجز',
    'remove': 'إزالة',
    'remove_waitlist_confirm': 'هل أنت متأكد من رغبتك في إزالة هذا الإدخال من قائمة الانتظار؟',
    'waitlist_processed': 'تم التحويل بنجاح إلى حجز معلق!',
    'entry_removed': 'تمت إزالة الإدخال',
    'failed_process_waitlist': 'فشل معالجة إدخال قائمة الانتظار',
    'failed_remove_entry': 'فشل إزالة الإدخال',
    'booking_analytics': 'إحصائيات الحجز',
    'track_conversion_and_holds': 'تتبع معدلات التحويل ومدة الحجز',
    'last_7_days': 'آخر 7 أيام',
    'last_30_days': 'آخر 30 يوماً',
    'last_90_days': 'آخر 90 يوماً',
    'last_year': 'السنوات الماضية',
    'total_bookings': 'إجمالي الحجوزات',
    'in_selected_period': 'في الفترة المختارة',
    'conversion_rate': 'معدل التحويل',
    'converted_to_tenants': '{{count}} تحولوا إلى مستأجرين',
    'cancellation_rate': 'معدل الإلغاء',
    'cancelled_holds': '{{count}} حجوزات ملغاة',
    'avg_hold_time': 'متوسط وقت الحجز',
    'before_conversion_cancel': 'قبل التحويل/الإلغاء',
    'volume_trends': 'اتجاهات الحجم',
    'no_trend_data': 'لا توجد بيانات اتجاهات متاحة',
    'total_holds': 'إجمالي الحجوزات',
    'status_breakdown': 'تحليل الحالة',
    'no_status_data': 'لا توجد بيانات حالة متاحة',
    'active_holds': 'الحجوزات النشطة',
    'apartment_unit_display': 'شقة {{number}} - الطابق {{floor}}',
    'pending_move_in': 'قيد الانتظار للانتقال',
    'tenant_name': 'الاسم',
    'tenant_phone': 'رقم الهاتف',
    'tenant_email': 'البريد الإلكتروني',
    'lease_details': 'تفاصيل عقد الإيجار',
    'start_date': 'تاريخ البدء',
    'end_date': 'تاريخ الانتهاء',
    'monthly_pay_date': 'تاريخ الدفع الشهري',
    'day_number': 'يوم {{number}}',
    'duration': 'المدة',
    'months': 'أشهر',
    'remaining_time': 'الوقت المتبقي',
    'financial_summary': 'ملخص مالي',
    'monthly_rent': 'الإيجار الشهري',
    'effective_rent': 'الإيجار الفعلي',
    'rent_status': 'حالة الإيجار',
    'future_tenant_upcoming_move_in': 'المستأجر المستقبلي (انتقال قادم)',
    'move_in_date': 'تاريخ الانتقال',
    'contract_end': 'نهاية العقد',
    'recent_bookings': 'الحجوزات والموافقات الأخيرة',
    'new_hold': 'حجز جديد',
    'available_now': 'متاح الآن',
    'lease_ending_soon': 'ينتهي الإيجار قريبًا',
    'no_apartments_found': 'لم يتم العثور على شقق مناسبة',
    'ready': 'جاهز',
    'ends_in_days': 'ينتهي خلال {{count}} يوم',
    'search_unit': 'البحث عن شقة...',
    'currently_occupied': 'مشغولة حالياً',
    'occupied': 'مشغولة',
    'occupied_status': 'مشغولة',
    'financial_status': 'الحالة المالية',
    'occupancy_physical': 'الإيجار الفعلي',
    'unit_indicators': 'مؤشرات الوحدة',
    'furnished_unit': 'وحدة مجهزة',
    'lease_expired_short': 'إنتهاء العقد',
    'lease_ended_short': 'إنتهاء العقد',
    'expired_label': 'إنتهاء العقد',
    'partial': 'جزئي',
    'scheduled_tenants': 'المستأجرون المجدولون',
    'multiple_leases': 'عقود إيجار متعددة',
    'current_end_date': 'تاريخ الانتهاء الحالي',
    'new_end_date': 'تاريخ الانتهاء الجديد',
    'extend': 'تمديد',
    'transfer': 'نقل',
    'expired': 'منتهي',
    'transfer_apartment': 'نقل الشقة',
    'current_apartment': 'الشقة الحالية',
    'select_new_apartment': 'اختر الشقة الجديدة',
    'new_monthly_rent': 'الإيجار الشهري الجديد',
    'transferring': 'جاري النقل...',
    'failed_to_transfer_tenant': 'فشل نقل المستأجر',
    'tenant_transferred_success': 'تم نقل المستأجر بنجاح',
    'extend_lease': 'تمديد عقد الإيجار',
    'extend_lease_confirm': 'هل أنت متأكد من رغبتك في تمديد عقد الإيجار؟',
    'lease_extended_success': 'تم تمديد عقد الإيجار بنجاح',
    'select_option': 'اختر خيارًا',
    'invite_portal': 'دعوة إلى النظام ',
    'tenant_documents': 'وثائق المستأجر',
    'maintenance_requests': 'طلبات الصيانة',
    'add_request': 'إضافة طلب',
    'reported_on': 'تم الإبلاغ في',
    'send_portal_invitation': 'إرسال دعوة إلى النظام',
    'fully_signed': 'موقع بالكامل',
    'voided': 'ملغى',
    'upgrade_for_analytics': 'لتحليلات',
    'upgrade_analytics_message': 'لتحليلات',
    'view_plans': 'عرض الخطط',
    'choose_a_plan': 'اختر خطط',
    'subscribe_with_stripe': 'اشترك مع stripe',
    'manage_subscription': 'إدارة الاشتراك',
    'subscribe_with_stripe': 'اشترك مع stripe',
    'upgrade': 'ترقية',
    'contact_sales': 'اتصل ببيع',
    'no_payment_history': 'لا يوجد سجل دفع',
    'no_subscription_history': 'لا يوجد سجل اشتراك',

    // ID Documents (Tenant & Owner)
    'id_documents': 'وثائق الهوية',
    'id_document_front': 'الوجه الأمامي',
    'id_document_back': 'الوجه الخلفي',
    'id_document_type': 'نوع الوثيقة',
    'id_document_number': 'رقم الوثيقة',
    'id_document_uploaded_at': 'تاريخ الرفع',
    'select_document_type': 'اختر نوع الوثيقة',
    'national_id': 'الهوية الوطنية',
    'passport': 'جواز السفر',
    'driving_license': 'رخصة القيادة',
    'residence_permit': 'إقامة',
    'other_document': 'أخرى',
    'document_number_placeholder': 'أدخل رقم الوثيقة (اختياري)',
    'front_side': 'الوجه الأمامي',
    'back_side': 'الوجه الخلفي',
    'drag_drop_or_click': 'اسحب وأسقط أو اضغط للرفع',
    'supported_formats': 'مدعوم: JPG, PNG, WEBP (حد أقصى 5MB)',
    'upload_id_documents': 'رفع وثائق الهوية',
    'uploading': 'جاري الرفع...',
    'id_documents_uploaded': 'تم رفع وثائق الهوية بنجاح',
    'id_documents_upload_failed': 'فشل في رفع وثائق الهوية',
    'delete_document_side': 'حذف وثيقة {{side}}',
    'confirm_delete_document': 'هل أنت متأكد من حذف هذه الوثيقة؟',
    'document_deleted': 'تم حذف الوثيقة بنجاح',
    'document_delete_failed': 'فشل في حذف الوثيقة',
    'no_id_documents': 'لا توجد وثائق هوية مرفوعة بعد',
    'view_document': 'عرض الوثيقة',
    'close_preview': 'إغلاق المعاينة',
    'save_changes': 'حفظ التغييرات',
    'pending_upload': 'في انتظار الرفع',
    'id_documents_tab': 'وثائق الهوية',
    'tenant_id_documents': 'وثائق هوية المستأجر',
    'owner_id_documents': 'وثائق هوية المالك',
    'id_documents_description': 'رفع وإدارة صور وثائق الهوية',

    'waitlist': 'قائمة الانتظار',
    'waitlist_management': 'إدارة قائمة الانتظار',
    'search_waitlist': 'ابحث بالاسم أو الهاتف أو الوحدة...',
    'waitlist_empty': 'قائمة الانتظار فارغة',
    'no_prospective_tenants_waiting': 'لا يوجد مستأجرين محتملين ينتظرون وحدة حاليًا.',

    // Waitlist table columns
    'priority': 'الأولوية',
    'prospect': 'المستأجر المحتمل',
    'desired_unit': 'الوحدة المطلوبة',
    'move_in_preference': 'تفضيل الانتقال',
    'added': 'تاريخ الإضافة',
    'rank': '#{{priority}}',
    'process_to_booking': 'تحويل إلى حجز',
    'remove': 'إزالة',
    'remove_from_waitlist': 'إزالة من قائمة الانتظار',
    'remove_waitlist_confirm': 'هل أنت متأكد من رغبتك في إزالة هذا المستأجر المحتمل من قائمة الانتظار؟ لا يمكن التراجع عن هذا الإجراء.',

    // Waitlist status messages
    'waitlist_processed': 'تم تحويل المستأجر المحتمل إلى حجز مؤجل بنجاح',
    'failed_process_waitlist': 'فشل تحويل هذا الإدخال في قائمة الانتظار إلى حجز',
    'entry_removed': 'تم إزالة الإدخال من قائمة الانتظار',
    'failed_remove_entry': 'فشل إزالة الإدخال من قائمة الانتظار',

    // Add to Waitlist Modal
    'add_to_waitlist': 'إضافة إلى قائمة الانتظار',
    'waitlist_form_subtitle': 'سيتم ترقية المستأجر المحتمل تلقائيًا عندما تصبح الوحدة متاحة',
    'desired_unit': 'الوحدة المطلوبة',
    'prospect_details': 'تفاصيل المستأجر المحتمل',
    'prospect_name': 'اسم المستأجر المحتمل',
    'prospect_phone': 'هاتف المستأجر المحتمل',
    'prospect_email': 'بريد المستأجر المحتمل',
    'scheduling_priority': 'الجدولة والأولوية',
    'preferred_move_in_date': 'تاريخ الانتقال المفضل',
    'higher_is_first': 'الأعلى = أول في الطابور',
    'priority_hint': 'المستأجرون ذوو الأولوية الأعلى يتقدمون في الطابور. الافتراضي هو 0 (FIFO).',
    'priority_range_error': 'يجب أن تكون الأولوية بين 0 و 10',
    'loading_apartments': 'جاري تحميل الشقق...',
    'field_required': 'هذا الحقل مطلوب',
    'adding': 'جاري الإضافة...',
    'added_to_waitlist': 'تم إضافة المستأجر المحتمل إلى قائمة الانتظار بنجاح',
    'failed_add_waitlist': 'فشل إضافة المستأجر المحتمل إلى قائمة الانتظار',
    'waitlist_auto_promote_info': 'عندما تصبح الشقة المحددة متاحة، سيتم تحويل هذا المستأجر المحتمل تلقائيًا إلى حجز مؤجل بناءً على أولويته وموقعه في الطابور.',
    'waitlist_notes_placeholder': 'المتطلبات الخاصة، مصدر العميل، ملاحظات الوكيل...',

    // ── Maintenance Hub ───────────────────────────────────────────
    'maintenance_hub': 'مركز الصيانة',
    'track_and_assign_maintenance': 'تتبع طلبات المستأجرين وتعيين أوامر العمل للموردين',
    'search_requests': 'ابحث حسب المشكلة أو المستأجر أو الشقة...',
    'loading_requests': 'جاري تحميل الطلبات...',
    'no_maintenance_found': 'لم يتم العثور على طلبات صيانة',
    'issue': 'المشكلة',
    'location': 'الموقع',
    'tenant': 'المستأجر',
    'assign_vendor': 'تعيين مورد',
    'update_status': 'تحديث الحالة',
    'status_updated': 'تم تحديث الحالة بنجاح',
    'error_updating_status': 'خطأ في تحديث الحالة',
    'error_fetching_data': 'خطأ في جلب البيانات',

    // Work Orders
    'create_work_order': 'إنشاء أمر عمل',
    'work_order_created': 'تم إنشاء أمر العمل وتعيينه',
    'error_creating_work_order': 'خطأ في إنشاء أمر العمل',
    'select_vendor': 'اختر موردًا',
    'select_a_vendor': 'اختر موردًا',
    'estimated_cost': 'التكلفة التقديرية',
    'scheduled_date': 'التاريخ المجدول',
    'work_description': 'وصف العمل',

    // Maintenance statuses
    'open': 'مفتوح',
    'in_progress': 'قيد التنفيذ',
    'completed': 'مكتمل',
    'cancelled': 'ملغى',

    // ── Vendor Management ─────────────────────────────────────────
    'vendor_management': 'إدارة الموردين',
    'manage_maintenance_vendors': 'إدارة مقاولي الصيانة الخارجيين ومقدمي الخدمات',
    'add_vendor': 'إضافة مورد',
    'add_new_vendor': 'إضافة مورد جديد',
    'edit_vendor': 'تعديل المورد',
    'search_vendors': 'ابحث حسب اسم المورد أو الفئة...',
    'no_vendors_found': 'لم يتم العثور على موردين',
    'vendor_name': 'اسم المورد',
    'category': 'الفئة',
    'contact_person': 'الشخص المسؤول',
    'vendor_created': 'تم إنشاء المورد بنجاح',
    'vendor_updated': 'تم تحديث المورد بنجاح',
    'vendor_deleted': 'تم حذف المورد بنجاح',
    'update_vendor': 'تحديث المورد',
    'save_vendor': 'حفظ المورد',
    'confirm_delete_vendor': 'هل أنت متأكد من رغبتك في حذف هذا المورد؟ لا يمكن التراجع عن هذا الإجراء.',
    'error_fetching_vendors': 'خطأ في جلب الموردين',
    'error_saving_vendor': 'خطأ في حفظ المورد',
    'error_deleting_vendor': 'خطأ في حذف المورد',
    'confirm_delete_vendor_title': 'حذف المورد',
    'vendor_no_email': 'المورد ليس لديه عنوان بريد إلكتروني',
    'vendor_invite_saved': 'تم حفظ الدعوة!',
    'vendor_invite_link_copied': 'تم نسخ رابط الإعداد إلى الحافظة',
    'vendor_invite_failed': 'فشل إرسال الدعوة',
    'vendor_invite_portal': 'دعوة إلى بوابة الموردين',
    'vendor_category_placeholder': 'مثال: سباكة، تقنية المعلومات، كهرباء',
    'vendor_1099_nec': 'المورد 1099-NEC',
    'vendor_1099_desc': 'تقرير IRS السنوي — الموردون الذين دفعوا ≥ 600 دولار كتعويض لغير الموظفين',
    'vendor_1099_disclaimer': 'نماذج 1099-NEC مطلوبة لأي مورد (غير موظف) دفع ≥ 600 دولار في السنة التقويمية. الموعد النهائي لتقديم IRS عادةً 31 يناير. تحقق دائمًا مع متخصص ضريبي قبل التقديم.',
    '1099_required': 'مطلوب 1099',
    'no_vendor_payments_recorded': 'لا توجد مدفوعات موردين مسجلة لـ',

    // ── Contract Templates ────────────────────────────────────────
    'contract_templates': 'قوالب العقود',
    'manage_legal_templates_desc': 'إدارة الأطر القانونية والقواعد الآلية للعقود.',
    'create_template': 'إنشاء قالب',
    'search_templates': 'ابحث في القوالب...',
    'no_templates_found': 'لم يتم العثور على قوالب',
    'create_first_template_desc': 'ابدأ بإنشاء أول قالب قانوني للعقود.',
    'no_description_provided': 'لم يتم تقديم وصف.',
    'default_rules': 'القواعد الافتراضية',
    'failed_to_load_templates': 'فشل تحميل القوالب',
    'template_deleted_successfully': 'تم حذف القالب بنجاح',
    'failed_to_delete_template': 'فشل حذف القالب',
    'confirm_delete_template': 'هل أنت متأكد من رغبتك في حذف هذا القالب؟ لا يمكن التراجع عن هذا الإجراء.',

    // Contract Template Form
    'edit_template': 'تعديل القالب',
    'create_new_template': 'إنشاء قالب جديد',
    'template_details': 'تفاصيل القالب',
    'template_name': 'اسم القالب',
    'is_active': 'القالب النشط',
    'legal_text': 'محتوى النص القانوني',
    'default_variable_rules': 'قواعد المتغيرات الافتراضية',
    'default_rules_desc': 'حدد المتغيرات الافتراضية (مثل commission_rate) التي سيستخدمها المنشئ.',
    'add_rule': 'إضافة قاعدة',
    'no_default_rules': 'لم يتم تعريف قواعد افتراضية.',
    'variable_name_placeholder': 'اسم المتغير (مثل commission_rate)',
    'default_value_placeholder': 'القيمة الافتراضية (مثل 8)',
    'archive_template': 'أرشفة القالب',
    'archive_template_confirm': 'هل أنت متأكد من رغبتك في أرشفة هذا القالب؟ لن يكون متاحًا للعقود الجديدة.',
    'archive': 'أرشفة',
    'template_archived_successfully': 'تم أرشفة القالب بنجاح',
    'failed_to_archive_template': 'فشل أرشفة القالب',
    'template_updated_successfully': 'تم تحديث القالب بنجاح',
    'template_created_successfully': 'تم إنشاء القالب بنجاح',
    'failed_to_save_template': 'فشل حفظ القالب',
    'failed_to_load_template': 'فشل تحميل القالب',

    // Contract types
    'management': 'إدارة',
    'lease': 'تأجير',
    'sale': 'بيع',
    'lease_progress': 'تقدم عقد الإيجار',
    'status_open': 'مفتوح',
    'status_in_progress': 'قيد التنفيذ',
    'status_completed': 'مكتمل',
    'status_cancelled': 'ملغي',
    'priority_low': 'منخفض',
    'priority_medium': 'متوسط',
    'priority_high': 'عالي',
    'priority_urgent': 'عاجل',
    'priority_emergency': 'طوارئ',
    'estimated_cost': 'التكلفة التقديرية',
    'tenant_portal_submissions': 'مرفقات بوابة المستأجر',
    'portal_submission_note': 'ملفات رفعها المستأجر عبر بوابة الخدمة الذاتية',
    'tenant_proof_document': 'هوية / وثيقة إثبات',
    'tenant_insurance_document': 'تأمين / شهادة',
    'not_submitted': 'لم يُرسل',
    'saved': 'محفوظ',
    'payment_method': 'الطريقة',
    'tenant_ledger': 'دفتر أستاذ المستأجر',
    'ledger_description': 'سجل غير قابل للتغيير لجميع الرسوم والمدفوعات. أضف قيوداً ائتمانية لتصحيح الأخطاء.',
    'ledger_generate_monthly': 'إنشاء شهري',
    'ledger_add_charge': 'إضافة رسوم',
    'ledger_add_credit': 'إضافة رصيد',
    'ledger_apply_late_fee': 'تطبيق غرامة التأخر',
    'ledger_late_fee': 'غرامة التأخر',
    'ledger_charge': 'رسوم',
    'ledger_deposit': 'وديعة',
    'ledger_payment': 'دفعة',
    'ledger_credit': 'رصيد',
    'ledger_charge_rent_fee': 'رسوم (إيجار / رسوم أخرى)',
    'ledger_description_placeholder': 'مثال: رسوم الصيانة',
    'outstanding_balance': 'الرصيد المستحق',
    'ledger_balance_note': 'مشتق من جميع قيود دفتر الأستاذ',
    'ledger_total_entries': 'إجمالي القيود',
    'ledger_no_entries': 'لا توجد قيود في دفتر الأستاذ',
    'ledger_no_entries_hint': 'أنشئ أول رسوم شهرية أو سجّل رسوماً يدوية من الأعلى.',
    'ledger_balance_after': 'الرصيد بعد',
    'ledger_charge_added': 'تمت إضافة الرسوم إلى دفتر الأستاذ',
    'ledger_charge_failed': 'فشل إضافة الرسوم',
    'ledger_credit_added': 'تمت إضافة الرصيد إلى دفتر الأستاذ',
    'ledger_credit_failed': 'فشل إضافة الرصيد',
    'ledger_late_fee_applied': 'تم تطبيق غرامة التأخر على دفتر الأستاذ',
    'ledger_late_fee_failed': 'فشل تطبيق غرامة التأخر',
    'ledger_monthly_generated': 'تم إنشاء الرسوم الشهرية',
    'ledger_monthly_failed': 'فشل إنشاء الرسوم',
    'ledger_load_failed': 'فشل تحميل دفتر الأستاذ',
    'created_by': 'أنشأه',
    'expired': 'منتهي',
    'expiring_soon': 'ينتهي قريباً',
    'email': 'البريد الإلكتروني',

    // ── بوابة المستأجر ────────────────────────────────────────────────────────

    // لوحة التحكم
    'failed_to_load_dashboard_data': 'فشل في تحميل بيانات لوحة التحكم',
    'welcome_back_user': 'أهلاً بعودتك، {{name}}',
    'tenancy_overview': 'نظرة عامة على إيجارك',
    'unit_display': 'وحدة {{number}}',
    'current_balance': 'الرصيد الحالي',
    'action_required': 'إجراء مطلوب',
    'account_good_standing': 'الحساب في وضع جيد',
    'lease_ends': 'ينتهي العقد',
    'view_lease_short': 'عرض العقد',
    'need_repairs': 'تحتاج إلى إصلاحات؟',
    'repairs_subtitle': 'أرسل طلب صيانة',
    'create_request': 'إنشاء طلب',
    'quick_actions': 'الإجراءات السريعة',
    'pay_now': 'ادفع الآن',
    'recent_account_activity': 'النشاط الحديث للحساب',
    'view_ledger': 'عرض دفتر الأستاذ',
    'no_ledger_entries_yet': 'لا توجد قيود بعد',
    'active_maintenance': 'الصيانة النشطة',
    'view_all': 'عرض الكل',
    'all_clear_maintenance': 'لا توجد طلبات مفتوحة',
    'maintenance_request_default': 'طلب صيانة',
    'building_news': 'أخبار المبنى',
    'lease_progress': 'تقدم العقد',
    'days_left': 'متبقي {{days}} يوم',
    'expires_today': 'ينتهي اليوم!',
    'pct_elapsed': '{{pct}}% مضى',
    'balance_after': 'بعد:',

    // المدفوعات
    'failed_to_load_payment_data': 'فشل في تحميل بيانات المدفوعات',
    'failed_to_initiate_payment': 'فشل في بدء الدفع',
    'payments_billing': 'المدفوعات والفواتير',
    'payments_billing_subtitle': 'سجل الإيجار ورسوم الخدمات ودفتر الأستاذ الكامل',
    'download_statement': 'تحميل الكشف',
    'current_amount_due': 'المبلغ المستحق الحالي',
    'due_on': 'يستحق في',
    'view_ledger_hint': 'هل تريد رؤية كيفية احتساب ذلك؟',
    'view_your_ledger': 'عرض دفتر الأستاذ',
    'in_n_days': 'خلال {{count}} يوم',
    'in_n_days_plural': 'خلال {{count}} أيام',
    'due_today': '⚡ مستحق اليوم',
    'all_paid_up': 'كل شيء مدفوع!',
    'tab_rent_payments': 'مدفوعات الإيجار',
    'tab_service_charges': 'رسوم الخدمات',
    'tab_service_charges_due': 'رسوم الخدمات ({{count}} مستحقة)',
    'tab_account_ledger': 'دفتر الحساب',
    'transaction_history': 'سجل المعاملات',
    'no_transactions': 'لا توجد معاملات بعد',
    'no_transactions_subtitle': 'سيظهر سجل مدفوعاتك هنا بمجرد تسجيل المدفوعات.',
    'rejected': 'مرفوض',
    'outstanding_service_charges': 'رسوم الخدمات المعلقة',
    'paid_service_history': 'سجل الخدمات المدفوعة',
    'service_charge_default': 'رسوم خدمة',
    'pay': 'دفع',
    'paid_badge': 'مدفوع',
    'no_service_charges': 'لا توجد رسوم خدمة',
    'no_service_charges_subtitle': 'ليس لديك رسوم خدمة في هذا الوقت.',
    'account_balance': 'رصيد الحساب',
    'ledger_calculated_from': 'محسوب من {{count}} قيد',
    'full_account_statement': 'كشف الحساب الكامل',
    'full_account_statement_subtitle': 'كل رسوم ومدفوعات حسابك مع الأرصدة الجارية.',
    'balance_after_col': 'الرصيد بعد',
    'no_ledger_entries': 'لا توجد قيود بعد',
    'no_ledger_entries_subtitle': 'سيظهر تاريخك المالي هنا بمجرد ترحيل الرسوم.',
    'ledger_type_charge': 'رسوم',
    'ledger_type_late_fee': 'غرامة تأخر',
    'ledger_type_deposit': 'تأمين',
    'ledger_type_payment': 'دفعة',
    'ledger_type_credit': 'رصيد دائن',
    'payment_success_stripe': 'تم الدفع بنجاح! سيتم تحديث حسابك قريباً.',
    'payment_cancelled_stripe': 'تم إلغاء الدفع. لم يتم خصم أي مبلغ.',
    'online_payments_not_enabled': 'المدفوعات الإلكترونية غير مفعلة بعد.',

    // العقد
    'failed_to_load_lease_details': 'فشل في تحميل تفاصيل العقد',
    'lease_signed_success': 'تم توقيع العقد بنجاح!',
    'failed_to_sign_lease': 'فشل في توقيع العقد',
    'lease_pdf_download_success': 'تم تحميل العقد بصيغة PDF بنجاح',
    'lease_pdf_download_failed': 'فشل في تحميل العقد. يرجى المحاولة مجدداً.',
    'generating': 'جارٍ التحضير…',
    'download_pdf': 'تحميل PDF',
    'download_your_lease': 'تحميل عقدك الموقع بصيغة PDF',
    'unit_prefix': 'وحدة',
    'ip_trace': 'تتبع IP:',
    'integrity_hash': 'رمز التحقق:',
    'signature_graphic': 'صورة التوقيع:',
    'lease_details': 'تفاصيل العقد',
    'lease_details_subtitle': 'اتفاقية إيجارك النشطة ومعلومات الدفع',
    'lease_signed': 'موقع',
    'sign_lease_now': 'وقّع العقد الآن',
    'contract_term': 'مدة العقد',
    'start_date': 'تاريخ البدء',
    'end_date': 'تاريخ الانتهاء',
    'property_information': 'معلومات العقار',
    'landlord_owner': 'المالك / الملاك',
    'payment_status': 'حالة الدفع',
    'payment_required': 'الدفع مطلوب',
    'e_signature_recorded': 'تم تسجيل التوقيع الإلكتروني',
    'signed_on': 'تم التوقيع في',
    'legal_disclosure': 'الإفصاح القانوني',
    'legal_disclosure_text': 'يُعدّ هذا العقد ملزماً قانونياً. بتوقيعك إلكترونياً، فإنك توافق على جميع البنود والشروط. تأكد من قراءة الوثيقة كاملة قبل التوقيع.',
    'lease_not_found': 'لم يتم العثور على عقد',
    'contact_management_error': 'يرجى التواصل مع الإدارة إذا كنت تعتقد أن هذا خطأ.',

    // الملف الشخصي
    'my_profile': 'ملفي الشخصي',
    'my_profile_subtitle': 'تحديث معلومات الاتصال وكلمة المرور',
    'personal_information': 'المعلومات الشخصية',
    'full_name': 'الاسم الكامل',
    'your_full_name_placeholder': 'اسمك الكامل',
    'phone_placeholder': '+966 5X XXX XXXX',
    'email_placeholder': 'بريدك@المثال.com',
    'save_changes': 'حفظ التغييرات',
    'change_password': 'تغيير كلمة المرور',
    'current_password': 'كلمة المرور الحالية',
    'new_password': 'كلمة المرور الجديدة',
    'confirm_new_password': 'تأكيد كلمة المرور الجديدة',
    'min_8_chars': '8 أحرف على الأقل',
    'repeat_new_password': 'أعد كلمة المرور الجديدة',
    'update_password': 'تحديث كلمة المرور',
    'updating': 'جارٍ التحديث...',
    'passwords_do_not_match': 'كلمتا المرور غير متطابقتين',
    'password_min_8': 'يجب أن تكون كلمة المرور 8 أحرف على الأقل',
    'failed_to_load_profile': 'فشل في تحميل الملف الشخصي',
    'profile_updated': 'تم تحديث الملف الشخصي بنجاح!',
    'password_changed': 'تم تغيير كلمة المرور بنجاح!',
    'failed_to_update_profile': 'فشل في تحديث الملف الشخصي',
    'failed_to_change_password': 'فشل في تغيير كلمة المرور',
    'account_id': 'معرف الحساب',
    'tenant_since': 'مستأجر منذ',

    // التفتيش
    'my_inspections': 'تفتيشاتي',
    'my_inspections_subtitle': 'تقارير تفتيش العقار لوحدتك',
    'no_inspections_yet': 'لا توجد تفتيشات بعد',
    'no_inspections_subtitle': 'ستظهر تقارير التفتيش المكتملة هنا.',
    'items_checked': '{{done}}/{{total}} بند تم فحصه',
    'inspection_items': 'بنود التفتيش',
    'general_notes': 'ملاحظات عامة',
    'failed_to_load_inspections': 'فشل في تحميل التفتيشات',
    'inspection_type_move_in': 'عند الدخول',
    'inspection_type_move_out': 'عند الخروج',
    'inspection_type_periodic': 'دوري',
    'inspection_type_maintenance': 'صيانة',
    'inspection_status_completed': 'مكتمل',
    'inspection_status_signed': 'موقع',
    'inspection_status_draft': 'مسودة',

    // الخدمات
    'service_charges_title': 'رسوم الخدمات',
    'service_charges_subtitle': 'رسوم خدمات المبنى الشهرية لوحدتك',
    'total_charges': 'إجمالي الرسوم',
    'outstanding_balance_label': 'الرصيد المعلق',
    'service_charges_year': 'رسوم الخدمات — {{year}}',
    'no_service_charges_year': 'لا توجد رسوم خدمة لعام {{year}}',
    'no_service_charges_year_hint': 'ستظهر رسوم الخدمات هنا عند إنشائها من قبل مدير المبنى.',
    'paid_on': 'مدفوعة في {{date}}',
    'unpaid': 'غير مدفوع',
    'pay_online': 'الدفع أونلاين',
    'service_paid_success': 'تم دفع رسوم الخدمة بنجاح!',
    'payment_canceled': 'تم إلغاء الدفع.',
    'failed_to_load_service_charges': 'فشل في تحميل رسوم الخدمات',

    // الرسائل
    'management_team': 'فريق الإدارة',
    'management_team_subtitle': 'رسالة مباشرة مع إدارة العقار',
    'message_empty_state': 'أرسل رسالة للتواصل مع الإدارة.',
    'message_placeholder': 'اكتب رسالة للإدارة...',
    'failed_to_load_messages': 'فشل في تحميل الرسائل',
    'failed_to_send_message': 'فشل في إرسال الرسالة',

    'portfolio_summary': 'ملخص المحفظة العقارية',
    'portfolio_subtitle': 'مؤشرات الأداء الحية لـ {{name}}.',
    'portfolio_statement': 'كشف المحفظة',
    'total_units': 'إجمالي الوحدات',
    'occupancy_rate': 'معدل الإشغال',
    'active_leases': '{{count}} عقد نشط',
    'monthly_revenue': 'الإيراد الشهري',
    'vacant_units': 'الوحدات الشاغرة',
    'installment_summary': 'ملخص الأقساط',
    'view_detailed_ledger': 'عرض دفتر الأستاذ التفصيلي',
    'outstanding': 'المعلق',
    'across_installments': 'عبر {{count}} قسط',
    'actions_required': '{{count}} إجراء فوري مطلوب',
    'proceed_to_payments': 'الانتقال إلى المدفوعات',
    'revenue_performance': 'أداء الإيرادات (آخر 6 أشهر)',
    'no_revenue_data': 'لا توجد بيانات إيرادات',
    'portfolio_distribution': 'توزيع المحفظة',
    'no_building_data': 'لا توجد بيانات مبنى',
    'occupied_label': 'مشغول',
    'ready_to_scale': 'هل أنت مستعد للتوسع؟',
    'ready_to_scale_subtitle': 'أدر عقاراتك بأقصى قدر من الرؤية.',
    'financials': 'الماليات',
    'approvals': 'الموافقات',
    'failed_to_download_statement': 'فشل في تحميل الكشف',
    'my_properties': 'عقاراتي',
    'my_properties_subtitle': 'نظرة عامة على جميع الوحدات في محفظتك الإدارية.',
    'portfolio_empty': 'المحفظة فارغة',
    'portfolio_empty_subtitle': 'لا توجد وحدات مخصصة لحسابك حالياً.',
    'floor_prefix': 'الطابق',
    'current_rent': 'الإيجار الحالي',
    'per_month_short': '/شهر',
    'sqm': 'م²',
    'maintenance_approvals': 'موافقات الصيانة',
    'maintenance_approvals_subtitle': 'راجع وافق على طلبات الإصلاح من المستأجرين.',
    'no_maintenance_requests': 'لا توجد طلبات صيانة',
    'no_maintenance_subtitle': 'جميع عقاراتك في حالة جيدة حالياً.',
    'pending_approval': 'في انتظار الموافقة',
    'approved_in_progress': 'تمت الموافقة / قيد التنفيذ',
    'rejected_cancelled': 'مرفوض/ملغى',
    'above_threshold': 'تجاوز حد ${{amount}}',
    'high_priority': 'أولوية عالية',
    'medium_priority': 'أولوية متوسطة',
    'low_priority': 'أولوية منخفضة',
    'est_cost': 'التكلفة التقديرية',
    'approve': 'موافقة',
    'reject': 'رفض',
    'request_status_updated': 'تم تحديث حالة الطلب',
    'failed_to_update_request': 'فشل في تحديث حالة الطلب',
    'failed_to_load_maintenance': 'فشل في تحميل طلبات الصيانة',
    'failed_to_load_properties': 'فشل في تحميل عقاراتك',
    'financial_overview': 'نظرة مالية عامة',
    'financial_subtitle': 'تتبع الإيرادات المتولدة من المستأجرين عبر جميع العقارات.',
    'no_financial_data': 'لا توجد بيانات مالية',
    'no_payments_message': 'لا توجد مدفوعات مسجلة لمحفظتك حالياً.',
    'recent_payments': 'المدفوعات الأخيرة',
    'overdue_payments': 'المدفوعات المتأخرة',
    'property_tenant': 'العقار / المستأجر',
    'gross_amount': 'المبلغ الإجمالي',
    'commission': 'العمولة',
    'net_amount': 'الصافي',
    'since': 'منذ',
    'amount_owed': 'المبلغ المستحق',
    'management_commission': 'عمولة الإدارة',
    'failed_to_load_financials': 'فشل في تحميل السجلات المالية',
    'statement_downloaded': 'تم تحميل كشف {{month}} {{year}}!',
    'member_since': 'عضو منذ',
    'saving': 'جارٍ الحفظ...',
    'owner_messages_title': 'إدارة العقارات',
    'owner_messages_subtitle': 'رسالة مباشرة مع فريق الإدارة',
    'owner_service_charges': 'رسوم الخدمات',
    'owner_service_charges_subtitle': 'رسوم خدمات المبنى الشهرية لوحداتك الشاغرة',
    'owner_service_info': 'تنطبق رسوم الخدمات فقط على وحداتك <strong>الشاغرة</strong>. يتم تحصيل الوحدات المشغولة من المستأجرين مباشرة.',
    'total_charges': 'إجمالي الرسوم',
    'outstanding_balance': 'الرصيد المستحق',
    'no_service_charges_year': 'لا توجد رسوم خدمات لعام {{year}}',
    'no_service_charges_subtitle': 'ستظهر رسوم الخدمات للوحدات الشاغرة هنا عند الإنشاء.',
    'paid_on': 'تم الدفع في {{date}}',
    'pay_online': 'الدفع إلكترونياً',
    'service_charge_paid': 'تم دفع رسوم الخدمة بنجاح!',
    'unpaid': 'غير مدفوع',
    'my_agreements': 'اتفاقياتي',
    'agreements_subtitle': 'عرض جميع عقود الإدارة وسجلات الملكية.',
    'no_active_agreements': 'لا توجد اتفاقيات نشطة',
    'no_contracts_message': 'لم يتم تسجيل أي عقود إدارية في نظامنا حتى الآن.',
    'total_value': 'القيمة الإجمالية',
    'remaining': 'المتبقي',
    'indefinite': 'غير محدد',
    'sign_now': 'وقّع الآن',
    'failed_to_load_agreements': 'فشل في تحميل الاتفاقيات',
    'financial_ledger': 'دفتر الأستاذ المالي',
    'ledger_subtitle': 'تفصيل أقساط رسوم الإدارة والأرصدة المعلقة.',
    'total_outstanding': 'إجمالي المعلق',
    'no_installments': 'لا توجد أقساط في دفتر أستاذك.',
    'settled': 'تم التسوية',
    'pay_amount': 'تدفع {{amount}}',
    'failed_to_load_installments': 'فشل في تحميل جدول الأقساط',
    'failed_to_initiate_payment': 'فشل في بدء الدفع',
    'error_connecting_payment': 'خطأ في الاتصال بمزود الدفع',
    'payment_success_msg': 'تمت عملية الدفع بنجاح!',
    'payment_canceled_msg': 'تم إلغاء الدفع.',
    'welcome_user': 'أهلاً بك، {{name}}؟',
    'owner_portal': 'بوابة المالك',
    'tenant_portal': 'بوابة المستأجر',
    'owner': 'مالك',
    'tenant': 'مستأجر',
    'core': 'رئيسي',
    'properties_&_contracts': 'العقارات والعقود',
    'financial': 'مالي',
    'financial_&_lease': 'مالي وإيجار',
    'Dashboard': 'لوحة التحكم',
    'Properties': 'العقارات',
    'Contracts': 'العقود',
    'Installments': 'الأقساط',
    'Service Charges': 'رسوم الخدمات',
    'Financials': 'المالية',
    'Maintenance': 'الصيانة',
    'Payments': 'المدفوعات',
    'Lease Details': 'تفاصيل عقد الإيجار',
    'Inspections': 'التفتيشات',
    'Profile': 'الملف الشخصي',
    'documents': 'الوثائق',
    'announcements': 'الإعلانات',
    'messages': 'الرسائل',
    'Messages': 'الرسائل',
    'maintenance_subtitle': 'قدّم طلبات الصيانة وتابعها من مكان واحد.',
    'new_request': 'طلب جديد',
    'report_an_issue': 'الإبلاغ عن مشكلة',
    'issue_summary': 'ملخص المشكلة',
    'issue_summary_placeholder': 'مثال: تسرب ماء في الحمام',
    'urgency_level': 'مستوى الإلحاح',
    'low_urgency': 'منخفض - غير عاجل',
    'normal_urgency': 'عادي - يحتاج اهتماماً',
    'high_urgency': 'مرتفع - يؤثر على الحياة اليومية',
    'emergency_urgency': 'طوارئ - يتطلب إجراءً فورياً',
    'describe_the_problem': 'وصف المشكلة',
    'describe_problem_placeholder': 'يرجى وصف المشكلة بأكبر قدر ممكن من التفاصيل...',
    'upload_photo_optional': 'رفع صورة (اختياري)',
    'add_photo': 'إضافة صورة',
    'photo_upload_tip': 'تساعدنا الصورة على حل مشكلتك بشكل أسرع.',
    'photo_upload_specs': 'صيغ JPG أو PNG أو WEBP. الحد الأقصى 5 ميغابايت.',
    'emergency_contact_warning': 'للحالات الطارئة التي تهدد الحياة، يرجى الاتصال بخدمات الطوارئ فوراً. سنتعامل مع هذا الطلب بأولى أولوية.',
    'processing': 'جارٍ المعالجة...',
    'submit_request': 'إرسال الطلب',
    'ongoing_past_requests': 'الطلبات الجارية والسابقة',
    'submitted': 'تم التقديم',
    'in_progress': 'قيد التنفيذ',
    'completed': 'مكتمل',
    'request_cancelled': 'تم إلغاء الطلب',
    'all_clear': 'كل شيء بخير!',
    'no_maintenance_on_record': 'لا توجد طلبات صيانة مسجلة. كل شيء على ما يرام!',
    'resolved_on': 'تم الحل بتاريخ {{date}}',
    'failed_to_load_maintenance_requests': 'فشل تحميل طلبات الصيانة',
    'failed_to_submit_request': 'فشل إرسال الطلب',
    'photo_size_limit_error': 'يجب أن تكون الصورة أقل من 5 ميغابايت',
    'request_submitted_success': 'تم إرسال الطلب بنجاح',
    'low': 'منخفض',
    'normal': 'عادي',
    'high': 'مرتفع',
    'emergency': 'طوارئ',
    'id': 'رقم',
    'announcements_subtitle': 'ابق على اطلاع بآخر أخبار وتحديثات إدارة المبنى.',
    'no_announcements_title': 'لا توجد إعلانات',
    'no_announcements_subtitle': 'تحقق لاحقاً للاطلاع على تحديثات إدارة المبنى.',
    'posted_by': 'نشر بواسطة {{name}}',
    'failed_to_load_announcements': 'فشل تحميل الإعلانات',
    'documents_verification': 'الوثائق والتحقق',
    'documents_verification_subtitle': 'ارفع وثائقك المطلوبة وأبقِها محدّثة لضمان تجربة إيجارية سلسة.',
    'supported_formats_specs': 'الصيغ المقبولة: PDF، JPG، JPEG، PNG. الحد الأقصى 5 ميغابايت لكل وثيقة.',
    'identification_proof': 'إثبات الهوية',
    'identification_proof_desc': 'هوية صادرة عن جهة حكومية كجواز السفر أو الهوية الوطنية أو رخصة القيادة.',
    'renters_insurance': 'تأمين المستأجر',
    'renters_insurance_desc': 'شهادة تأمين سارية تغطي وحدتك.',
    'verified': 'موثّق',
    'missing': 'مفقود',
    'pdf_document': 'مستند PDF',
    'view_full_size': 'عرض بالحجم الكامل',
    'replace': 'استبدال',
    'upload_file': 'رفع ملف',
    'need_help_verification': 'تحتاج مساعدة في التحقق؟',
    'need_help_verification_subtitle': 'إذا واجهت صعوبة في رفع الوثائق أو تحتاج إلى تقديم بديل، تواصل مع فريق الدعم.',
    'contact_support': 'تواصل مع الدعم',
    'failed_to_load_document_status': 'فشل تحميل حالة الوثائق',
    'file_size_large_error': 'حجم الملف كبير جداً. الحد الأقصى 5 ميغابايت.',
    'document_uploaded_success': 'تم رفع الوثيقة بنجاح',
    'failed_to_upload_document': 'فشل رفع الوثيقة',
    'my_inspections': 'فحوصاتي',
    'my_inspections_subtitle': 'عرض جميع فحوصات العقار المرتبطة بإيجارك.',
    'no_inspections_yet': 'لا توجد فحوصات بعد',
    'no_inspections_subtitle': 'ستظهر سجلات فحوصات عقارك هنا بعد الانتهاء منها.',
    'failed_to_load_inspections': 'فشل تحميل الفحوصات',
    'inspection_type_move_in': 'دخول',
    'inspection_type_move_out': 'خروج',
    'inspection_type_periodic': 'دوري',
    'inspection_type_maintenance': 'صيانة',
    'inspection_status_completed': 'مكتمل',
    'inspection_status_signed': 'موقّع',
    'inspection_status_draft': 'مسودة',
    'unit_prefix': 'وحدة',
    'items_checked': '{{done}} / {{total}} عنصر تم فحصه',
    'inspection_items': 'عناصر الفحص',
    'general_notes': 'ملاحظات عامة',
    'management_team': 'فريق الإدارة',
    'management_team_subtitle': 'خط مباشر مع إدارة المبنى',
    'message_empty_state': 'لا توجد رسائل بعد. ابدأ المحادثة!',
    'failed_to_load_messages': 'فشل تحميل الرسائل',
    'failed_to_send_message': 'فشل إرسال الرسالة',
    'message_placeholder': 'اكتب رسالة...',
    'lease_details_subtitle': 'راجع عقد الإيجار وحالة الدفع والتوقيع الرقمي.',
    'lease_not_found': 'لا يوجد عقد إيجار',
    'contact_management_error': 'يرجى التواصل مع إدارة المبنى للحصول على المساعدة.',
    'lease_signed': 'موقّع',
    'download_your_lease': 'تنزيل عقد الإيجار بصيغة PDF',
    'generating': 'جارٍ الإنشاء...',
    'download_pdf': 'تنزيل PDF',
    'sign_lease_now': 'وقّع العقد الآن',
    'contract_term': 'مدة العقد',
    'property_information': 'العقار والمالك',
    'landlord_owner': 'المالك',
    'payment_status': 'حالة الدفع',
    'current_balance': 'الرصيد الحالي',
    'payment_required': 'الدفع مطلوب',
    'account_good_standing': 'الحساب في وضع جيد',
    'lease_signed_success': 'تم التوقيع على العقد بنجاح!',
    'failed_to_sign_lease': 'فشل التوقيع على العقد',
    'lease_pdf_download_success': 'تم تنزيل PDF بنجاح',
    'lease_pdf_download_failed': 'فشل تنزيل PDF',
    'e_signature_recorded': 'تم تسجيل التوقيع الإلكتروني',
    'signed_on': 'وقّع في',
    'ip_trace': 'IP',
    'integrity_hash': 'Hash',
    'signature_graphic': 'توقيعك',
    'legal_disclosure': 'الإفصاح القانوني',
    'legal_disclosure_text': 'عقد الإيجار هذا وثيقة ملزمة قانونياً. بالتوقيع إلكترونياً، توافق على جميع الشروط والأحكام الواردة في العقد.',
    'payments_billing': 'المدفوعات والفواتير',
    'payments_billing_subtitle': 'تتبع مدفوعات الإيجار ورسوم الخدمات وسجل حسابك.',
    'download_statement': 'تنزيل كشف الحساب',
    'current_amount_due': 'المبلغ المستحق الحالي',
    'due_on': 'مستحق في',
    'view_ledger_hint': 'عرض سجل معاملاتك الكامل في',
    'view_your_ledger': 'سجل الحساب',
    'all_paid_up': 'كل شيء مدفوع!',
    'tab_rent_payments': 'مدفوعات الإيجار',
    'tab_service_charges': 'رسوم الخدمات',
    'tab_service_charges_due': 'رسوم الخدمات ({{count}} مستحقة)',
    'tab_account_ledger': 'سجل الحساب',
    'transaction_history': 'سجل المعاملات',
    'no_transactions': 'لا توجد معاملات بعد',
    'no_transactions_subtitle': 'سيظهر سجل مدفوعات إيجارك هنا.',
    'outstanding_service_charges': 'رسوم الخدمات المستحقة',
    'service_charge_default': 'رسم خدمة',
    'paid_service_history': 'سجل الخدمات المدفوعة',
    'paid_badge': 'مدفوع',
    'no_service_charges': 'لا توجد رسوم خدمات',
    'no_service_charges_subtitle': 'لم يتم إصدار أي فواتير خدمات لحسابك.',
    'account_balance': 'رصيد الحساب',
    'ledger_calculated_from': 'محسوب من {{count}} معاملة',
    'full_account_statement': 'كشف الحساب الكامل',
    'full_account_statement_subtitle': 'كل رسوم ومدفوعات حسابك',
    'no_ledger_entries': 'لا توجد قيود في السجل',
    'no_ledger_entries_subtitle': 'سيظهر نشاط حسابك هنا.',
    'balance_after_col': 'الرصيد بعد',
    'ledger_type_charge': 'رسم',
    'ledger_type_late_fee': 'رسم تأخير',
    'ledger_type_deposit': 'وديعة',
    'ledger_type_payment': 'دفعة',
    'ledger_type_credit': 'رصيد دائن',
    'payment_success_stripe': 'تمت عملية الدفع بنجاح! تم تحديث حسابك.',
    'payment_cancelled_stripe': 'تم إلغاء الدفع. لم يتم خصم أي رسوم.',
    'online_payments_not_enabled': 'المدفوعات الإلكترونية غير مفعّلة لحسابك.',
    'failed_to_initiate_payment': 'فشل إطلاق عملية الدفع',
    'failed_to_load_payment_data': 'فشل تحميل بيانات الدفع',
    'my_profile': 'ملفي الشخصي',
    'my_profile_subtitle': 'إدارة معلوماتك الشخصية وأمان حسابك.',
    'personal_information': 'المعلومات الشخصية',
    'full_name': 'الاسم الكامل',
    'your_full_name_placeholder': 'اسمك الكامل',
    'phone_placeholder': '+966 5X XXX XXXX',
    'email_placeholder': 'you@example.com',
    'saving': 'جارٍ الحفظ...',
    'save_changes': 'حفظ التغييرات',
    'change_password': 'تغيير كلمة المرور',
    'current_password': 'كلمة المرور الحالية',
    'new_password': 'كلمة المرور الجديدة',
    'confirm_new_password': 'تأكيد كلمة المرور الجديدة',
    'min_8_chars': '8 أحرف على الأقل',
    'repeat_new_password': 'أعد كلمة المرور الجديدة',
    'passwords_do_not_match': 'كلمتا المرور غير متطابقتين',
    'updating': 'جارٍ التحديث...',
    'update_password': 'تحديث كلمة المرور',
    'account_id': 'رقم الحساب',
    'tenant_since': 'مستأجر منذ',
    'failed_to_load_profile': 'فشل تحميل الملف الشخصي',
    'profile_updated': 'تم تحديث الملف الشخصي بنجاح',
    'failed_to_update_profile': 'فشل تحديث الملف الشخصي',
    'password_changed': 'تم تغيير كلمة المرور بنجاح',
    'failed_to_change_password': 'فشل تغيير كلمة المرور',
    'password_min_8': 'يجب أن تكون كلمة المرور 8 أحرف على الأقل',
    'service_charges_title': 'رسوم الخدمات',
    'service_charges_subtitle': 'عرض ودفع فواتير رسوم الخدمات.',
    'total_charges': 'إجمالي الرسوم',
    'outstanding_balance_label': 'مستحق',
    'service_charges_year': 'رسوم الخدمات — {{year}}',
    'no_service_charges_year': 'لا توجد رسوم خدمات لعام {{year}}',
    'no_service_charges_year_hint': 'جرّب تحديد عام مختلف.',
    'paid_on_date': 'مدفوع في {{date}}',
    'unpaid_label': 'غير مدفوع',
    'pay_online': 'الدفع إلكترونياً',
    'service_paid_success': 'تم دفع رسم الخدمة بنجاح!',
    'payment_canceled': 'تم إلغاء الدفع.',
    'failed_to_load_service_charges': 'فشل تحميل رسوم الخدمات',
    'portfolio_summary': 'ملخص المحفظة العقارية',
    'portfolio_subtitle': 'مرحباً بعودتك، {{name}}. إليك نظرة عامة على محفظتك العقارية.',
    'portfolio_statement': 'كشف المحفظة',
    'total_units': 'إجمالي الوحدات',
    'occupancy_rate': 'نسبة الإشغال',
    'active_leases': '{{count}} عقد إيجار نشط',
    'monthly_revenue': 'الإيراد الشهري',
    'vacant_units': 'الوحدات الشاغرة',
    'installment_summary': 'ملخص الأقساط',
    'view_detailed_ledger': 'عرض السجل التفصيلي',
    'outstanding': 'مستحق',
    'across_installments': 'عبر {{count}} قسط',
    'overdue': 'متأخر',
    'actions_required': '{{count}} إجراء مطلوب',
    'proceed_to_payments': 'الانتقال إلى المدفوعات',
    'revenue_performance': 'أداء الإيرادات',
    'no_revenue_data': 'لا توجد بيانات إيرادات',
    'portfolio_distribution': 'توزيع المحفظة',
    'no_building_data': 'لا توجد بيانات للمباني',
    'occupied_label': 'مشغولة',
    'ready_to_scale': 'هل أنت مستعد لإدارة محفظتك؟',
    'ready_to_scale_subtitle': 'الوصول إلى الأدوات الرئيسية لمتابعة عقاراتك',
    'failed_to_load_dashboard_data': 'فشل تحميل بيانات لوحة التحكم',
    'failed_to_download_statement': 'فشل تنزيل كشف الحساب',
    'owner_messages_title': 'الرسائل',
    'owner_messages_subtitle': 'التواصل المباشر مع إدارة المبنى',
    'my_properties': 'عقاراتي',
    'my_properties_subtitle': 'عرض جميع الشقق والوحدات المخصصة لمحفظتك.',
    'portfolio_empty': 'لا توجد عقارات',
    'portfolio_empty_subtitle': 'لم يتم تخصيص أي شقق لمحفظتك بعد. تواصل مع مدير المبنى للمساعدة.',
    'floor_prefix': 'طابق',
    'sqm': 'م²',
    'current_rent': 'الإيجار الحالي',
    'per_month_short': '/شهر',
    'failed_to_load_properties': 'فشل تحميل العقارات',
    'maintenance_approvals': 'موافقات الصيانة',
    'maintenance_approvals_subtitle': 'مراجعة طلبات صيانة المستأجرين والموافقة أو رفضها.',
    'failed_to_load_maintenance': 'فشل تحميل طلبات الصيانة',
    'request_status_updated': 'تم تحديث حالة الطلب بنجاح',
    'failed_to_update_request': 'فشل تحديث طلب الصيانة',
    'pending_approval': 'في انتظار الموافقة',
    'approved_in_progress': 'موافق عليه / قيد التنفيذ',
    'rejected_cancelled': 'مرفوض / ملغى',
    'above_threshold': 'يتجاوز الحد (${{amount}})',
    'no_maintenance_requests': 'لا توجد طلبات صيانة',
    'no_maintenance_subtitle': 'طلبات صيانة المستأجرين التي تتطلب موافقتك ستظهر هنا.',
    'financial_overview': 'نظرة مالية عامة',
    'financial_subtitle': 'تتبع الإيرادات المتولدة من مستأجريك عبر جميع العقارات.',
    'no_financial_data': 'لا توجد بيانات مالية',
    'no_payments_message': 'لا توجد حاليًا مدفوعات مسجلة لمحفظتك.',
    'recent_payments': 'المدفوعات الأخيرة',
    'property_tenant': 'العقار / المستأجر',
    'gross_amount': 'المبلغ الإجمالي',
    'commission': 'العمولة',
    'net_amount': 'المبلغ الصافي',
    'overdue_payments': 'المدفوعات المتأخرة',
    'failed_to_load_financials': 'فشل تحميل البيانات المالية',
    'statement_downloaded': 'تم تنزيل كشف {{month}} {{year}}',
    'management_commission': 'عمولة الإدارة',
    'unit_display': 'وحدة {{number}}',
    'since': 'منذ',
    'amount_owed': 'المبلغ المستحق',
    'financial_ledger': 'السجل المالي',
    'ledger_subtitle': 'جميع مدفوعات الأقساط عبر عقود الملكية.',
    'total_outstanding': 'إجمالي المستحق',
    'installment': 'القسط',
    'due_date': 'تاريخ الاستحقاق',
    'action': 'إجراء',
    'partial': 'جزئي',
    'owner_contract': 'عقد المالك',
    'pay_amount': 'دفع {{amount}}',
    'settled': 'مسوّى',
    'no_installments': 'لا توجد أقساط.',
    'failed_to_load_installments': 'فشل تحميل الأقساط',
    'payment_success_msg': 'تمت عملية الدفع بنجاح! شكراً لك.',
    'payment_canceled_msg': 'تم إلغاء الدفع.',
    'error_connecting_payment': 'خطأ في الاتصال بنظام الدفع',
    'owner_service_charges': 'رسوم الخدمات',
    'owner_service_charges_subtitle': 'عرض ودفع رسوم الخدمات المفوترة لعقاراتك.',
    'owner_service_info': 'تصدر رسوم الخدمات من قِبل إدارة المبنى. يرجى سداد المبالغ المستحقة في الوقت المناسب لتجنب انقطاع الخدمات.',
    'outstanding_balance': 'الرصيد المستحق',
    'service_charge_paid': 'تم دفع رسم الخدمة بنجاح!',
    'paid_on': 'مدفوع في {{date}}',
    'unpaid': 'غير مدفوع',
    'my_agreements': 'اتفاقياتي',
    'agreements_subtitle': 'مراجعة وتوقيع عقود إدارة الممتلكات الخاصة بك.',
    'no_active_agreements': 'لا توجد اتفاقيات',
    'no_contracts_message': 'ليس لديك حالياً أي عقود مسجلة. تواصل مع مدير المبنى للمساعدة.',
    'management_agreement': 'اتفاقية إدارة',
    'total_value': 'القيمة الإجمالية',
    'remaining': 'المتبقي',
    'failed_to_load_agreements': 'فشل تحميل الاتفاقيات',
    'rent': 'إيجار',
    'download_pdf': 'تنزيل PDF',
    'generating': 'جارٍ الإنشاء…',
    'announcements_manager': 'الإعلانات',
    'announcements_manager_subtitle': 'نشر وإدارة الإعلانات للمستأجرين والملاك أو مبانٍ محددة.',
    'new_announcement': 'إعلان جديد',
    'publish_announcement': 'نشر',
    'publishing': 'جارٍ النشر…',
    'all_announcements': 'جميع الإعلانات',
    'announcement_created': 'تم نشر الإعلان بنجاح!',
    'announcement_create_failed': 'فشل نشر الإعلان.',
    'announcement_deleted': 'تم حذف الإعلان.',
    'announcement_delete_failed': 'فشل حذف الإعلان.',
    'announcement_delete_confirm': 'حذف هذا الإعلان؟ لا يمكن التراجع عن هذا الإجراء.',
    'announcement_fields_required': 'العنوان والمحتوى مطلوبان.',
    'announcement_building_required': 'يرجى تحديد المبنى.',
    'announcement_title_placeholder': 'مثال: صيانة المياه المجدولة يوم الاثنين',
    'announcement_content_placeholder': 'اكتب رسالتك هنا…',
    'target_audience': 'الجمهور المستهدف',
    'audience_all': 'الجميع',
    'audience_tenants': 'المستأجرون فقط',
    'audience_owners': 'الملاك فقط',
    'audience_building': 'مبنى محدد',
    'select_building': 'اختر المبنى',
    'select_building_placeholder': '— اختر مبنى —',
    'no_announcements_yet': 'لا توجد إعلانات بعد',
    'no_announcements_yet_subtitle': 'انقر على "إعلان جديد" لإرسال أول رسالة.',
    'announcements_owner_subtitle': 'اطلع على آخر الأخبار والتحديثات من مدير عقارك.',
    'announcements_check_back': 'تحقق لاحقاً للاطلاع على الأخبار والتحديثات من مدير عقارك.',
    'posted_by': 'نشره {{name}}',

    // ── تقرير رسوم الإدارة ──────────────────────────────────────────────────────
    'management_fee_report': 'تقرير رسوم الإدارة',
    'management_fee_report_subtitle': 'تتبع تحصيل أقساط المالكين وتحليل التأخير',
    'ledger_activity_report': 'تقرير نشاط دفتر الأستاذ',
    'ledger_activity_report_subtitle': 'جميع قيود دفتر الأستاذ — الرسوم والمدفوعات وغرامات التأخير والائتمانات والودائع',
    'ledger_type_charge':   'رسوم',
    'ledger_type_late_fee': 'غرامة تأخير',
    'ledger_type_deposit':  'وديعة',
    'ledger_type_payment':  'دفعة',
    'ledger_type_credit':   'ائتمان',
    'ledger_net_balance':   'الرصيد المستحق',
    'feature_locked': 'الميزة مقفلة',
    'mgmt_fee_analytics_required': 'تقارير رسوم الإدارة تتطلب خطة التحليلات.',
    'upgrade': 'ترقية',
    'year': 'السنة',
    'month': 'الشهر',
    'all_months': 'كل الأشهر',
    'all_owners': 'جميع الملاك',
    'all_statuses': 'جميع الحالات',
    'status_paid': 'مدفوع',
    'status_pending_upcoming': 'معلق (قادم)',
    'status_overdue': 'متأخر',
    'status_partial': 'جزئي',
    'status_cancelled_label': 'ملغى',
    'clear_filters': 'مسح الفلاتر',
    'print_pdf': 'طباعة / PDF',
    'export_csv': 'تصدير CSV',
    'exporting': 'جارٍ التصدير…',
    'total_expected': 'إجمالي المتوقع',
    'total_collected': 'إجمالي المحصّل',
    'overdue_balance': 'الرصيد المتأخر',
    'collection_rate': 'معدل التحصيل',
    'n_installments': '{{count}} قسط',
    'n_paid': '{{count}} مدفوع',
    'n_overdue_installments': '{{count}} قسط متأخر',
    'n_upcoming': '{{count}} قادم',
    'monthly_breakdown': 'التوزيع الشهري — {{year}}',
    'monthly_breakdown_filtered': 'التوزيع الشهري — {{year}} (مفلتر إلى {{month}})',
    'chart_expected': 'المتوقع',
    'chart_collected': 'المحصّل',
    'chart_overdue': 'المتأخر',
    'no_installment_data_year': 'لا توجد بيانات أقساط لـ {{year}}',
    'tooltip_expected': 'المتوقع:',
    'tooltip_collected': 'المحصّل:',
    'tooltip_overdue': 'المتأخر:',
    'all_installments': 'جميع الأقساط',
    'n_records': '{{count}} سجل',
    'n_records_plural': '{{count}} سجل',
    'page_of': 'صفحة {{page}}/{{total}}',
    'no_installments_found': 'لم يتم العثور على أقساط',
    'try_adjusting_filters': 'جرّب تعديل الفلاتر.',
    'col_owner': 'المالك',
    'col_apt': 'الشقة',
    'col_building': 'المبنى',
    'col_due_date': 'تاريخ الاستحقاق',
    'col_amount': 'المبلغ',
    'col_paid': 'المدفوع',
    'col_balance': 'الرصيد',
    'col_status': 'الحالة',
    'col_days_late': 'أيام التأخير',
    'totals_all_pages': 'الإجمالي (كل الصفحات):',
    'previous': '→ السابق',
    'next': 'التالي ←',
    'page_x_of_y': 'صفحة {{page}} من {{total}} ({{count}} إجمالاً)',
    'overdue_aging_title': 'الأقساط المتأخرة — تحليل فترة التأخير',
    'col_aging': 'فترة التأخير',
    'all_installments_up_to_date': 'جميع الأقساط محدّثة!',
    'no_overdue_found': 'لا توجد أقساط رسوم إدارة متأخرة.',
    'total_overdue': 'إجمالي المتأخر:',
    'n_days': '{{count}} يوم',
    'aging_1_30': '1–30 يوماً',
    'aging_31_60': '31–60 يوماً',
    'aging_61_90': '61–90 يوماً',
    'aging_90_plus': '+90 يوماً',
    'badge_paid': 'مدفوع',
    'badge_partial': 'جزئي',
    'badge_pending': 'معلق',
    'badge_overdue': 'متأخر',
    'badge_cancelled': 'ملغى',
    'failed_to_load_mgmt_fee_report': 'فشل تحميل تقرير رسوم الإدارة',
    'export_failed': 'فشل التصدير',
    'export_downloaded_label': 'تم التنزيل: {{label}}',

    // Email Template Form
    'et_new_title': 'قالب بريد إلكتروني جديد',
    'et_edit_title': 'تعديل قالب البريد الإلكتروني',
    'et_basic_info': 'المعلومات الأساسية',
    'et_template_name': 'اسم القالب *',
    'et_template_name_placeholder': 'مثال: تذكير الإيجار الشهري',
    'et_trigger_event': 'حدث التشغيل',
    'et_description': 'الوصف',
    'et_description_placeholder': 'ملاحظة داخلية اختيارية',
    'et_subject_line': 'سطر الموضوع *',
    'et_subject_placeholder': 'مثال: إيجارك بقيمة ${{rent_amount}} مستحق في {{due_date}}',
    'et_html_body': 'نص HTML',
    'et_editor': 'المحرر',
    'et_preview': 'معاينة',
    'et_quick_insert': 'إدراج سريع للمتغيرات',
    'et_update_btn': 'تحديث القالب',
    'et_create_btn': 'إنشاء القالب',
    'et_created': 'تم إنشاء القالب',
    'et_updated': 'تم تحديث القالب',
    'et_failed_load': 'فشل تحميل القالب',
    'et_save_failed': 'فشل الحفظ',
    'et_fields_required': 'الاسم والموضوع والنص مطلوبة',
    'issue_utility_bill': 'إصدار فاتورة المرافق',
    'tenant_billing_assignment': 'تعيين المستأجر والفواتير',
    'select_tenant': 'اختر المستأجر',
    'search_tenant_placeholder': 'البحث بالاسم أو رقم الشقة...',
    'utility_details': 'تفاصيل المرافق',
    'period_month': 'الشهر',
    'period_year': 'السنة',
    'due_date': 'تاريخ الاستحقاق',
    'posting_options': 'خيارات الترحيل',
    'charge_immediately': 'تقييد المبلغ في الحساب فوراً',
    'charge_immediately_desc_on': 'سيتم ترحيل المبلغ إلى رصيد المستأجر بمجرد الحفظ.',
    'charge_immediately_desc_off': 'سيتم حفظ الفاتورة كـ "معلقة" ويجب عليك ترحيلها يدوياً لاحقاً.',
    'processing': 'جاري المعالجة...',
    'issue_and_charge': 'إصدار وتقييد',
    'issue_bill': 'إصدار الفاتورة',
    'meter_identity_provider': 'هوية العداد والمزود',
    'account_number': 'رقم الحساب',
    'meter_number': 'رقم العداد',
    'shared_meter_rubs': 'عداد مشترك (تقسيم RUBS)',
    'pricing_unit_measurement': 'التسعير ووحدة القياس',
    'rate_per_unit': 'السعر لكل وحدة ($)',
    'unit_of_measure': 'وحدة القياس',
    'billing_day_monthly': 'يوم الفوترة (شهرياً)',
    'internal_notes': 'ملاحظات داخلية',

    // Utility — edit / void / mark-paid
    'edit_utility_account': 'تعديل حساب المرافق',
    'void_bill': 'إلغاء الفاتورة',
    'void_reason': 'السبب (اختياري)',
    'void_reason_placeholder': 'مثال: خطأ في الفوترة، مكرر...',
    'confirm_void_bill': 'سيتم إلغاء هذه الفاتورة ولن يمكن تحصيلها.',
    'confirm_void_bill_sent': 'تم تحصيل هذه الفاتورة بالفعل. سيتم إصدار قيد ائتماني لعكس التحصيل.',
    'bill_voided': 'تم إلغاء الفاتورة',
    'bill_marked_paid': 'تم تعليم الفاتورة كمدفوعة',
    'confirm_mark_paid': 'هل تريد تعليم هذه الفاتورة كمدفوعة (دفع خارجي)؟',
    'deactivate_utility_account': 'تعطيل الحساب',
    'confirm_deactivate_utility_account': 'هل أنت متأكد أنك تريد تعطيل حساب المرافق هذا؟',
    'post_utility_charge': 'ترحيل رسوم المرافق',
    'account_updated': 'تم تحديث الحساب بنجاح',
    'utility_bill': 'فاتورة المرافق',
    'tenant_info': 'المستأجر',
    'tenant_name_5': 'الاسم',
    'email_15': 'البريد الإلكتروني',
    'reading_history': 'سجل القراءات',
    'usage_breakdown': 'تفاصيل الاستهلاك',
    'previous_reading': 'القراءة السابقة',
    'current_reading': 'القراءة الحالية',
    'view_account': 'عرض حساب المرافق',

    // Currency
    'currency_selector_label': 'عملة المنظمة',
    'currency_stripe_warning': 'المدفوعات الإلكترونية عبر Stripe غير متاحة لهذه العملة. سيدفع المستأجرون شخصياً فقط.',
    'online_payment_unavailable': 'الدفع الإلكتروني غير متاح لعملتك. يرجى الدفع شخصياً.',

    // Buildings / Bulk creator
    'units_per_floor': 'وحدات لكل طابق',
    'QTY_PER_FLOOR': 'الكمية / الطابق',
    'qty_per_floor': 'الكمية / الطابق',
    'SIZE': 'المساحة',
    'SELECT_FLOORS': 'اختر الطوابق',
    'select_floors': 'اختر الطوابق',
    'BULK_ADD': 'إضافة جماعية',
    'bulk_add': 'إضافة جماعية',
    'avg_occupancy': 'متوسط الإشغال',
    'total_buildings': 'إجمالي المباني',

    // Dashboard & Risk Widgets
    'payment_risk': 'مخاطر الدفع',
    'ai_scored_late_payment': 'احتمالية التأخر في الدفع (مدعوم بالذكاء الاصطناعي)',
    'high_risk': 'مخاطر عالية',
    'medium': 'متوسطة',
    'low_risk': 'مخاطر منخفضة',
    'no_scores_yet': 'لا توجد تقييمات حتى الآن. انقر لتشغيل التقييم بالذكاء الاصطناعي.',
    'owed': 'مستحقة',
    'view_all_risk_scores': 'عرض جميع تقييمات المخاطر',
    'renewal_risk': 'مخاطر التجديد',
    'leases_expiring_90d': 'عقود الإيجار التي تنتهي خلال 90 يومًا',
    'exp_in_30d': 'تنتهي خلال 30 يوم',
    'exp_in_90d': 'تنتهي خلال 90 يوم',
    'no_leases_expiring_90d': 'لا توجد عقود إيجار تنتهي خلال الـ 90 يومًا القادمة.',
    'left': 'متبقية',
    'view_all_renewal_risks': 'عرض جميع مخاطر التجديد',
    're_run_ai_scoring': 'إعادة تشغيل التقييم بالذكاء الاصطناعي',

    // User Form
    'invitation_only_onboarding': 'إعداد الحساب عبر الدعوة فقط',
    'invitation_only_onboarding_desc': 'لأسباب أمنية، لم يعد المسؤولون يقومون بتعيين كلمات المرور. سيتم إرسال دعوة آمنة إلى عنوان البريد الإلكتروني للمستخدم تتيح له إعداد حسابه الخاص وكلمة المرور.',
    'user_created_email_failed': 'تم إنشاء حساب لـ ',
    'user_created_email_failed_2': '، ولكن ',
    'invitation_email_could_not_be_sent': 'تعذر إرسال بريد الدعوة',
    'user_created_email_failed_3': ' بسبب مشكلة في خادم البريد.',
    'manual_onboarding_link': 'رابط إعداد الحساب اليدوي',
    'manual_onboarding_desc': 'يرجى نسخ هذا الرابط وإرساله للمستخدم يدويًا لتمكينه من تعيين كلمة المرور الخاصة به:',
    'link_copied_to_clipboard': 'تم نسخ الرابط إلى الحافظة!',
    'copy_link': 'نسخ الرابط',
    'done': 'تم',
    'add_another_user': 'إضافة مستخدم آخر',

    // Apartment List
    'furnished_apartment': 'شقة مفروشة',
    'multiple_leases': 'عقود إيجار متعددة',
    'manage': 'إدارة',
    'delete_apartment': 'حذف الشقة',

    // --- HIGH-QUALITY MANUAL TRANSLATIONS ---
    'total_properties': 'إجمالي العقارات',
    'active_properties': 'العقارات النشطة',
    'active_tenants': 'المستأجرين النشطين',
    'monthly_revenue': 'الإيرادات الشهرية',
    'pending_payments': 'المدفوعات المعلقة',
    'lease_expiring_soon': 'عقود الإيجار التي تنتهي قريباً',
    'payment_risk': 'مخاطر الدفع',
    'ai_scored_late_payment': 'احتمالية التأخر في الدفع (مدعوم بالذكاء الاصطناعي)',
    'high_risk': 'مخاطر عالية',
    'medium_risk': 'مخاطر متوسطة',
    'low_risk': 'مخاطر منخفضة',
    'no_scores_yet': 'لا توجد تقييمات حتى الآن. انقر على تحديث لتشغيل التقييم الذكي.',
    'renewal_risk': 'مخاطر التجديد',
    'leases_expiring_in_90_days': 'عقود الإيجار التي تنتهي خلال 90 يومًا',
    'exp_in_30d': 'تنتهي في 30 يومًا',
    'exp_in_90d': 'تنتهي في 90 يومًا',
    'no_leases_expiring_90d': 'لا توجد عقود إيجار تنتهي خلال 90 يومًا.',
    'leasing_office': 'مكتب التأجير',
    'marketing_links': 'الروابط التسويقية',
    'bulk_import': 'استيراد جماعي',
    'evictions': 'الإخلاءات',
    'accounting': 'المحاسبة',
    'payments': 'المدفوعات',
    'portfolio_kpis': 'المحفظة ومؤشرات الأداء',
    'bulk_comms': 'رسائل جماعية',
    'email_templates': 'قوالب البريد الإلكتروني',
    'building_view': 'عرض المبنى',
    'failed_to_load_logs': 'فشل تحميل سجلات النشاط',
    'export_failed': 'فشل تصدير السجلات',
    'all_user_activities_desc': 'تتبع جميع إجراءات وأحداث النظام',
    'search_logs': 'البحث في السجلات...',
    'entries': 'سجلات',
    'filter_activities': 'تصفية الأنشطة',
    'action_type': 'نوع الإجراء',
    'all_actions': 'كل الإجراءات',
    'entity_type': 'نوع الكيان',
    'all_types': 'كل الأنواع',
    'start_date': 'تاريخ البدء',
    'end_date': 'تاريخ الانتهاء',
    'reset': 'إعادة تعيين',
    'apply_filter': 'تطبيق التصفية',
    'time': 'الوقت',
    'user': 'المستخدم',
    'action': 'الإجراء',
    'entity': 'الكيان',
    'details': 'التفاصيل',
    'amount': 'المبلغ',
    'no_logs_matching_search': 'لا توجد سجلات مطابقة لبحثك.',
    'no_logs_available': 'لا توجد سجلات نشاط متاحة.',
    'showing_range': 'عرض {{start}} إلى {{end}} من {{total}}',
    'previous': 'السابق',
    'next': 'التالي',
    'exporting': 'جاري التصدير...',
    'export': 'تصدير',
    'filter': 'تصفية',
    'activity_logs': 'سجلات النشاط',
    'invitation_only_onboarding': 'التسجيل عبر الدعوات فقط',
    'approve_payment_msg': 'هل أنت متأكد أنك تريد الموافقة على هذه الدفعة؟',
    'reject_payment_msg': 'يرجى تقديم سبب لرفض هذه الدفعة.',
    'errors_serverError': 'خطأ داخلي في الخادم',
    'timePeriods_month': 'شهر',
    'timePeriods_quarter': 'ربع سنوي',
    'timePeriods_year': 'سنة',
    'common_startDate': 'تاريخ البدء',
    'common_endDate': 'تاريخ الانتهاء',
    'common_type': 'النوع',
    'common_all': 'الكل',
    'common_tenant': 'المستأجر',

  
  
  
    // Auto-added translations
    'unpaid_balance': 'الرصيد غير المدفوع',
    'lease_period': 'فترة الإيجار',
    'view_record': 'عرض السجل',
    'apartment_created_successfully': 'تم إنشاء الشقة بنجاح',
    'apartment_updated_successfully': 'تم تحديث الشقة بنجاح',
    'manage_your_properties': 'إدارة الممتلكات الخاصة بك',
    'add_your_first_apartment': 'أضف شقتك الأولى',
    'filter_apartments': 'تصفية الشقق',
    'no_matching_apartments_message': 'لا توجد رسالة الشقق المطابقة',
    'select_at_least_one_floor': 'حدد طابقًا واحدًا على الأقل',
    'add_at_least_one_unit_type': 'أضف نوع وحدة واحدًا على الأقل',
    'apartments_created': 'تم إنشاء الشقق',
    'skipped_duplicates': 'تم تخطي التكرارات',
    'apartments_created_successfully': 'تم إنشاء الشقق بنجاح',
    'error_creating_apartments': 'خطأ في إنشاء الشقق',
    'clear': 'واضح',
    'select_floors_and_types': 'حدد الأرضيات والأنواع',
    'future_tenant_only': 'المستأجر المستقبلي فقط',
    'converted': 'تحويلها',
    'confirmed': 'تم التأكيد',
    'hold': 'عقد',
    'failed_confirm_booking': 'فشل تأكيد الحجز',
    'failed_cancel_booking': 'فشل إلغاء الحجز',
    'failed_convert_tenant': 'فشل تحويل المستأجر',
    'converted_to_tenant': 'تحولت إلى المستأجر',
    'hold_expired': 'عقد منتهية الصلاحية',
    'booking_created': 'تم إنشاء الحجز',
    'failed_save_booking': 'فشل حفظ الحجز',
    'failed_load_bookings': 'فشل تحميل الحجوزات',
    'building_created_successfully': 'تم إنشاء المبنى بنجاح',
    'building_updated_successfully': 'تم تحديث المبنى بنجاح',
    'current': 'الحالي',
    'building_has_no_apartments': 'المبنى لا يوجد به شقق',
    'add_apartments_hint': 'إضافة تلميح الشقق',
    'due': 'مستحق',
    'contract_type': 'نوع العقد',
    'description': 'الوصف',
    'next_7_days': '7 أيام القادمة',
    'next_14_days': 'الـ 14 يومًا القادمة',
    'next_30_days': 'الثلاثين يومًا القادمة',
    'view_arrow': 'عرض السهم',
    'search_unit_tenant': 'بحث عن مستأجر الوحدة',
    'no_results_for_filters': 'لا توجد نتائج للمرشحات',
    'charged': 'مشحونة',
    'bank': 'البنك',
    'cheque': 'تحقق',
    'stripe': 'شريط',
    'failed_to_load_revenue': 'فشل في تحميل الإيرادات',
    'no_tenant_logs': 'لا توجد سجلات المستأجر',
    'payment_record_error': 'خطأ في سجل الدفع',
    'contract_not_found': 'لم يتم العثور على العقد',
    'back_to_owner': 'العودة إلى المالك',
    'contract_details': 'تفاصيل العقد',
    'contract_id': 'معرف العقد',
    'summary_info': 'معلومات موجزة',
    'n_a': 'ن أ',
    'paid_progress': 'التقدم المدفوع',
    'total_installments': 'إجمالي الأقساط',
    'paid_installments': 'الأقساط المدفوعة',
    'pending_installments': 'الأقساط المعلقة',
    'legal_document': 'وثيقة قانونية',
    'signatures': 'التوقيعات',
    'owner_signature': 'توقيع المالك',
    'awaiting_owner_signature': 'في انتظار توقيع المالك',
    'admin_signature': 'توقيع المشرف',
    'awaiting_admin_signature': 'في انتظار توقيع المشرف',
    'installment_schedule': 'جدول التقسيط',
    'paid_amount': 'المبلغ المدفوع',
    'save_payment': 'حفظ الدفع',
    'add_contract': 'أضف العقد',
    'language': 'اللغة',
    'exportPDF': 'تصدير قوات الدفاع الشعبي',
    'print': 'طباعة',
    'receiptNo': 'رقم الإيصال',
    'contractDetails': 'تفاصيل العقد',
    'contractNo': 'رقم العقد',
    'contractType': 'نوع العقد',
    'startDate': 'تاريخ البدء',
    'endDate': 'تاريخ الانتهاء',
    'openEnded': 'مفتوحة النهاية',
    'financialSummary': 'الملخص المالي',
    'totalValue': 'القيمة الإجمالية',
    'totalPaid': 'إجمالي المبلغ المدفوع',
    'balanceDue': 'الرصيد المستحق',
    'installments': 'أقساط',
    'installmentSchedule': 'جدول التقسيط',
    'dueDate': 'تاريخ الاستحقاق',
    'paidAmt': 'المبلغ المدفوع',
    'paymentDate': 'تاريخ الدفع',
    'paidWatermark': 'العلامة المائية المدفوعة',
    'paymentDetails': 'تفاصيل الدفع',
    'installmentNo': 'رقم القسط',
    'amountDue': 'المبلغ المستحق',
    'amountPaid': 'المبلغ المدفوع',
    'paymentStatus': 'حالة الدفع',
    'paymentConfirmed': 'تم تأكيد الدفع',
    'awaitingPayment': 'في انتظار الدفع',
    'balanceRemaining': 'الرصيد المتبقي',
    'authorizedSig': 'سيج المعتمد',
    'ownerSig': 'مالك سيج',
    'generatedBy': 'تم إنشاؤها بواسطة',
    'informationalOnly': 'إعلامية فقط',
    'failed_to_load_owner_data': 'فشل في تحميل بيانات المالك',
    'sending': 'إرسال',
    'payment_reminder_message': 'رسالة تذكير بالدفع',
    'reminder_sent_success': 'تم إرسال التذكير بنجاح',
    'failed_to_send_reminder': 'فشل في إرسال التذكير',
    'owner_has_no_email': 'المالك ليس لديه بريد إلكتروني',
    'portal_invitation_sent_successfully': 'تم إرسال دعوة البوابة بنجاح',
    'failed_to_send_portal_invite': 'فشل في إرسال دعوة البوابة',
    'owner_not_found': 'لم يتم العثور على المالك',
    'total_income': 'إجمالي الدخل',
    'contracts': 'العقود',
    'residence': 'الإقامة',
    'does_not_live_on_property': 'لا يعيش على الممتلكات',
    'outstanding_fees_note': 'ملاحظة الرسوم المعلقة',
    'owner_contracts': 'عقود المالك',
    'no_contracts_found': 'لم يتم العثور على العقود',
    'pending_signature': 'التوقيع في انتظار',
    'fully_executed': 'تم التنفيذ بالكامل',
    'error_loading_financials': 'حدث خطأ أثناء تحميل البيانات المالية',
    'due_soon': 'قريبا',
    'management_fees': 'رسوم الإدارة',
    'owner_updated_successfully': 'تم تحديث المالك بنجاح',
    'invitation_sent': 'تم إرسال الدعوة',
    'invitation_failed': 'فشلت الدعوة',
    'owner_created_successfully': 'تم إنشاء المالك بنجاح',
    'preferred_language': 'اللغة المفضلة',
    'english': 'الإنجليزية',
    'arabic': 'العربية',
    'kurdish': 'الكردية',
    'drop_here': 'إسقاط هنا',
    'failed_to_load_owners_data': 'فشل في تحميل بيانات المالكين',
    'connection_error': 'خطأ في الاتصال',
    'failed_to_delete_owner': 'فشل في حذف المالك',
    'failed_to_delete_owners': 'فشل في حذف المالكين',
    'edit_owner': 'تعديل المالك',
    'delete_owner': 'حذف المالك',
    'occupied_lowercase': 'حرف صغير محتل',
    'confirm_bulk_delete_title': 'تأكيد الحذف المجمع للعنوان',
    'refresh_owners': 'تحديث أصحاب',
    'delete_selected_owners': 'حذف المالكين المحددين',
    'export_to_pdf': 'تصدير إلى قوات الدفاع الشعبي',
    'print_owners': 'أصحاب الطباعة',
    'min_zero': 'دقيقة صفر',
    'count_formatted': 'تم تنسيق العدد',
    'most_popular': 'الأكثر شعبية',
    'trial': 'محاكمة',
    'past_due': 'تاريخ الاستحقاق الماضي',
    'canceled': 'تم الإلغاء',
    'invalid_plan_selected': 'تم تحديد خطة غير صالحة',
    'could_not_start_checkout': 'تعذر بدء الخروج',
    'checkout_failed': 'فشل الخروج',
    'could_not_open_portal': 'لا يمكن فتح البوابة',
    'failed_to_open_portal': 'فشل في فتح البوابة',
    'payment_approved_success': 'تمت الموافقة على الدفع بنجاح',
    'failed_to_approve_payment': 'فشل في الموافقة على الدفع',
    'provide_rejection_reason': 'تقديم سبب الرفض',
    'payment_rejected': 'تم رفض الدفع',
    'failed_to_reject_payment': 'فشل في رفض الدفع',
    'stripe_connected': 'شريط متصل',
    'yr': 'سنة',
    'mo': 'مو',
    'expires': 'تنتهي',
    'renews': 'يجدد',
    'opening': 'الافتتاح',
    'stripe_portal_title': 'عنوان البوابة الشريطية',
    'stripe_portal_desc': 'وصف بوابة الشريط',
    'monthly': 'شهريا',
    'annual': 'سنوي',
    'redirecting': 'إعادة التوجيه',
    'stripe_secure_notice': 'إشعار الشريط الآمن',
    'organization': 'التنظيم',
    'approve_payment': 'الموافقة على الدفع',
    'reject_payment': 'رفض الدفع',
    'errors.serverError': 'خطأ في الخادم',
    'export_excel': 'تصدير اكسل',
    'timePeriods.month': 'شهر',
    'timePeriods.quarter': 'ربع',
    'timePeriods.year': 'سنة',
    'common.startDate': 'تاريخ البدء',
    'common.endDate': 'تاريخ الانتهاء',
    'common.type': 'اكتب',
    'common.all': 'الكل',
    'common.tenant': 'المستأجر',
    'common.searchTenant': 'بحث المستأجر',
    'ledgerReport.netBalance': 'صافي الرصيد',
    'ledgerReport.entries': 'إدخالات',
    'common.noData': 'لا توجد بيانات',
    'common.date': 'التاريخ',
    'common.building': 'بناء',
    'common.apartment': 'شقة',
    'common.description': 'الوصف',
    'common.amount': 'المبلغ',
    'ledgerReport.balanceAfter': 'الرصيد بعد',
    'ledgerReport.createdBy': 'تم الإنشاء بواسطة',
    'common.page': 'الصفحة',
    'metric': 'متري',
    'value': 'القيمة',
    'failed_to_export': 'فشل التصدير',
    'select_date_range': 'حدد النطاق الزمني',
    'revenue_deep_dive_restricted': 'الإيرادات مقيد الغوص العميق',
    'showing_building_revenue': 'عرض إيرادات البناء',
    'showing_owner_revenue': 'عرض إيرادات المالك',
    'showing_monthly_revenue': 'عرض الإيرادات الشهرية',
    'receiptTitle': 'عنوان الاستلام',
    'receiptDate': 'تاريخ الاستلام',
    'residentName': 'اسم المقيم',
    'servicePeriod': 'فترة الخدمة',
    'signature': 'التوقيع',
    'responsible': 'مسؤول',
    'thankYou': 'شكرا لك',
    'invalid_amount': 'مبلغ غير صالح',
    'payment_generated_successfully': 'تم إنشاء الدفع بنجاح',
    'failed_to_generate_payment': 'فشل في إنشاء الدفع',
    'no_owner': 'لا مالك',
    'rented': 'مستأجرة',
    'payer': 'دافع',
    'failed_to_load_service_data': 'فشل في تحميل بيانات الخدمة',
    'records': 'السجلات',
    'no_matching_payments_found': 'لم يتم العثور على مدفوعات مطابقة',
    'paid_count': 'العدد المدفوع',
    'unpaid_count': 'العدد غير المدفوع',
    'no_data_to_export': 'لا توجد بيانات للتصدير',
    'export_successful': 'تم التصدير بنجاح',
    'months_with_data': 'أشهر مع البيانات',
    'data_refreshed_successfully': 'تم تحديث البيانات بنجاح',
    'payment_marked_as_paid': 'تم تحديد الدفعة كمدفوعة بنجاح',
    'payment_marked_as_unpaid': 'تم تحديد الدفعة كغير مدفوعة بنجاح',
    'rented': 'مؤجر',
    'service_charge_deleted': 'تم حذف رسوم الخدمة بنجاح',
    'failed_to_delete_service_charge': 'فشل حذف رسوم الخدمة',
    'service_payment_note_default': 'دفعة خدمة عن شهر {{month}} {{year}}',
    'failed_init_stripe': 'فشل شريط التهيئة',
    'refresh_status': 'تحديث الحالة',
    'failed_to_load_user_data': 'فشل في تحميل بيانات المستخدم',
    'error_updating_profile': 'حدث خطأ أثناء تحديث الملف الشخصي',
    'error_updating_password': 'حدث خطأ أثناء تحديث كلمة المرور',
    'manage_your_account_and_system_preferences': 'إدارة حسابك وتفضيلات النظام',
    'error_from_server': 'خطأ من الخادم',
    'nameLabel': 'تسمية الاسم',
    'floorPre': 'الطابق قبل',
    'aptPre': 'شقة قبل',
    'periodLabel': 'تسمية الفترة',
    'officeCommission': 'لجنة المكتب',
    'invalid_date': 'تاريخ غير صالح',
    'tenant_has_no_email': 'المستأجر ليس لديه بريد إلكتروني',
    'portal_invitation_failed': 'فشلت دعوة البوابة',
    'failed_to_extend_lease': 'فشل في تمديد عقد الإيجار',
    'lease_renewed_success': 'تأجير النجاح المتجدد',
    'failed_to_renew_lease': 'فشل تجديد عقد الإيجار',
    'ending_lease': 'إنهاء عقد الإيجار',
    'renew_lease': 'تجديد عقد الإيجار',
    'french': 'الفرنسية',
    'german': 'الألمانية',
    'italian': 'ايطالي',
    'no_additional_fees': 'لا رسوم إضافية',
    'electronic_signature': 'التوقيع الإلكتروني',
    'no_maintenance_requests_message': 'لا توجد طلبات صيانة',
    'add_first_request': 'أضف الطلب الأول',
    'tenant_updated_successfully': 'تم تحديث المستأجر بنجاح',
    'tenant_created_successfully': 'تم إنشاء المستأجر بنجاح',
    'no_phone': 'لا يوجد هاتف',
    'not_assigned': 'لم يتم تعيينه',
    'financial_details': 'التفاصيل المالية',
    'search_tenants_by_name_phone_or_apartment': 'بحث المستأجرين حسب اسم الهاتف أو الشقة',
    'more_info': 'مزيد من المعلومات',
    'apartment_specs': 'مواصفات الشقة',
    'hide_inactive_users': 'إخفاء المستخدمين غير النشطين',
    'show_inactive_users': 'إظهار المستخدمين غير النشطين',
    'error_loading_users': 'حدث خطأ أثناء تحميل المستخدمين',
    'no_users_message': 'لا توجد رسالة للمستخدمين',
    'create_first_user': 'إنشاء المستخدم الأول',
    'spanish': 'الاسبانية',
    'sms_sent_to': 'الرسائل القصيرة المرسلة إلى',
    'sms_failed': 'فشل الرسائل القصيرة',
    'request_failed': 'فشل الطلب',
    'via_twilio': 'عبر تويليو',
    'no_recipients_match': 'لا توجد تطابقات بين المستلمين',
    'on': 'على',
    'off': 'إيقاف',
    'loading_units': 'وحدات التحميل',
    'listed_rent': 'الإيجار المدرج',
    'portfolio_occupancy': 'إشغال المحفظة',
    'avg_renewal_increase': 'زيادة متوسط التجديد',
    'title': 'العنوان',
    'content': 'المحتوى',
    'marketing_links_desc': 'وصف روابط التسويق',
    'days': 'أيام',
    'download_failed': 'فشل التنزيل',
    'run_report': 'تشغيل التقرير',
    'downloading': 'جاري التحميل',
    'total_ar': 'مجموع آر',
    'total_balance': 'الرصيد الإجمالي',
    'no_outstanding_balances_found': 'لم يتم العثور على أرصدة مستحقة',
    'totals': 'المجاميع',
    'subject_body_required': 'مطلوب هيئة الموضوع',
    'no_active_tenants': 'لا يوجد مستأجرين نشطين',
    'confirm_send_bulk': 'تأكيد الإرسال بالجملة',
    'message_sent_to_tenants': 'تم إرسال رسالة إلى المستأجرين',
    'bulk_communications': 'الاتصالات السائبة',
    'message_sent_successfully': 'تم إرسال الرسالة بنجاح',
    'in_app_announcement': 'في إعلان التطبيق',
    'dismiss': 'استبعاد',
    'target_building': 'بناء الهدف',
    'all_buildings_count': 'عدد جميع المباني',
    'compose_message': 'إنشاء رسالة',
    'subject': 'الموضوع',
    'message_body': 'جسم الرسالة',
    'markdown_hint': 'تلميح تخفيض السعر',
    'characters': 'الشخصيات',
    'delivery_channels': 'قنوات التسليم',
    'email_blast': 'انفجار البريد الإلكتروني',
    'send_to_tenants': 'إرسال إلى المستأجرين',
    'bulk_guidelines': 'المبادئ التوجيهية السائبة',
    'in_app_announcements': 'في إعلانات التطبيق',
    'in_app_desc': 'في وصف التطبيق',
    'email_blasts': 'انفجارات البريد الإلكتروني',
    'email_blast_desc': 'وصف انفجار البريد الإلكتروني',
    'send_immediate_desc': 'إرسال وصف فوري',
    'professional_desc': 'وصف المهنية',
    'owner_balances': 'أرصدة المالك',
    'deselect_all': 'قم بإلغاء تحديد الكل',
    'select_all': 'حدد الكل',
    'notes_optional': 'ملاحظات اختيارية',
    'confirm_bulk_payout_title': 'تأكيد الدفع الجماعي',
    'error_loading_churn_data': 'حدث خطأ أثناء تحميل بيانات التشغيل',
    'running_scoring': 'تشغيل التهديف',
    'scored_tenants': 'سجل المستأجرين',
    'scoring_failed': 'فشل التسجيل',
    'vendor_dashboard_subtitle': 'العنوان الفرعي للوحة تحكم البائع',
    'view_your_work_orders': 'عرض أوامر العمل الخاصة بك',
    'templates': 'قوالب',
    'editor': 'محرر',
    'desktop': 'سطح المكتب',
    'mobile': 'الجوال',
    'realistic_sample_data': 'بيانات عينة واقعية',
    'template_logic': 'منطق القالب',
    'event_trigger_desc': 'وصف مشغل الحدث',
    'admin_only': 'المشرف فقط',
    'click_to_insert': 'انقر لإدراج',
    'body': 'الجسم',
    'template_deactivated': 'تم تعطيل القالب',
    'failed_to_deactivate': 'فشل في التعطيل',
    'enter_test_email': 'أدخل البريد الإلكتروني التجريبي',
    'test_email_sent_to': 'اختبار البريد الإلكتروني المرسل إلى',
    'failed_to_send_test': 'فشل في إرسال الاختبار',
    'active_templates_count': 'عدد القوالب النشطة',
    'send_test_email': 'إرسال البريد الإلكتروني للاختبار',
    'save_failed': 'فشل الحفظ',
    'description_required': 'الوصف مطلوب',
    'post_failed': 'مشاركة فاشلة',
    'code': 'الكود',
    'create_account': 'إنشاء حساب',
    'apply': 'تطبيق',
    'account': 'الحساب',
    'debit': 'الخصم',
    'credit': 'الائتمان',
    'lines': 'خطوط',
    'hide': 'إخفاء',
    'reverse': 'عكس',
    'run': 'تشغيل',
    'total_debits': 'إجمالي الديون',
    'total_credits': 'إجمالي الاعتمادات',
    'journal_entry': 'إدخال دفتر اليومية',
    'building_id_label': 'تسمية معرف المبنى',
    'units_count': 'عدد الوحدات',
    'enable_in_settings': 'تمكين في الإعدادات',
    'unit_label': 'تسمية الوحدة',
    'no_messages_yet': 'لا توجد رسائل حتى الآن',
    'failed_to_load_notification_log': 'فشل في تحميل سجل الإخطارات',
    'no_notifications_found': 'لم يتم العثور على أي إشعارات',
    'channel': 'قناة',
    'recipient': 'المستلم',
    'flat_amount': 'المبلغ الثابت',
    'org_settings_desc': 'وصف إعدادات المؤسسة',
    'late_fee_configuration': 'تكوين الرسوم المتأخرة',
    'enabled': 'ممكّن',
    'disabled': 'معطل',
    'legal_note_late_fees': 'مذكرة قانونية الرسوم المتأخرة',
    'grace_period_days': 'أيام فترة السماح',
    'fee_type': 'نوع الرسوم',
    'percent_of_rent': 'نسبة الإيجار',
    'late_fee_summary': 'ملخص الرسوم المتأخرة',
    'applied_after': 'تطبق بعد',
    'discount_rent': 'خصم الإيجار',
    'lease_start': 'بداية الإيجار',
    'lease_end': 'نهاية الإيجار',
    'next_bill': 'مشروع القانون القادم',
    'no_units_found': 'لم يتم العثور على وحدات',
    'csv_download_failed': 'فشل تنزيل ملف CSV',
    'all_1099_downloaded': 'تم تنزيل جميع 1099',
    'no_reportable_owners': 'لا يوجد مالكون يمكن الإبلاغ عنهم',
    'pdf_download_failed': 'فشل تحميل قوات الدفاع الشعبي',
    'pdf_generation_failed': 'فشل إنشاء ملف PDF',
    'generating_pdfs': 'توليد ملفات PDF',
    'download_all_pdfs': 'تحميل جميع ملفات pdf',
    'important': 'مهم',
    'irs_1099_disclaimer': 'إخلاء المسؤولية IRS 1099',
    'owner_payment_summary': 'ملخص دفع المالك',
    'irs_threshold': 'عتبة مصلحة الضرائب',
    'total_paid': 'إجمالي المبلغ المدفوع',
    'form': 'النموذج',
    'file_form': 'نموذج الملف',
    'no_owner_payments_found': 'لم يتم العثور على مدفوعات المالك',
    'no_deposits_found': 'لم يتم العثور على الودائع',
    'deposit_amount': 'مبلغ الإيداع',
    'deductions': 'الخصومات',
    'error_loading_showing': 'حدث خطأ أثناء تحميل العرض',
    'required_fields_error': 'خطأ في الحقول المطلوبة',
    'showing_updated': 'يتم عرض التحديث',
    'showing_scheduled': 'عرض المجدولة',
    'time_conflict_error': 'خطأ في تعارض الوقت',
    'choose_unit': 'اختر الوحدة',
    'agent_name_placeholder': 'اسم الوكيل العنصر النائب',
    'schedule': 'الجدول الزمني',
    'error_loading_showings': 'خطأ في تحميل العروض',
    'marked_as': 'تم وضع علامة باسم',
    'update_failed': 'فشل التحديث',
    'delete_failed': 'فشل الحذف',
    'mark_completed': 'تم وضع علامة "مكتملة".',
    'mark_no_show': 'علامة لا تظهر',
    'confirm_delete': 'تأكيد الحذف',
    'confirm_delete_showing': 'تأكيد حذف العرض',
    'error_loading_surveys': 'حدث خطأ أثناء تحميل الاستطلاعات',
    'from_responses': 'من الردود',
    'no_data_yet': 'لا توجد بيانات حتى الآن',
    'utility_type_required': 'نوع الأداة المساعدة مطلوب',
    'failed_to_create_account': 'فشل في إنشاء الحساب',
    'select_tenant_error': 'حدد خطأ المستأجر',
    'please_fix_errors': 'الرجاء إصلاح الأخطاء',
    'bill_issued_successfully': 'تم إصدار الفاتورة بنجاح',
    'failed_to_issue_bill': 'فشل في إصدار الفاتورة',
    'download_csv': 'تنزيل ملف CSV',
    'vendor_1099_disclaimer': 'إخلاء مسؤولية البائع 1099',
    'vendor': 'بائع',
    'first_payment': 'الدفعة الأولى',
    'last_payment': 'الدفعة الأخيرة',
    'no_vendor_payments_recorded': 'لم يتم تسجيل أي مدفوعات للموردين',
    'account_deactivated': 'تم تعطيل الحساب',
    'server_no_response': 'الخادم لا يوجد استجابة',
    'login_to_continue': 'تسجيل الدخول للمتابعة',
    'logging_in': 'تسجيل الدخول',
    'dont_have_account': 'لا تملك حساب',
    'register': 'سجل',
    'company_name_required': 'اسم الشركة مطلوب',
    'registration_failed': 'فشل التسجيل',
    'sign_up_to_get_started': 'قم بالتسجيل للبدء',
    'company_name': 'اسم الشركة',
    'enter_company_name': 'أدخل اسم الشركة',
    'already_have_account': 'لديك حساب بالفعل',
    'fully_signed_active': 'موقعة بالكامل نشطة',
    'pending_owner_signature': 'في انتظار توقيع المالك',
    'pending_admin_signature': 'في انتظار توقيع المشرف',
    'terminated': 'تم إنهاؤه',
    'back_to_contracts': 'العودة إلى العقود',
    'contract_terms': 'شروط العقد',
    'payment_schedule': 'جدول الدفع',
    'no_installments_defined': 'لم يتم تحديد الأقساط',
    'signed_by': 'تم التوقيع بواسطة',
    'awaiting_admin_review': 'في انتظار مراجعة المشرف',
    'sign_contract': 'توقيع العقد',
    'past': 'الماضي',
    'tenant_signin_success': 'نجاح تسجيل دخول المستأجر',

    // Auto-added mass translations from ESLint Codemod
    '10': '10 /',
    '12': '/ 12',
    '16': '−16%',
    '25': '25 /',
    '50': '50 /',
    '100': '100 /',
    '600': ': 600 دولار',
    'ai_assistant_pro_only': 'مساعد الذكاء الاصطناعي – للمحترفين فقط',
    'ask_questions_about_your_portfolio_in_pl': 'اطرح أسئلة حول محفظتك باللغة الإنجليزية البسيطة. احصل على إجابات فورية حول الإيرادات والمدفوعات المتأخرة والوظائف الشاغرة والمزيد.',
    'upgrade_to_pro': 'الترقية إلى برو',
    'here_s_what_s_happening_across_your_port': 'إليك ما يحدث عبر محفظتك اليوم.',
    'portfolio_risk': 'مخاطر المحفظة',
    'pro_only': 'للمحترفين فقط',
    'pending_collections': 'المجموعات المعلقة',
    'ask_ai_assistant': 'اسأل مساعد الذكاء الاصطناعي',
    'unlock_ai_assistant_upgrade_to_pro': 'فتح مساعد الذكاء الاصطناعي - الترقية إلى Pro',
    'download': 'تحميل',
    'd': 'د',
    'view_details_1': 'عرض التفاصيل',
    'export_data': 'تصدير البيانات',
    'refresh_data': 'تحديث البيانات',
    'property_pulse': 'نبض الملكية',
    'cash_flow_analysis_for_the_current_fisca': 'تحليل التدفق النقدي للسنة المالية الحالية',
    'yearly_report': 'التقرير السنوي',
    'analytics_pro_required': 'مطلوب تحليلات برو',
    'unlock_deep_financial_insights_and_custo': 'احصل على رؤى مالية عميقة وتقارير تنبؤية مخصصة.',
    'upgrade_now': 'الترقية الآن',
    'items_requiring_immediate_follow_up': 'العناصر التي تتطلب المتابعة الفورية',
    'activity_log': 'سجل النشاط',
    'view_history': 'عرض التاريخ',
    'no_recent_logs_found': 'لم يتم العثور على سجلات حديثة',
    'active_issues': 'القضايا النشطة',
    'pro': 'برو',
    'pro_1': 'برو',
    'sell_unit': 'بيع الوحدة',
    'floor_1': 'الكلمة',
    'size_1': 'الحجم',
    'm': 'م²',
    'amenities': 'وسائل الراحة',
    'last_updated_today': 'آخر تحديث: اليوم',
    'back_to_apartment': 'العودة إلى الشقة',
    'sell_unit_1': 'بيع الوحدة',
    'floor_2': 'الكلمة',
    'select_buyer': 'حدد المشتري',
    'existing_owner': 'المالك الحالي',
    'new_buyer': 'مشتري جديد',
    'no_owners_found_switch_to_new_buyer_to_c': 'لم يتم العثور على مالكين — قم بالتبديل إلى "مشتري جديد" لإنشاء مالك',
    'search_owners_placeholder': 'ابحث عن المالكين بالاسم أو الهاتف أو البريد الإلكتروني...',
    'buyer_name_placeholder': 'مثال: أحمد الراشدي',
    'sale_notes_placeholder': 'ملاحظات اختيارية...',
    'edit_1': 'تحرير',
    'the_buyer_will_be_created_as_an_owner_an': 'سيتم إنشاء المشتري كمالك وربطه بهذا البيع تلقائيًا.',
    'sale_terms': 'شروط البيع',
    'total_sale_price': 'إجمالي سعر البيع *',
    'down_payment': 'الدفعة الأولى',
    'annual_interest_rate': 'سعر الفائدة السنوي (%)',
    'term_months': 'المدة (أشهر) *',
    'yrs': 'سنوات)',
    'sale_start_date': 'تاريخ البيع / البدء *',
    'quick_preview': 'معاينة سريعة',
    'principal': 'مدير المدرسة',
    'down_payment_1': 'الدفعة الأولى',
    'term': 'مصطلح',
    'months_1': 'أشهر',
    'amortization_schedule': 'جدول الاستهلاك',
    'confirm_sale': 'تأكيد البيع',
    'buyer': 'المشتري',
    'floor_3': '— الكلمة',
    'financial_terms': 'الشروط المالية',
    'draft_sale_contract': 'مسودة عقد البيع',
    'will_be_created_the_apartment_will_be_ma': 'سيتم إنشاء. سيتم وضع علامة على الشقة على أنها',
    'sold': 'تم البيع',
    'only_after_both_you_and_the_buyer_digita': 'فقط بعد قيامك أنت والمشتري بتوقيع العقد رقميًا.',
    'sale_finalized': 'تم الانتهاء من البيع!',
    'the_sale_contract_for_unit': 'عقد بيع الوحدة',
    'has_been_created_use_the_links_below_to': 'تم إنشاؤه. استخدم الروابط أدناه للانضمام إلى المشتري.',
    'public_sign_link': 'رابط التوقيع العام',
    'p_sign_owner': '/ص/توقيع/مالك/',
    'portal_invite_link': 'رابط دعوة البوابة',
    'portal_setup_password_type_owner_id': '/portal/setup-password?type=owner&id=',
    'email_1': '&البريد الإلكتروني=',
    'token': '&الرمز=',
    'view_owner': 'عرض المالك',
    'manage_contract': 'إدارة العقد',
    '0_10': '(0-10،',
    'm_1': 'م²',
    'm_2': 'م²',
    'm_3': 'م²',
    'm_4': 'م²',
    'empty_key': '✕',
    'this_apartment_already_has': 'هذه الشقة لديها بالفعل',
    'active_booking_s_for_these_dates': 'الحجز (الحجوزات) النشطة لهذه التواريخ.',
    'levels': 'المستويات',
    'cap': 'كاب',
    'no_inventory_data': 'لا توجد بيانات المخزون',
    'init_units': 'الوحدات الأولية',
    'm_5': 'م²',
    'm_6': 'م²',
    'supports_markdown_placeholders_e_g': 'يدعم MarkDown والعناصر النائبة على سبيل المثال.',
    'empty_key_1': '✓',
    'trial_ends_in': 'تنتهي المحاكمة في',
    'days_subscribe': 'أيام - اشترك',
    'new_lease_agreement': 'اتفاقية الإيجار الجديدة',
    'tenant_unit_assignment': 'تعيين المستأجر والوحدة',
    'please_select_a_building_first': 'الرجاء تحديد المبنى أولاً',
    'lease_terms_duration': 'شروط ومدة الإيجار',
    'lease_type': 'نوع الإيجار',
    'fixed_term': 'مصطلح محدد',
    'month_to_month': 'من شهر إلى شهر',
    'end_date_optional': 'تاريخ الانتهاء (اختياري)',
    'financial_obligations': 'الالتزامات المالية',
    'empty_key_2': ') *',
    'notes_special_provisions': 'ملاحظات / أحكام خاصة',
    'empty_key_3': ': #',
    'send_for_signature': 'إرسال للتوقيع',
    'copy_sign_link': 'انسخ رابط التوقيع',
    'download_contract_pdf': 'تحميل العقد PDF',
    'contract_summary': 'ملخص العقد',
    'generated_from_template': 'تم إنشاؤها من القالب:',
    'digitally_executed': 'تم تنفيذها رقميا',
    'electronic_signatures': 'التوقيعات الإلكترونية',
    'management_office': 'مكتب الإدارة',
    'authorized_signature': 'التوقيع المعتمد',
    'owner_landlord': 'المالك / المالك',
    'email_2': 'البريد الإلكتروني:',
    'signed': 'التوقيع:',
    'ip': 'الملكية الفكرية:',
    'reason_for_voiding': 'سبب الإفراغ',
    'building_agreement_for': 'اتفاقية بناء ل',
    'contract_builder_rules': 'قواعد منشئ العقد',
    'select_contract_template': 'حدد قالب العقد',
    'no_template_manual_mode': 'لا يوجد قالب (الوضع اليدوي)',
    'template_dynamic_variables': 'المتغيرات الديناميكية للقالب',
    'owner_default_commission': 'العمولة الافتراضية للمالك:',
    'maintenance_threshold': 'عتبة الصيانة:',
    'unit_1': 'وحدة',
    'sale_unit_purchase': 'بيع / شراء وحدة',
    'fixed_maintenance_contract': 'عقد الصيانة الثابتة',
    'lease_agreement': 'اتفاقية الإيجار',
    'start_date_1': 'تاريخ البدء',
    'auto_generate_quarterly': 'إنشاء تلقائي ربع سنوي',
    'add_custom_installment': 'إضافة قسط مخصص',
    'plan_total': 'إجمالي الخطة',
    'agreement': 'اتفاق',
    'copy_portal_link': 'انسخ رابط البوابة',
    'portal_link_copied': 'تم نسخ رابط البوابة إلى الحافظة',
    'failed_generate_invite_link': 'فشل إنشاء رابط الدعوة',
    'ledger': 'دفتر الأستاذ',
    'empty_key_4': ') †’',
    'owner_documents': 'وثائق المالك',
    'add_document': 'إضافة مستند',
    'name_1': 'الاسم *',
    'tax': 'ضريبة',
    'file_url': 'عنوان الملف *',
    'cancel_1': 'إلغاء',
    'no_documents_yet': 'لا توجد وثائق حتى الآن',
    'document_added': 'تمت إضافة المستند',
    'name_and_url_required': 'الاسم والرابط مطلوبان',
    'uploaded_by': 'رُفع بواسطة',
    'delete_document': 'حذف المستند',
    'document_name_placeholder': 'اسم المستند',
    '30_days': '(30 يومًا)',
    'view_1': 'عرض',
    'future_scheduled_installments': 'الأقساط المقررة في المستقبل',
    'unit_2': 'وحدة',
    'no_investment_data_available_add_purchas': 'لا توجد بيانات استثمارية متاحة. أضف سعر الشراء والقيمة الحالية للشقق لمعرفة المقاييس.',
    'click_the_edit_icon_on_any_unit_to_updat': 'انقر فوق أيقونة التحرير الموجودة على أي وحدة لتحديث قيمتها السوقية الحالية أو سعر الشراء.',
    'unit_3': 'وحدة',
    'unit_mo': 'وحدة/شهر',
    'save_16_billed_annually': 'وفر 16% · يتم إصدار الفاتورة سنويًا',
    'reason_for_rejection': 'سبب الرفض',
    'of_1': 'من',
    'error_loading_receipt': 'حدث خطأ أثناء تحميل الإيصال',
    'go_back': 'العودة',
    'receipt_not_found': 'لم يتم العثور على الإيصال',
    'the_requested_payment_receipt_could_not': 'تعذر العثور على إيصال الدفع المطلوب.',
    'go_back_1': 'العودة',
    'payment_receipt': 'إيصال الدفع',
    'issue_date': 'تاريخ الإصدار:',
    'from_1': 'من',
    'phone_1': 'الهاتف:',
    'to_1': 'ل',
    'phone_2': 'الهاتف:',
    'amount_1': 'المبلغ',
    'notes_1': 'ملاحظات',
    'thank_you_for_your_payment': 'شكرا لك على الدفع الخاص بك!',
    'this_receipt_was_generated_automatically': 'تم إنشاء هذا الإيصال تلقائيًا.',
    'delete_template': 'حذف القالب',
    'cancel_2': 'إلغاء',
    'delete_1': 'حذف',
    'description_optional': 'الوصف (اختياري)',
    'report_type': 'نوع التقرير',
    'choosing_a_report_type_shows_the_relevan': 'يؤدي اختيار نوع التقرير إلى عرض عوامل التصفية ذات الصلة أدناه.',
    'saved_filters': 'المرشحات المحفوظة',
    'select_a_report_type_above_to_set_saved': 'حدد نوع التقرير أعلاه لتعيين قيم التصفية المحفوظة لهذا القالب.',
    'cancel_3': 'إلغاء',
    'saved_filter': 'مرشح محفوظ',
    'saved_1': 'تم الحفظ',
    'favourites': 'المفضلة',
    'all_templates': 'جمیع القوالب',
    'load_template': 'تحميل القالب',
    'favourites_1': 'المفضلة',
    'no_templates_for_this_report_type': 'لا توجد قوالب لهذا النوع من التقارير',
    'saved_filter_1': 'مرشح محفوظ',
    'manage_apartment_sales_and_track_sold_un': 'إدارة مبيعات الشقق وتتبع الوحدات المباعة',
    'apartments_1': 'شقق',
    'available': 'متاح',
    'sold_1': 'بيعت',
    'sold_rate': 'نسبة البيع %',
    'floor_4': 'الكلمة',
    'units_1': 'وحدات',
    'available_1': 'متاح',
    'sold_2': 'بيعت',
    'unit_4': 'وحدة',
    'owner_buyer': 'المالك / المشتري',
    'sale_price': 'سعر البيع',
    'sale_date': 'تاريخ البيع',
    'sell_unit_2': 'بيع الوحدة',
    'search_unit_or_buyer': 'ابحث عن وحدة أو مشتري...',
    'stat_available_to_sell': 'متاحة للبيع',
    'stat_sold_units': 'الوحدات المباعة',
    'status_all': 'الكل',
    'status_vacant': 'شاغرة',
    'status_available': 'متاحة',
    'status_occupied': 'مشغولة',
    'status_sold': 'مباعة',
    'status_maintenance': 'صيانة',
    'view_details_2': 'عرض التفاصيل',
    'print_1': 'طباعة',
    'apartment_management_system': 'نظام إدارة الشقق',
    'erbil_kurdistan_region_iraq': 'أربيل، إقليم كوردستان – العراق',
    'tel_xxx_xxxxxxxx': 'الهاتف: +XXXXXXXXXXXX',
    'receipt': 'رقم الإيصال:',
    'name_2': 'الاسم:',
    'phone_3': 'الهاتف:',
    'building_1': 'بناء:',
    'payment_details_1': 'تفاصيل الدفع',
    'amount_2': 'المبلغ:',
    'payment_date_1': 'تاريخ الدفع:',
    'period_1': 'الفترة:',
    'notes_2': 'ملاحظات',
    'thank_you_for_your_payment_1': 'شكرا لك على الدفع الخاص بك!',
    'tenant_information_1': 'معلومات المستأجر',
    'name_3': 'الاسم:',
    'phone_4': 'الهاتف:',
    'apartment_1': 'شقة:',
    'building_2': 'بناء:',
    'furnished_1': 'مفروشة:',
    'at_12_00_pm': 'الساعة 12:00 ظهرًا',
    'monthly_rent_1': 'الإيجار الشهري:',
    'insurance_1': 'التأمين:',
    'additional_notes': 'ملاحظات إضافية',
    'tenant_signature': 'توقيع المستأجر',
    'this_receipt_is_electronically_generated': 'يتم إنشاء هذا الإيصال إلكترونيًا ويكون صالحًا بدون توقيع.',
    'apartment_management_system_all_rights_r': 'نظام إدارة الشقق. جميع الحقوق محفوظة.',
    'lease_renewal_risk': 'مخاطر تجديد عقد الإيجار',
    'expiring_in_30_days': 'تنتهي صلاحيته خلال 30 يومًا',
    'expiring_in_60_days': 'تنتهي صلاحيته خلال 60 يومًا',
    'expiring_in_90_days': 'تنتهي صلاحيته خلال 90 يومًا',
    'expiring_in_180_days': 'تنتهي صلاحيته خلال 180 يومًا',
    'all_risk_levels': 'جميع مستويات المخاطر',
    'no_leases_matching_the_selected_filters': 'لا توجد عقود إيجار مطابقة للمرشحات المحددة.',
    'd_1': 'د',
    'no_documents_uploaded_for_this_tenant': 'لم يتم تحميل أي مستندات لهذا المستأجر.',
    'empty_key_5': '✓',
    'empty_key_6': '✕',
    'empty_key_7': '($) *',
    'ai_lease_reader': 'قارئ الإيجار بالذكاء الاصطناعي',
    'upload_a_lease_pdf_to_auto_fill_the_form': 'قم بتحميل ملف PDF للإيجار لملء النموذج تلقائيًا',
    'empty_key_8': '●',
    'empty_key_9': '✓',
    '10_1': '10 /',
    '25_1': '25 /',
    '50_1': '50 /',
    '100_1': '100 /',
    'register_as_maintenance_provider_service': 'التسجيل كمقدم صيانة (بائع الخدمة)',
    'this_will_automatically_create_a_record': 'سيؤدي هذا تلقائيًا إلى إنشاء سجل في مركز الصيانة حتى تتمكن من تعيين أوامر العمل لهذا المستخدم.',
    'assigned_buildings_portfolio': 'المباني المخصصة (المحفظة)',
    'select_the_buildings_this_portfolio_mana': 'حدد المباني التي يمكن لمدير المحفظة هذا الوصول إليها. سوف يرون فقط بيانات هذه المباني.',
    'no_buildings_found_please_create_buildin': 'لم يتم العثور على المباني. يرجى إنشاء المباني أولا.',
    'building_3': 'بناء',
    'empty_key_10': '☀️',
    '1_315_333_7884': '+1 (315) 333-7884',
    'sent_sid': '✅ تم الإرسال! معرف الأمان:',
    'iraq_964_is_blocked_by_default_enable_it': '🌍 العراق (+964) محجوب افتراضياً. تمكينه:',
    'twilio_messaging_geo_permissions_iraq_on': 'Twilio → المراسلة → الأذونات الجغرافية → العراق → تشغيل → حفظ',
    'trial_accounts_can_only_message': '🔒الحسابات التجريبية يمكنها المراسلة فقط',
    'verified_numbers': 'أرقام تم التحقق منها',
    'apt_1': '· شقة',
    'mo_1': '/ مو',
    'mo_2': '/ مو',
    'manage_building_amenities_unit_features': 'إدارة مرافق المبنى وميزات الوحدة وأماكن وقوف السيارات',
    'all_buildings_1': 'جميع المباني',
    'add_amenity': 'أضف وسائل الراحة',
    'no_building_amenities_found': 'لم يتم العثور على مرافق البناء',
    'all_buildings_2': 'جميع المباني',
    'all_units': 'جميع الوحدات',
    'add_unit_amenity': 'إضافة وسائل الراحة للوحدة',
    'no_unit_amenities_found': 'لم يتم العثور على وسائل الراحة للوحدة',

    'unit_amenities': 'مرافق الوحدة',
    'edit_unit_amenity': 'تعديل مرفق الوحدة',
    'col_monthly_fee': 'الرسوم الشهرية',
    'col_available': 'متاح',
    'col_space': 'المساحة',
    'col_amenity': 'المرفق',
    'all_buildings_3': 'جميع المباني',
    'available_2': 'متاح',
    'reserved': 'محفوظة',
    'add_space': 'أضف مساحة',
    'no_parking_spaces_found': 'لم يتم العثور على أماكن لوقوف السيارات',
    'assign': 'تعيين',
    'unassign': 'إلغاء التعيين',
    'spaces': 'المساحات',
    'driveway_area': 'منطقة الممر',
    'cancel_4': 'إلغاء',
    'complete': 'كامل',
    'confirm_1': 'تأكيد',
    'cancel_5': 'إلغاء',
    'complete_1': 'كامل',
    'assign_space': 'تخصيص مساحة',
    'select_tenant_1': 'حدد المستأجر',
    'choose_tenant': '-- اختر المستأجر --',
    'select_owner': 'حدد المالك',
    'choose_owner': '-- اختر المالك --',
    'cancel_6': 'إلغاء',
    'assign_1': 'تعيين',
    'new_amenity_booking': 'حجز وسائل الراحة الجديدة',
    'amenity': 'وسائل الراحة *',
    'select_amenity': 'اختر وسائل الراحة…',
    'tenant_1': 'المستأجر *',
    'select_tenant_2': 'اختر المستأجر...',
    'date_1': 'التاريخ *',
    'notes_3': 'ملاحظات',
    'cancel_7': 'إلغاء',
    'deactivated': 'معطل',
    'max_uses': 'الاستخدامات القصوى',
    'generate_application_link': 'إنشاء رابط التطبيق',
    'building_4': 'المبنى *',
    'specific_unit_optional': 'وحدة محددة (اختياري)',
    'any_unit_in_building': 'أي وحدة في المبنى',
    'unit_5': 'وحدة',
    'floor_5': '- الكلمة',
    'label': 'التسمية',
    'expires_at': 'تنتهي في',
    'max_uses_1': 'الاستخدامات القصوى',
    'cancel_8': 'إلغاء',
    'label_unit': 'التسمية / الوحدة',
    'token_url': 'عنوان URL للرمز المميز',
    'uses': 'الاستخدامات',
    'status_1': 'الحالة',
    'no_links_yet_click_generate_link_to_crea': 'لا توجد روابط حتى الآن. انقر على "إنشاء رابط" لإنشاء رابط.',
    'link_generated': 'تم إنشاء الرابط!',
    'failed_to_generate_link': 'فشل إنشاء الرابط',
    'failed_to_load_links': 'فشل تحميل الروابط',
    'link_deactivated': 'تم تعطيل الرابط',
    'search_label_building_token': 'البحث بالتسمية أو المبنى أو الرمز…',
    'links_count': '{{count}} رابط',
    'untitled': 'بدون عنوان',
    'open_form': 'فتح النموذج',
    'no_links_match_filters': 'لا توجد روابط تطابق الفلاتر.',
    'unit_6': '· الوحدة',
    '1_30': '1-30',
    '31_60': '31-60',
    '61_90': '61-90',
    'building_amenity': 'وسائل الراحة في المبنى',
    'amenity_details': 'تفاصيل وسائل الراحة',
    'building_5': 'المبنى *',
    'name_4': 'الاسم *',
    'category_1': 'الفئة',
    'monthly_fee': 'الرسوم الشهرية ($)',
    'operating_hours': 'ساعات العمل',
    'capacity': 'القدرة',
    'description_1': 'الوصف',
    'notes_4': 'ملاحظات',
    'available_for_booking': 'متاح للحجز',
    'cancel_9': 'إلغاء',
    'saving_1': 'جارٍ الحفظ…',
    'bulk_tenant_import': 'استيراد المستأجر بالجملة',
    'import_tenants_from_a_csv_file_apartment': 'قم باستيراد المستأجرين من ملف CSV - تتم مطابقة الشقق حسب اسم المبنى + رقم الوحدة',
    'download_csv_template': 'تنزيل قالب CSV',
    'use_this_template_to_format_your_data_co': 'استخدم هذا القالب لتنسيق بياناتك بشكل صحيح',
    'template': 'القالب',
    'required_columns': 'الأعمدة المطلوبة',
    'optional_columns': 'الأعمدة الاختيارية',
    'payment_date_2': 'تاريخ الدفع',
    'day_of_month_1_31': '= يوم من الشهر (1–31)  ·',
    'contract_start_contract_end': 'Contract_start / Contract_end',
    'yyyy_mm_dd': '= YYYY-MM-DD  ·',
    'en_ar_fr_de_it_sp': '= en، ar، fr، de، it، sp',
    'parsing_csv': 'جارٍ تحليل ملف CSV...',
    'or_click_to_browse_max_2_mb': 'أو انقر للتصفح - بحد أقصى 2 ميجابايت',
    'import_preview': 'معاينة الاستيراد',
    'rows_found_review_before_importing': 'تم العثور على صفوف — قم بمراجعتها قبل الاستيراد',
    'start_over': 'البدء من جديد',
    'name_5': 'الاسم',
    'phone_5': 'الهاتف',
    'building_unit': 'المبنى / الوحدة',
    'contract_1': 'العقد',
    'status_2': 'الحالة',
    'empty_key_11': '· #',
    'ready_to_import': 'جاهز للاستيراد',
    'tenant_2': 'المستأجر',
    'row': 'صف',
    'with_errors_will_be_skipped': 'مع الأخطاء سيتم تخطيها',
    'no_valid_rows_to_import': 'لا توجد صفوف صالحة للاستيراد',
    'fix_the_errors_in_your_csv_and_try_again': 'قم بإصلاح الأخطاء في ملف CSV وحاول مرة أخرى',
    'upload_new_file': 'تحميل ملف جديد',
    'import_complete': 'اكتمل الاستيراد',
    'tenants_successfully_imported': 'تم استيراد المستأجرين بنجاح',
    'row_1': 'صف',
    'skipped_rows': 'الصفوف التي تم تخطيها',
    'row_2': 'صف',
    'import_another_file': 'استيراد ملف آخر',
    'view_tenants': 'عرض المستأجرين',
    'upload_document': 'تحميل الوثيقة',
    'tenant_3': 'المستأجر *',
    'select_tenant_3': 'اختر المستأجر...',
    'document_name': 'اسم الوثيقة *',
    'category_2': 'الفئة',
    'file_pdf_image_word_max_5mb': 'الملف * (PDF، صورة، Word — بحد أقصى 5 ميجابايت)',
    'upload_document_1': 'تحميل الوثيقة',
    'document_management': 'إدارة الوثائق',
    'document': 'وثيقة',
    'across_all_tenants': 'عبر جميع المستأجرين',
    'upload': 'تحميل',
    'all_categories': 'جميع الفئات',
    'document_1': 'وثيقة',
    'tenant_4': 'المستأجر',
    'category_3': 'الفئة',
    'status_3': 'الحالة',
    'uploaded': 'تم الرفع',
    'actions_1': 'الإجراءات',
    'no_documents_found': 'لم يتم العثور على وثائق',
    'of_2': 'من',
    'prev': 'السابق',
    'next_1': 'التالي',
    'select_tenant_required': 'اختر مستأجراً',
    'document_name_required': 'اسم المستند مطلوب',
    'select_file_required': 'يرجى اختيار ملف',
    'document_uploaded': 'تم رفع المستند',
    'upload_failed': 'فشل الرفع',
    'failed_to_load_documents': 'فشل تحميل المستندات',
    'document_status_updated': 'تم تحديث حالة المستند',
    'failed_to_update_status': 'فشل تحديث الحالة',
    'confirm_delete_doc': 'حذف "{{name}}"؟ يمكن التراجع عن ذلك من قبل المسؤول.',
    'failed_to_delete_document': 'فشل الحذف',
    'documents_count': '{{count}} مستند',
    'search_by_tenant_name': 'البحث باسم المستأجر…',
    'doc_results_count': '{{count}} نتيجة',
    'uploaded_from': 'تاريخ الرفع من',
    'uploaded_to': 'تاريخ الرفع إلى',
    'doc_cat_id': 'هوية',
    'doc_cat_contract': 'عقد',
    'doc_cat_financial': 'مالي',
    'doc_cat_insurance': 'تأمين',
    'doc_cat_other': 'أخرى',
    'approved': 'موافق عليه',
    'file_1': 'ملف',
    'open_eviction_case': 'فتح قضية الإخلاء',
    'tenant_5': 'المستأجر',
    'tenant_6': 'المستأجر *',
    'building_apartment_auto_filled_from_tena': 'يتم ملء المبنى والشقق تلقائيًا من سجل المستأجر',
    'case_details': 'تفاصيل القضية',
    'reason': 'السبب *',
    'notice_type': 'نوع الإشعار',
    'cancel_10': 'إلغاء',
    'open_case': 'فتح القضية',
    'eviction_management': 'إدارة الإخلاء',
    'track_and_manage_eviction_cases_from_not': 'تتبع وإدارة قضايا الإخلاء من',
    'new_case': 'حالة جديدة',
    'pipeline': 'خط أنابيب',
    'no_eviction_cases_found': 'لم يتم العثور على حالات الإخلاء',
    'advance': 'تقدم →',
    'eviction_case': 'حالة الإخلاء #',
    'tenant_7': 'المستأجر',
    'unit_7': '· الوحدة رقم',
    'reason_1': 'السبب',
    'amount_owed_1': 'المبلغ المستحق',
    'pipeline_status': 'حالة خط الأنابيب',
    'notes_5': 'ملاحظات',
    'expense_details': 'تفاصيل النفقات',
    'payment_info': 'معلومات الدفع',
    'description_2': 'الوصف',
    'no_accounts_posted_yet': 'لم يتم نشر أي حسابات حتى الآن.',
    'total_1': 'المجموع',
    'assets': 'الأصول',
    'liabilities': 'المسؤوليات',
    'select_a_date_and_click_run_to_generate': 'حدد التاريخ وانقر على تشغيل لإنشاء',
    'from_2': 'من',
    'to_2': 'ل',
    'run_1': 'تشغيل',
    'operating_activities': 'الأنشطة التشغيلية',
    'net_operating_cash_flow': 'صافي التدفق النقدي التشغيلي',
    'financing_activities': 'أنشطة التمويل',
    'net_financing_cash_flow': 'صافي التدفق النقدي للتمويل',
    'net_change_in_cash': 'صافي التغير في النقد',
    'select_a_date_range_and_click_run': 'حدد نطاقًا زمنيًا وانقر فوق "تشغيل".',
    'balance_sheet': 'الميزانية العمومية',
    'cash_flow_statement': 'التدفق النقدي',
    'total_assets': 'إجمالي الأصول',
    'total_liabilities': 'إجمالي الالتزامات',
    'total_equity': 'إجمالي حقوق الملكية',
    'bs_balanced_msg': '✓ متوازن — الأصول = الالتزامات + حقوق الملكية',
    'bs_unbalanced_msg': '⚠ غير متوازن — تحقق من قيود اليومية',
    'operating_cash_flow': 'التدفق النقدي من الأنشطة التشغيلية',
    'financing_cash_flow': 'التدفق النقدي من أنشطة التمويل',
    'edit_expense': 'تعديل المصروف',
    'expense_updated': 'تم تحديث المصروف',
    'rated': 'تصنيف',
    'property_inspections': 'تفتيش الممتلكات',
    'move_in_move_out_periodic_20_item_standa': 'الانتقال إلى الداخل · الخروج · بشكل دوري · قائمة مرجعية موحدة مكونة من 20 بندًا',
    'new_inspection': 'التفتيش الجديد',
    'no_inspections_found': 'لم يتم العثور على عمليات التفتيش.',
    'adjust_the_filters_or_create_a_new_inspe': 'اضبط عوامل التصفية أو أنشئ فحصًا جديدًا.',
    'showing_1': 'عرض',
    'of_3': 'من',
    'new_inspection_1': 'التفتيش الجديد',
    'apartment_2': 'شقة',
    'nothing_found': 'لم يتم العثور على شيء.',
    'unit_8': '- الوحدة',
    'no_active_tenant_on_this_unit': 'لا يوجد مستأجر نشط في هذه الوحدة.',
    'tenant_8': 'المستأجر',
    'no_tenant_vacant': 'لا يوجد مستأجر (شاغر)',
    'inspection_type': 'نوع التفتيش',
    'overall_condition': 'الحالة العامة',
    'a_20_item_standardized_checklist_entranc': 'سيتم تلقائيًا إنشاء قائمة مرجعية موحدة مكونة من 20 عنصرًا (المدخل، غرفة المعيشة، المطبخ، الحمام، غرفة النوم، العام).',
    'cancel_11': 'إلغاء',
    'creating': 'جارٍ الإنشاء…',
    'create_inspection': 'إنشاء التفتيش',
    'unit_9': '· الوحدة',
    'tenant_9': 'المستأجر:',
    'inspector': 'المفتش:',
    'print_2': 'طباعة',
    'checklist_completion': 'استكمال قائمة المراجعة',
    'overall': 'الإجمالي:',
    'click_a_condition_button_to_rate_each_it': 'انقر على زر الحالة لتقييم كل عنصر. يتم حفظ الملاحظات تلقائيًا عند حدوث تشويش.',
    'general_notes_1': 'ملاحظات عامة',
    'close_1': 'إغلاق',
    'completing': 'جارٍ الإكمال…',
    'mark_as_completed': 'وضع علامة كمكتمل',
    'close_2': 'إغلاق',
    'signing': 'التوقيع…',
    'sign_inspection': 'توقيع الفحص',
    'sign_inspection_message': 'هل تريد تعيين هذا الفحص كموقّع؟ هذا الإجراء نهائي ولا يمكن التراجع عنه.',
    'signing_is_final_and_cannot_be_undone': 'التوقيع نهائي ولا يمكن التراجع عنه.',
    'delete_draft_inspection': 'حذف مسودة الفحص',
    'delete_draft_confirm': 'هل أنت متأكد من حذف مسودة الفحص هذه؟',
    'failed_load_inspections': 'فشل تحميل الفحوصات',
    'inspection_created': 'تم إنشاء الفحص',
    'failed_create_inspection': 'فشل إنشاء الفحص',
    'failed_save_checklist': 'فشل حفظ قائمة التحقق',
    'inspection_completed': 'تم تعيين الفحص كمكتمل',
    'inspection_signed': 'تم توقيع الفحص',
    'failed_sign_inspection': 'فشل توقيع الفحص',
    'failed_update_condition': 'فشل تحديث الحالة',
    'inspection_deleted': 'تم حذف الفحص',
    'failed_delete_inspection': 'يمكن حذف مسودات الفحص فقط',
    'search_inspections_placeholder': 'ابحث بالوحدة أو المبنى أو المستأجر...',
    'search_apartment_placeholder': 'ابحث عن شقة...',
    'inspection_notes_placeholder': 'أي ملاحظات أو مشاهدات أولية...',
    'item_notes_placeholder': 'أضف ملاحظات لهذا البند...',
    'fair': 'مقبول',
    'poor': 'سيء',
    'covered_entity': 'الكيان المغطى',
    'select': 'اختر',
    'policy_details': 'تفاصيل السياسة',
    'insurer_name': 'اسم المؤمن *',
    'start_date_2': 'تاريخ البدء',
    'notes_6': 'ملاحظات',
    'cancel_12': 'إلغاء',
    'manage_tenant_owner_and_building_insuran': 'إدارة وثائق التأمين للمستأجر والمالك والمبنى',
    'empty_key_12': '✓',
    'new_lease_application': 'طلب إيجار جديد',
    'applicant_information': 'معلومات مقدم الطلب',
    'full_name_1': 'الاسم الكامل *',
    'email_3': 'البريد الإلكتروني',
    'phone_6': 'الهاتف',
    'date_of_birth': 'تاريخ الميلاد',
    'current_address': 'العنوان الحالي',
    'employment': 'التوظيف',
    'employment_status': 'الحالة الوظيفية',
    'monthly_income': 'الدخل الشهري ($)',
    'employer_name': 'اسم صاحب العمل',
    'employer_phone': 'هاتف صاحب العمل',
    'unit_preferences': 'تفضيلات الوحدة',
    'building_6': 'بناء',
    'unit_10': 'وحدة',
    'desired_move_in': 'الانتقال المطلوب',
    'desired_lease_months': 'الإيجار المرغوب فيه (أشهر)',
    'has_pets': 'لديه حيوانات أليفة',
    'pet_details': 'تفاصيل الحيوانات الأليفة',
    'notes_7': 'ملاحظات',
    'cancel_13': 'إلغاء',
    'submit_application': 'تقديم الطلب',
    'review_and_approve_prospective_tenant_ap': 'مراجعة والموافقة على طلبات المستأجرين المحتملين',
    'all_buildings_4': 'جميع المباني',
    'no_applications_found': 'لم يتم العثور على أي تطبيقات',
    'showing_2': 'عرض',
    'of_4': 'من',
    'prev_1': 'السابق',
    'next_2': 'التالي',
    'close_3': 'إغلاق',
    'unit_11': '· الوحدة رقم',
    'monthly_rent_2': 'الإيجار الشهري *',
    'discount_1': 'خصم',
    'contract_start_1': 'بداية العقد *',
    'contract_end_1': 'نهاية العقد *',
    'payment_day_of_month': 'يوم الدفع من الشهر *',
    'application': 'التطبيق',
    'rejection_reason': 'سبب الرفض',
    'cancel_14': 'إلغاء',
    'app_search_placeholder': 'ابحث بالاسم أو البريد الإلكتروني أو الهاتف…',
    'app_status_submitted': 'مُقدَّم',
    'app_status_under_review': 'قيد المراجعة',
    'app_status_approved': 'مقبول',
    'app_status_rejected': 'مرفوض',
    'app_status_waitlisted': 'في قائمة الانتظار',
    'app_status_withdrawn': 'مسحوب',
    'app_status_converted': 'تم التحويل',
    'sort_newest': 'الأحدث أولاً',
    'sort_movein_asc': 'الانتقال ↑ الأقرب',
    'sort_movein_desc': 'الانتقال ↓ الأبعد',
    'sort_income_asc': 'الدخل ↑ الأدنى',
    'sort_income_desc': 'الدخل ↓ الأعلى',
    'all_employment': 'جميع أنواع التوظيف',
    'emp_other': 'أخرى',
    'move_in_from': 'الانتقال من',
    'move_in_to': 'الانتقال إلى',
    'application_results_count': '{{count}} طلب',
    'failed_to_load_lease_applications': 'فشل تحميل طلبات الإيجار',
    'status_updated_to': 'تم تحديث الحالة إلى {{status}}',
    'rent_dates_payment_required': 'الإيجار وتاريخا البدء والانتهاء ويوم الدفع مطلوبة',
    'converted_to_tenant_success': 'تم التحويل إلى مستأجر',
    'conversion_failed': 'فشل التحويل',
    'lease_duration_months_label': 'مدة الإيجار',
    'lease_duration_months': '{{n}} شهر',
    'details_not_provided': 'لم يتم تقديم التفاصيل',
    'reviewed_by': 'راجعه',
    'reviewed_at': 'تاريخ المراجعة',
    'converting': 'جارٍ التحويل…',
    'applicant_name_required': 'اسم مقدم الطلب مطلوب',
    'failed_to_submit_application': 'فشل تقديم الطلب',
    'submitting': 'جارٍ الإرسال…',
    'update_failed': 'فشل التحديث',
    'nightly_scan_flags_leases_expiring_in_90': 'علامات الفحص الليلي لعقود الإيجار التي تنتهي صلاحيتها خلال 90 يومًا - يتم إنشاء مسودة العروض تلقائيًا، ويمكنك إرسالها بنقرة واحدة',
    'send_all_drafts': 'إرسال كافة المسودات (',
    'expiring_within_90_days': 'تنتهي صلاحيتها خلال 90 يومًا',
    'without_an_offer_yet': 'بدون عرض حتى الآن',
    'd_2': 'د',
    'offer_sent': 'تم إرسال العرض',
    'no_offer': 'لا يوجد عرض',
    'all_statuses_1': 'جميع الحالات',
    'no_renewals_found': 'لم يتم العثور على التجديدات',
    'd_left': 'د اليسار',
    'convert_lease': 'تحويل الإيجار',
    'counter_offer': 'عرض العداد',
    'tenant_10': 'المستأجر:',
    'counter_rent_amount': 'مبلغ الإيجار العداد *',
    'cancel_15': 'إلغاء',
    'send_counter': 'إرسال العداد',
    'error_loading_renewals': 'فشل تحميل التجديدات',
    'offer_sent_2': 'تم إرسال العرض',
    'error_sending_offer': 'فشل إرسال العرض',
    'renewal_accepted': 'تم قبول التجديد',
    'error_accepting_renewal': 'فشل قبول التجديد',
    'decline_renewal_title': 'رفض التجديد',
    'decline_renewal_msg': 'هل أنت متأكد من رغبتك في رفض عرض التجديد هذا؟',
    'renewal_declined': 'تم رفض التجديد',
    'error_declining_renewal': 'فشل رفض التجديد',
    'lease_converted_msg': 'تم تحويل عقد الإيجار — تم تحديث سجل المستأجر!',
    'error_converting_renewal': 'فشل تحويل التجديد',
    'drafts_created': 'تم إنشاء {{count}} مسودة عرض!',
    'no_new_drafts_needed': 'لا حاجة لمسودات جديدة — جميع عقود الإيجار المنتهية لديها عروض بالفعل.',
    'error_generating_drafts': 'فشل إنشاء المسودات',
    'no_draft_renewals_to_send': 'لا توجد تجديدات مسودة للإرسال',
    'send_all_draft_offers_title': 'إرسال جميع عروض المسودة',
    'send_all_draft_offers_msg': 'إرسال عروض التجديد إلى جميع {{count}} مستأجر مسودة (بريد إلكتروني + واتساب)؟',
    'offers_sent': 'تم إرسال {{count}} عرض!{{failed}}',
    'error_sending_offers': 'فشل إرسال العروض',
    'counter_offer_sent': 'تم إرسال العرض المضاد',
    'error_sending_counter': 'فشل إرسال العرض المضاد',
    'search_tenant_unit_building': 'البحث بالمستأجر أو الوحدة أو المبنى…',
    'all_risk': 'جميع المخاطر',
    'risk_low': 'مخاطر منخفضة',
    'risk_medium': 'مخاطر متوسطة',
    'risk_high': 'مخاطر عالية',
    'renewals_count': '{{count}} تجديد',
    'leases_expiring_90d': '{{count}} عقد إيجار تنتهي خلال 90 يومًا',
    'viewed_1': 'تمت المشاهدة',
    'accepted_1': 'مقبول',
    'counter_offered': 'عرض مضاد',
    'declined_1': 'مرفوض',
    'full_lease_lifecycle_create_renew_termin': 'دورة حياة الإيجار الكاملة - الإنشاء والتجديد والإنهاء والتاريخ',
    'new_lease': 'عقد إيجار جديد',
    'all_status_1': 'كل الحالة',
    'active_1': 'نشط',
    'expired_1': 'انتهت صلاحيتها',
    'renewed': 'متجدد',
    'all_buildings_5': 'جميع المباني',
    'no_leases_found': 'لم يتم العثور على عقود الإيجار',
    'expired_2': 'انتهت صلاحيتها',
    'd_left_1': 'د اليسار',
    'd_left_2': 'د اليسار',
    'd_3': 'د',
    'renew': 'تجديد',
    'terminate': 'إنهاء',
    'terminate_lease': 'إنهاء عقد الإيجار',
    'this_action_cannot_be_undone_the_lease_w': 'لا يمكن التراجع عن هذا الإجراء. سيتم إنهاء عقد الإيجار بشكل دائم.',
    'cancel_16': 'إلغاء',
    'empty_key_13': '— #',
    'new_start_date': 'تاريخ البدء الجديد *',
    'monthly_rent_3': 'لإيجار الشهري ($) *',
    'lease_type_1': 'نوع الإيجار',
    'fixed_term_1': 'مصطلح محدد',
    'month_to_month_1': 'من شهر إلى شهر',
    'annual_1': 'سنوي',
    'renew_lease_1': 'تجديد عقد الإيجار',
    'cancel_17': 'إلغاء',
    'expiry_days': '{{days}} يوم',
    'leases_expiring_within_60d': '{{count}} عقد إيجار تنتهي خلال 60 يومًا',
    'sort_default': 'الترتيب: الافتراضي',
    'sort_expiry_asc': 'تاريخ الانتهاء ↑ الأقرب',
    'sort_expiry_desc': 'تاريخ الانتهاء ↓ الأبعد',
    'sort_rent_asc': 'الإيجار ↑ الأدنى',
    'sort_rent_desc': 'الإيجار ↓ الأعلى',
    'sort_name_asc': 'المستأجر أ → ي',
    'expiring_within': 'ينتهي خلال',
    'any_expiry': 'أي تاريخ انتهاء',
    'days_lte': '≤ {{n}} يوم',
    'create_tenant_for_lease': 'أضف مستأجرًا لإنشاء سجل عقد إيجار تلقائيًا.',
    'terminating': 'جارٍ الإنهاء...',
    'enter_termination_reason': 'أدخل سبب الإنهاء...',
    'failed_to_load_leases': 'فشل تحميل عقود الإيجار',
    'renewal_failed': 'فشل التجديد',
    'terminate_failed': 'فشل الإنهاء',
    'start_date_and_rent_required': 'تاريخ البدء والإيجار الشهري مطلوبان',
    'lease_results_count': '{{count}} عقد إيجار',
    'description_3': 'الوصف',
    'tenant_11': 'المستأجر',
    'close_4': 'إغلاق',
    'new_maintenance_schedule': 'جدول الصيانة الجديد',
    'schedule_details': 'تفاصيل الجدول الزمني',
    'building_7': 'بناء',
    'all_buildings_6': 'جميع المباني',
    'frequency': 'التردد *',
    'first_due_date': 'تاريخ الاستحقاق الأول *',
    'description_4': 'الوصف',
    'cancel_18': 'إلغاء',
    'create_schedule': 'إنشاء الجدول الزمني',
    'maintenance_schedules': 'جداول الصيانة',
    'preventive_maintenance_tracking': 'تتبع الصيانة الوقائية',
    'new_schedule': 'جدول جديد',
    'overdue_work_orders_will_be_auto_created': 'متأخرة - سيتم إنشاء أوامر العمل تلقائيًا الليلة',
    'no_schedules_found': 'لم يتم العثور على جداول زمنية',
    'history': 'التاريخ —',
    'no_history_yet': 'لا يوجد تاريخ بعد',
    'wo': 'طلب العمل #',
    'empty_key_14': '✓',
    'owner_ledger': 'دفتر مالك',
    'immutable_financial_history': '- التاريخ المالي غير قابل للتغيير',
    'refresh_1': 'تحديث',
    'add_entry': 'إضافة إدخال',
    'payouts': 'الدفعات',
    'add_manual_ledger_entry': 'إضافة إدخال دفتر الأستاذ اليدوي',
    'amount_3': 'المبلغ *',
    'description_5': 'الوصف *',
    'cancel_19': 'إلغاء',
    'showing_3': 'عرض',
    'of_5': 'من',
    'prev_2': 'السابق',
    'next_3': 'التالي',
    'new_parking_space': 'مساحة جديدة لوقوف السيارات',
    'creation_mode': 'وضع الإنشاء',
    'single_space': 'مساحة واحدة',
    'bulk_generation': 'الجيل السائب',
    'building_8': 'المبنى *',
    'select_building_1': 'اختر المبنى…',
    'prefix': 'بادئة',
    'start_number': 'رقم البداية *',
    'end_number': 'رقم النهاية *',
    'pad_with_zeros_e_g_01_02': 'لوحة مع الأصفار؟ (على سبيل المثال 01، 02)',
    'space_number': 'رقم المساحة *',
    'level': 'المستوى',
    'type_1': 'اكتب',
    'monthly_fee_1': 'الرسوم الشهرية ($)',
    'notes_8': 'ملاحظات',
    'cancel_20': 'إلغاء',
    'saving_2': 'جارٍ الحفظ…',
    'create_space': 'خلق الفضاء',
    'tenant_screening': 'فحص المستأجر',
    'identity_verification_background_checks': 'التحقق من الهوية والتحقق من الخلفية',
    'unit_12': 'وحدة',
    'select_a_tenant_to_view_or_start_their_s': 'حدد المستأجر لعرضه أو بدء فحصه',
    'final_decision': 'القرار النهائي',
    'set_on': 'تعيين على',
    'identity_verification': 'التحقق من الهوية',
    'document_2': 'الوثيقة:',
    'name_6': 'الاسم:',
    'start_identity_verification': 'ابدأ التحقق من الهوية',
    'link_was_shared_with_the_tenant_waiting': 'تمت مشاركة الرابط مع المستأجر — في انتظار إكماله.',
    'background_check_checkr': 'فحص الخلفية (Checkr)',
    'adjudication': 'الحكم:',
    'checks': 'الشيكات:',
    'start_background_check': 'ابدأ فحص الخلفية',
    'united_states': 'الولايات المتحدة',
    'canada': 'كندا',
    'fcra_consent_required': 'موافقة FCRA مطلوبة',
    'under_the_fair_credit_reporting_act_fcra': 'بموجب قانون الإبلاغ الائتماني العادل (FCRA)، يجب عليك الحصول على موافقة كتابية من مقدم الطلب قبل إجراء فحص الخلفية. سيتلقى المستأجر بريدًا إلكترونيًا من Checkr لإكمال الع��لية.',
    'i_confirm_the_applicant_has_provided_wri': 'أؤكد أن مقدم الطلب قد قدم موافقة كتابية لإجراء فحص الخلفية هذا',
    'cancel_21': 'إلغاء',
    'invitation_sent_waiting_for_the_applican': 'تم إرسال الدعوة - في انتظار إكمال مقدم الطلب. سيقوم Checkr بتحديث هذا تلقائيًا.',
    'set_final_decision': 'تحديد القرار النهائي',
    'final_screening_decision': 'قرار الفحص النهائي',
    'manual_review': 'مراجعة يدوية',
    'cancel_22': 'إلغاء',
    'no_screening_started_for_this_tenant_yet': 'لم يبدأ أي فحص لهذا المستأجر حتى الآن.',
    'empty_key_15': '($) *',
    'prospect_information': 'معلومات احتمالية',
    'showing_details': 'عرض التفاصيل',
    'empty_key_16': '· #',
    'empty_key_17': '· #',
    'add_unit_amenity_1': 'إضافة وسائل الراحة للوحدة',
    'bulk_addition_mode': 'وضع الإضافة السائبة',
    'add_this_amenity_to_multiple_units_at_on': 'أضف هذه الميزة إلى وحدات متعددة في وقت واحد',
    'amenity_details_1': 'تفاصيل وسائل الراحة',
    'clear_all': 'مسح الكل',
    'nothing_found_1': 'لم يتم العثور على شيء.',
    'amenity_name': 'اسم وسائل الراحة *',
    'category_4': 'الفئة',
    'condition': 'الحالة',
    'notes_9': 'ملاحظات',
    'cancel_23': 'إلغاء',
    'saving_3': 'جارٍ الحفظ…',
    'add_amenity_1': 'أضف وسائل الراحة',
    'n_more': '+{{n}} أكثر',
    'board_view': 'عرض اللوحة',
    'main_level': 'الطابق الرئيسي',
    'unassigned_1': 'غير مخصص',
    'unit_cat_appliance': 'أجهزة',
    'unit_cat_climate': 'مناخ',
    'unit_cat_view': 'منظر',
    'unit_cat_layout': 'تصميم',
    'unit_cat_finish': 'تشطيب',
    'unit_cat_storage': 'تخزين',
    'unit_cat_connectivity': 'اتصال',
    'unit_cat_safety': 'أمان',
    'unit_cat_other': 'أخرى',
    'bld_cat_general': 'عام',
    'bld_cat_fitness': 'لياقة بدنية',
    'bld_cat_pool': 'مسبح',
    'bld_cat_common_area': 'منطقة مشتركة',
    'bld_cat_outdoor': 'خارجي',
    'bld_cat_security': 'أمن',
    'bld_cat_business': 'أعمال',
    'bld_cat_parking': 'موقف سيارات',
    'bld_cat_pet': 'حيوانات أليفة',
    'bld_cat_laundry': 'غسيل',
    'bld_cat_storage': 'تخزين',
    'all_fields_required': 'جميع الحقول مطلوبة',
    'booking_failed': 'فشل الحجز',
    'failed_to_load_amenity': 'فشل تحميل الميزة',
    'name_required': 'الاسم مطلوب',
    'amenity_updated': 'تم تحديث الميزة',
    'amenity_added': 'تمت إضافة الميزة',
    'open_time': 'فتح',
    'close_time': 'إغلاق',
    'max_occupancy': 'الحد الأقصى للإشغال',
    'edit_building_amenity': 'تعديل ميزة المبنى',
    'new_building_amenity': 'ميزة مبنى جديدة',
    'unit_required': 'الوحدة مطلوبة',
    'at_least_one_unit_required': 'مطلوب وحدة واحدة على الأقل',
    'unit_amenity_updated': 'تم تحديث ميزة الوحدة',
    'amenity_bulk_added': 'تمت إضافة الميزة إلى {{count}} وحدات',
    'selected_units_label': 'الوحدات المحددة *',
    'unit_searchable_label': 'الوحدة * (قابلة للبحث)',
    'search_add_multiple_units': 'بحث وإضافة وحدات متعددة...',
    'search_unit_by_num': 'بحث عن وحدة برقمها أو المبنى...',
    'cond_new': 'جديد',
    'cond_excellent': 'ممتاز',
    'cond_good': 'جيد',
    'cond_fair': 'مقبول',
    'cond_needs_repair': 'يحتاج إصلاح',
    'meter_accounts_rubs_billing_and_per_tena': 'حسابات العدادات، وفواتير RUBS، ورسوم المرافق لكل مستأجر',
    'option_a_metered': 'الخيار أ – المقاس:',
    'add_account_record_reading_generate_bill': 'إضافة حساب → قراءة السجل → إنشاء فواتير → الشحن إلى دفتر الأستاذ',
    'option_c_rubs': 'الخيار ب – RUBS:',
    'building_level_meter_split_equally_acros': 'يتم تقسيم عداد مستوى المبنى بالتساوي بين جميع المستأجرين النشطين',
    'reading_recorded_for': 'القراءة المسجلة ل',
    'no_utility_accounts_yet_add_one_to_start': 'لا توجد حسابات مرافق حتى الآن — أضف حسابًا لبدء الفوترة بالعداد.',
    'no_bills_yet_generate_from_meter_readings': 'لا توجد فواتير بعد — أضف حسابات عداد، سجّل القراءات، ثم أنشئ الفواتير.',
    'no_readings': 'لا قراءات',
    'shared': 'مشترك',
    'reading': 'القراءة',
    'all_statuses_2': 'جميع الحالات',
    'accounts': 'الحسابات',
    'bills': 'الفواتير',
    'benchmarking': 'المقارنة المرجعية',
    'total_bills': 'إجمالي الفواتير',
    'total_billed': 'الإجمالي المفوتر',
    'charge': 'تهمة',
    'unit_13': 'وحدة',
    'notes_10': 'ملاحظات',
    'cancel_24': 'إلغاء',
    'loading_1': 'جارٍ التحميل…',
    'accounts_tracked': 'الحسابات التي تم تتبعها',
    'monthly_consumption_last_6_months': 'الاستهلاك الشهري — آخر 6 أشهر',
    'monthly_cost': 'التكلفة الشهرية ($)',
    'no_readings_recorded_yet_for': 'لم يتم تسجيل أي قراءات حتى الآن ل',
    'valuation_details': 'تفاصيل التقييم',
    'building_9': 'المبنى *',
    'market_value': 'القيمة السوقية ($) *',
    'valuation_method': 'طريقة التقييم',
    'notes_11': 'ملاحظات',
    'cancel_25': 'إلغاء',
    'portal': 'البوابة ✓',
    'invite_as_system_user_full_portal_access': 'دعوة كمستخدم النظام (الوصول الكامل إلى البوابة الإلكترونية)',
    'this_will_create_a_staff_account_with_th': 'سيؤدي هذا إلى إنشاء حساب موظفين بدور "المورد". سوف يتلقون دعوة عبر البريد الإلكتروني لتعيين كلمة المرور الخاصة بهم.',
    'record_violation': 'سجل المخالفة',
    'tenant_unit': 'المستأجر والوحدة',
    'tenant_12': 'المستأجر *',
    'unit_14': '- الوحدة',
    'apartment_id': 'معرف الشقة',
    'auto_filled': 'مملوءة تلقائيًا',
    'violation_details': 'تفاصيل المخالفة',
    'title_1': 'العنوان *',
    'type_2': 'النوع *',
    'severity': 'الشدة *',
    'incident_date': 'تاريخ الحادثة *',
    'fine_amount_optional': 'مبلغ الغرامة (اختياري)',
    'description_6': 'الوصف *',
    'if_a_fine_amount_is_entered_it_will_be_a': 'إذا تم إدخال مبلغ الغرامة، فسيتم تحميله تلقائيًا على دفتر أستاذ المستأجر.',
    'cancel_26': 'إلغاء',
    'record_violation_1': 'سجل المخالفة',
    'violations_notices': 'المخالفات والإشعارات',
    'track_lease_violations_and_issue_formal': 'تتبع مخالفات عقد الإيجار وإصدار إشعارات قانونية رسمية',
    'new_violation': 'انتهاك جديد',
    'how_it_works_1': 'كيف يعمل',
    'all_statuses_3': 'جميع الحالات',
    'notice': 'إشعار',
    'resolve': 'حل',
    'issue_legal_notice': 'إصدار إشعار قانوني',
    'cancel_27': 'إلغاء',
    'add_webhook_endpoint': 'أضف نقطة نهاية Webhook',
    'push_events_to_your_external_systems': 'دفع الأحداث إلى أنظمتك الخارجية',
    'successfully_created': 'تم الإنشاء بنجاح!',
    'save_your_signing_secret_now_it_won_t_be': 'احفظ سر التوقيع الخاص بك الآن، فلن يتم عرضه مرة أخرى.',
    'copy_secret': 'نسخ السرية',
    'done_return': 'تم والعودة',
    'connection_details': 'تفاصيل الاتصال',
    'payload_url': 'عنوان URL للحمولة',
    'description_7': 'الوصف',
    'event_subscriptions': 'اشتراكات الأحداث',
    'you_can_always_add_more_events_later': 'يمكنك دائمًا إضافة المزيد من الأحداث لاحقًا.',
    'register_endpoint': 'تسجيل نقطة النهاية',
    'cancel_28': 'إلغاء',
    'assign_a_new_task_to_a_maintenance_provi': 'تعيين مهمة جديدة لمزود الصيانة',
    'work_order_details': 'تفاصيل أمر العمل',
    'work_order_title': 'عنوان أمر العمل',
    'task_description': 'وصف المهمة',
    'scheduling_reference': 'الجدولة والمرجع',
    'maintenance_request_id': 'رقم طلب الصيانة',
    'assignment': 'مهمة',
    'select_a_maintenance_provider': 'اختر مزود الصيانة',
    'priority_level_level': 'مستوى مستوى الأولوية',
    'dispatch_work_order': 'إرسال أمر العمل',
    'discard_changes': 'تجاهل التغييرات',
    'pro_tip': 'نصيحة للمحترفين',
    'dispatching_a_work_order_will_immediatel': 'سيؤدي إرسال أمر العمل إلى إخطار البائع على الفور عبر البوابة الإلكترونية والبريد الإلكتروني إذا تم تمكينه.',
    'update_work_order': 'تحديث أمر العمل',
    'status_priority': 'الحالة والأولوية',
    'status_4': 'الحالة',
    'completed_date': 'تاريخ الانتهاء',
    'invoice': 'الفاتورة',
    'invoice_amount': 'مبلغ الفاتورة',
    'invoice_status': 'حالة الفاتورة',
    'cancel_29': 'إلغاء',
    'vendor_work_order_management': 'إدارة أوامر عمل البائع',
    'refresh_2': 'تحديث',
    'new_work_order': 'أمر عمل جديد',
    'all_statuses_4': 'جميع الحالات',
    'no_work_orders_found': 'لم يتم العثور على أوامر العمل',
    'mr': 'السيد:',
    'work_order': 'أمر العمل #',
    'priority_1': 'الأولوية',
    'description_8': 'الوصف',
    'linked_maintenance_request': 'طلب الصيانة المرتبطة',
    'unit_15': 'وحدة',
    'invoice_1': 'الفاتورة',
    'view_invoice_document': 'عرض مستند الفاتورة',
    'review_approve_invoice': 'مراجعة الفاتورة والموافقة عليها',
    'edit_work_order': 'تحرير أمر العمل',
    'approve_invoice': 'الموافقة على الفاتورة',
    'you_are_approving_a_vendor_invoice_of': 'أنت توافق على فاتورة مورد لـ',
    'for': 'ل',
    'charge_to_tenant_ledger': 'تحميل دفتر الأستاذ المستأجر',
    'the_cost_will_be_automatically_added_as': 'ستتم إضافة التكلفة تلقائيًا كخصم على دفتر الأستاذ الخاص بالمستأجر ليتمكن من الدفع.',
    'organization_absorbs_cost': 'المنظمة تمتص التكلفة',
    'the_tenant_will_not_be_charged_this_crea': 'لن يتم فرض رسوم على المستأجر. يؤدي هذا إلى إنشاء إدخال "الحسابات الدائنة" للمؤسسة.',
    'cancel_30': 'إلغاء',
    'loading_2': 'جارٍ التحميل…',
    'page_not_found': 'لم يتم العثور على الصفحة',
    'the_page_you_re_looking_for_doesn_t_exis': 'الصفحة التي تبحث عنها غير موجودة.',
    'go_to_dashboard': 'انتقل إلى لوحة المعلومات',
    'clear_signature': 'مسح التوقيع',
    'i_consent_to_use_electronic_signatures_a': 'أوافق على استخدام التوقيعات الإلكترونية وأوافق على استخدام توقيعي الإلكتروني',
    'cancel_31': 'هو المعادل القانوني لتوقيعي اليدوي على هذا العقد. أنا أفهم',
    'sign_contract_1': 'أن لي الحق في الحصول على نسخة ورقية من هذه الوثيقة.',
    'by_signing_this_document_electronically': 'إلغاء',
    'subscription_locked': 'توقيع العقد',
    'your_subscription_status_is': 'من خلال التوقيع على هذه الوثيقة إلكترونيًا، فإنك تقر بأن توقيعك الإلكتروني',
    'please_renew_your_subscription_to_contin': 'ملزم قانونًا وله نفس تأثير التوقيع المكتوب بخط اليد. عنوان IP الخاص بك',
    'payment_options': 'وسيتم تسجيل الطابع الزمني لأغراض التحقق.',
    'please_contact_the_administrator_to_proc': 'الاشتراك مغلق',
    'contact_admin_to_renew': 'حالة اشتراكك هي',
    'request_sent_pending_approval': '.',
    'need_help_contact_support_at_support_qua': 'يرجى تجديد اشتراكك لمواصلة إدارة الممتلكات الخاصة بك.',
    'sign_out': 'خيارات الدفع',
    'requires_the': 'يرجى الاتصال بالمسؤول لمعالجة دفعتك وإعادة تنشيط اشتراكك.',
    'pro_plan': 'اتصل بالمسؤول للتجديد',
    'is_a_pro_feature': 'تم إرسال الطلب! في انتظار الموافقة.',
    'upgrade_to_pro_to_unlock_ai_powered_inte': 'بحاجة الى مساعدة؟ اتصل بالدعم على support@quadcores.com',
    'upgrade_to_pro_1': 'تسجيل الخروج',
    'starting_at_3_20_unit_month_no_minimum_u': 'يتطلب',
    'our_narrative': 'خطة احترافية',
    'reimagined': 'هي ميزة احترافية',
    'quadcores_properties_is_an_elite_operati': 'قم بالترقية إلى Pro لفتح قفل الذكاء المدعوم بالذكاء الاصطناعي عبر محفظتك بأكملها.',
    'core_capabilities': 'الترقية إلى برو',
    'our_approach_to': 'يبدأ من 3.20 دولارًا أمريكيًا للوحدة / الشهر. لا يوجد حد أدنى للوحدات المطلوبة',
    'operations': 'روايتنا',
    'we_believe_property_management_should_be': 'إعادة تصورها.',
    'whether_you_manage_10_units_or_10_000_qu': 'تعد Quadcores Properties طبقة تشغيلية النخبة للمحفظة العقارية الحديثة.',
    'complete_platform': 'منصة كاملة',
    'all_features': 'جميع الميزات',
    '35_powerful_features_organized_into_7_co': '35 ميزة قوية منظمة في 7 فئات شاملة.',
    'link_unavailable': 'الرابط غير متاح',
    'application_submitted': 'تم تقديم الطلب!',
    'your_application_has_been_received_our_t': 'لقد تم استلام طلبك. سيقوم فريقنا بمراجعتها والرد عليك قريبًا.',
    'your_application_id': 'معرف التطبيق الخاص بك',
    'successfully_registered': 'تم التسجيل بنجاح',
    'track_application_status': 'تتبع حالة الطلب',
    'rental_application': 'تطبيق الإيجار',
    'unit_16': 'وحدة',
    'applying_for': 'التقدم بطلب للحصول',
    'full_name_2': 'الاسم الكامل *',
    'email_address': 'عنوان البريد الإلكتروني *',
    'national_id_passport': 'الهوية الوطنية / جواز السفر',
    'date_of_birth_1': 'تاريخ الميلاد',
    'current_address_1': 'العنوان الحالي',
    'employment_income': 'التوظيف والدخل',
    'employment_status_1': 'الحالة الوظيفية',
    'employed': 'موظف',
    'self_employed': 'العاملين لحسابهم الخاص',
    'retired': 'متقاعد',
    'student': 'طالب',
    'unemployed': 'عاطلين عن العمل',
    'monthly_income_1': 'الدخل الشهري',
    'employer_name_1': 'اسم صاحب العمل',
    'employer_phone_1': 'هاتف صاحب العمل',
    'lease_preferences': 'تفضيلات الإيجار',
    'desired_move_in_date': 'تاريخ الانتقال المطلوب',
    'lease_duration_months': 'مدة الإيجار (أشهر)',
    'months_2': 'أشهر',
    'i_have_pets': 'لدي حيوانات أليفة',
    'emergency_contact': 'الاتصال في حالات الطوارئ',
    'name_7': 'الاسم',
    'phone_7': 'الهاتف',
    'relation': 'العلاقة',
    'additional_notes_1': 'ملاحظات إضافية',
    'your_information_is_kept_private_and_use': 'يتم الحفاظ على خصوصية معلوماتك واستخدامها فقط لتقييم الإيجار.',
    'track_application': 'تطبيق المسار',
    'ref_id': 'معرف المرجع: #',
    'verification_email': 'البريد الإلكتروني للتحقق',
    'review': 'مراجعة',
    'approval': 'موافقة',
    'notice_from_the_team': 'إشعار من الفريق',
    'applicant': 'مقدم الطلب',
    'property_1': 'الملكية',
    'submitted_1': 'تم الإرسال',
    'approved_for_lease': 'تمت الموافقة على عقد الإيجار',
    'next_steps_sign_lease': 'الخطوات التالية: توقيع عقد الإيجار',
    'questions_contact': 'أسئلة؟ الاتصال',
    'support': 'الدعم',
    'or_call_our_leasing_office': 'أو اتصل بمكتب التأجير لدينا.',
    'verification_code': 'رمز التحقق',
    'verify_code': 'التحقق من الرمز',
    'resend_code': 'إعادة إرسال الرمز',
    'back_to_login': 'العودة إلى تسجيل الدخول',
    'invalid_link': 'رابط غير صالح',
    'go_to_login': 'اذهب إلى تسجيل الدخول',
    'welcome_aboard': 'مرحبا بكم على متن الطائرة!',
    'secure_onboarding': 'الصعود الآمن',
    'welcome_to_the_quadcores_property_manage': 'مرحبًا بك في بوابة إدارة الممتلكات Quadcores. دعنا ننتهي من إعداد حسابك الداخلي.',
    'account_role': 'دور الحساب',
    'email_address_1': 'عنوان البريد الإلكتروني',
    'set_your_password': 'قم بتعيين كلمة المرور الخاصة بك',
    'please_choose_a_secure_password_for_your': 'يرجى اختيار كلمة مرور آمنة لحسابك.',
    'show_password': 'إظهار كلمة المرور',
    'complete_account_setup': 'إكمال إعداد الحساب',
    'password_requirement_minimum_8_character': 'متطلبات كلمة المرور: الحد الأدنى 8 أحرف. نوصي باستخدام مزيج من الحروف والأرقام والرموز لتحقيق أقصى قدر من الأمان.',
    'payment_successful': 'تم الدفع بنجاح!',
    'thank_you_for_your_subscription_your_acc': 'شكرا لك على اشتراكك. تمت ترقية حسابك.',
    'go_to_dashboard_1': 'انتقل إلى لوحة المعلومات',
    'back_to_home': 'العودة إلى المنزل',
    'pricing_plans': 'التسعير + الخطط',
    'pay_for_what': 'ادفع مقابل ماذا',
    'you_actually_use': 'تستخدمه فعلا.',
    'annual_2': 'سنوي',
    '16_1': '−16%',
    'per_unit_pricing_no_minimum_portfolio_si': 'التسعير لكل وحدة. لا يوجد حد أدنى لحجم المحفظة. إلغاء في أي وقت.',
    'current_1': 'الحالي',
    'unit_17': '/ وحدة',
    'from_3': 'من',
    'mo_3': '/ مو',
    'minimum': 'الحد الأدنى',
    '2_months_free_annual_billing': 'شهرين مجاناً · الفواتير السنوية',
    'includes': 'يشمل',
    'enterprise_custom_contract': 'عقد المؤسسة / مخصص',
    '10_000_units_custom_sla_dedicated_suppor': 'أكثر من 10,000 وحدة، واتفاقية مستوى الخدمة المخصصة، ودعم مخصص، وخيار محلي.',
    'talk_to_sales': 'التحدث إلى المبيعات →',
    'feature_matrix': 'مصفوفة الميزة',
    'full_capability': 'القدرة الكاملة',
    'breakdown': 'انفصال.',
    'starter': 'كاتب',
    'growth': 'النمو',
    'pro_2': 'برو',
    'no_minimum_units_no_setup_fees_enterpris': 'لا يوجد حد أدنى للوحدات. لا رسوم الإعداد. أمان على مستوى المؤسسات في كل خطة.',
    'legal': 'قانوني',
    'privacy': 'الخصوصية',
    'policy': 'السياسة.',
    'we_are_committed_to_protecting_your_prof': 'نحن ملتزمون بحماية بياناتك المهنية والشخصية بنفس الصرامة التي نطبقها على العمليات العقارية.',
    'principles': 'الشفافية هي أساسنا.',
    'section_0': 'المبادئ',
    'legal_and_compliance': 'القسم 0',
    'inquiries': 'القانونية والامتثال',
    'if_you_have_questions_about_how_we_handl': 'الاستفسارات.',
    'info_quadcores_com': 'إذا كانت لديك أسئلة حول كيفية تعاملنا مع بياناتك، أو إذا كنت بحاجة إلى ممارسة حقوق الخصوصية الخاصة بك، فيرجى الاتصال بفريق الامتثال لدينا.',
    'please_review_the_full_contract_terms_be': 'يرجى مراجعة بنود العقد كاملةً.',
    'link_expired_or_invalid': 'info@quadcores.com',
    'we_couldn_t_find_the_contract_associated': 'يرجى مراجعة شروط العقد الكاملة أدناه.',
    'your_signature_has_been_recorded_a_copy': 'الرابط منتهي الصلاحية أو غير صالح',
    'setup_your_portal': 'لم نتمكن من العثور على العقد المرتبط بهذا الرابط. يرجى الاتصال بمكتب إدارة الممتلكات للحصول على رابط التوقيع الجديد.',
    'access_your_payments_installments_and_do': 'يمكنك الوصول إلى مدفوعاتك وأقساطك ومستنداتك في أي وقت عن طريق إنشاء حسابك على البوابة الإلكترونية.',
    'activate_my_account': 'قم بإعداد البوابة الإلكترونية الخاصة بك',
    'go_to_dashboard_2': 'يمكنك الوصول إلى مدفوعاتك وأقساطك ومستنداتك في أي وقت عن طريق إعداد حساب البوابة الإلكترونية الخاص بك.',
    'id_1': 'تفعيل حسابي',
    'contract_signature_portal': 'انتقل إلى لوحة المعلومات',
    'review_sign': 'المعرف: #',
    'hello': 'بوابة توقيع العقد',
    'please_review_your_contract_details_for': 'المراجعة والتوقيع',
    'property_2': 'ملكية',
    'contract_value': 'يرجى مراجعة تفاصيل العقد الخاص بك للعقار أدناه.',
    'timeline': 'الجدول الزمني',
    'to_3': 'ل',
    'legal_terms': 'المصطلحات القانونية',
    'en_ar': 'إن/ار',
    'legal_disclaimer': 'إخلاء المسؤولية القانونية',
    'electronic_signatures_are_legally_equiva': 'التوقيعات الإلكترونية تعادل قانونيًا التوقيعات المكتوبة بخط اليد.',
    'your_ip_address_and_device_information_w': 'سيتم تسجيل عنوان IP الخاص بك ومعلومات الجهاز للأمان.',
    'you_can_download_the_pdf_anytime_after_c': 'يمكنك تنزيل ملف PDF في أي وقت بعد الانتهاء.',
    'ready_to_complete': 'جاهز للإكمال؟',
    'continue_to_plans': 'المتابعة إلى الخطط',
    'next_step': 'الخطوة التالية...',
    'complete_registration': 'إتمام التسجيل',
    'verify_phone_number': 'تحقق من رقم هاتفك',
    'verification_code_sent_to_phone': 'تم إرسال رمز التحقق إلى هاتفك. يرجى إدخاله أدناه.',
    'popular': 'شعبية',
    'mo_4': '/ مو',
    'up_to': 'حتى',
    'units_2': 'وحدات',
    'back_to_info': 'العودة إلى المعلومات',
    'verification_code_1': 'رمز التحقق',
    'please_enter_the_6_digit_code_sent_to': 'الرجاء إدخال الرمز المكون من 6 أرقام المرسل إليه',
    'verify_phone': 'التحقق من الهاتف',
    'guidelines': 'المبادئ التوجيهية',
    'terms_of': 'شروط',
    'use': 'استخدم.',
    'our_terms_are_designed_to_ensure_a_secur': 'تم تصميم شروطنا لضمان بيئة آمنة وموثوقة وعادلة للمالكين والمستأجرين ومديري العقارات على حدٍ سواء.',
    'conditions': 'الشروط',
    'clause_0': 'البند 0',
    'agreement_to': 'الاتفاق على',
    'arbitration': 'التحكيم.',
    'by_using_the_platform_you_agree_that_any': 'باستخدام المنصة، فإنك توافق على أن أي نزاعات سيتم حلها من خلال الوساطة المهنية أو التحكيم الملزم، مما يضمن حل فعال للصراع التشغيلي.',
    'last_updated_march_2026': 'نحن ملتزمون بالحفاظ على علاقة تعاونية مع جميع مستخدمينا.',
    'system_architecture': 'آخر تحديث: مارس 2026',
    'refined': 'هندسة النظام',
    'operations_1': 'العمليات.',
    'a_masterclass_in_property_management_we': 'دورة متقدمة في إدارة الممتلكات. لقد تخلصنا من الضوضاء لنترك فقط ما هو ضروري وقوي ومصمم بدقة.',
    'complete_platform_1': 'منصة كاملة',
    'everything_you_need_to_manage': 'كل ما تحتاجه لإدارة',
    'your_properties': 'خصائصك.',
    'a_comprehensive_property_management_syst': 'نظام شامل لإدارة الممتلكات مصمم لتحقيق الكفاءة والأتمتة والتوسع.',
    'view_all_24_features': 'عرض جميع الميزات 24',
    'get_started': 'ابدأ',
    'take_control_of': 'السيطرة على',
    'your_entire_portfolio': 'محفظتك بأكملها.',
    'hundreds_of_property_managers_have_alrea': 'لقد قام المئات من مديري العقارات بنقل عملياتهم بالفعل إلى QuadProperties.',
    'start_free_trial': 'ابدأ تجربتك المجانية - لا حاجة لبطاقة ائتمان.',
    'already_have_an_account': 'ابدأ النسخة التجريبية المجانية',
    'quadcores_properties': 'هل لديك حساب بالفعل؟',
    'the_apartment_management_platform_built': 'خصائص رباعية النواة',
    'quadcores': 'منصة إدارة الشقق مصممة للعمليات الجادة.',
    'quadcores_properties_1': 'رباعية النوى',
    'every_property': 'خصائص رباعية النواة',
    'under_control': 'كل عقار.',
    'one_platform_for_leases_rent_collection': 'تحت السيطرة.',
    'start_free_trial_1': 'منصة واحدة للإيجارات وتحصيل الإيجارات والصيانة والمستأجرين -',
    'view_dashboard': 'عرض لوحة القيادة',
    'scroll': 'قم بالتمرير',
    'quadcores_properties_2': 'خصائص رباعية النواة',
    'tenant_login': 'تسجيل دخول المستأجر',
    'owner_login': 'تسجيل دخول المالك',
    'sign_in': 'تسجيل الدخول',
    'get_started_1': 'ابدأ ←',
    'sign_in_1': 'تسجيل الدخول',
    'menu': 'القائمة',
    'get_started_2': 'ابدأ',
    'tenant_13': 'المستأجر',
    'owner_1': 'المالك',
    'nav_features': 'المميزات',
    'nav_pricing': 'الأسعار',
    'nav_about': 'عن الشركة',
    'our_tiers': 'طبقاتنا',
    'choose_the_right': 'اختر الحق',
    'plan_for_you': 'خطة لك.',
    'monthly_1': 'شهريا',
    'annual_3': 'سنوي',
    'mo_5': '/ مو',
    '20_off_annual_billing': '- خصم 20% على الفاتورة السنوية',
    'quadcores_properties_3': 'خصائص رباعية النواة',
    'the_apartment_management_platform_built_1': 'منصة إدارة الشقق مصممة للعمليات الجادة.',
    'quadcores_1': 'رباعية النوى',
    'solutions': 'الحلول',
    'built_for_every_property_professional': 'مصممة لكل محترف في مجال العقارات.',
    'empty_key_18': '✦',
    'set_up_your_password': 'قم بإعداد كلمة المرور الخاصة بك',
    'create_a_strong_password_for': 'إنشاء كلمة مرور قوية ل',
    'email_address_2': 'عنوان البريد الإلكتروني',
    'new_password_1': 'كلمة المرور الجديدة',
    'confirm_password_1': 'تأكيد كلمة المرور',
    'back_to_login_1': 'العودة إلى تسجيل الدخول',
    'view_all_announcements': 'عرض جميع الإعلانات →',
    'session_expiring_soon': 'ستنتهي الجلسة قريبًا',
    'you_will_be_logged_out_automatically': 'سيتم تسجيل خروجك تلقائيا',
    'log_out': 'تسجيل الخروج',
    'stay_logged_in': 'البقاء مسجل الدخول',
    'id_2': 'المعرف: #',
    'to_4': 'ل',
    'ip_1': 'الملكية الفكرية:',
    'ip_2': 'الملكية الفكرية:',
    'contract_already_signed': 'تم توقيع العقد بالفعل',
    'you_have_already_signed_this_contract': 'لقد قمت بالفعل بتوقيع هذا العقد.',
    'review_sign_contract': 'مراجعة وتوقيع العقد',
    'awaiting_your_signature': 'في انتظار توقيعك',
    'contract_summary_1': 'ملخص العقد',
    'property_3': 'الملكية',
    'start_date_3': 'تاريخ البدء',
    'end_date_1': 'تاريخ الانتهاء',
    'terms_and_conditions': 'الشروط والأحكام',
    'important_information': 'معلومات هامة',
    'by_signing_you_agree_to_all_terms_and_co': '• بالتوقيع، فإنك توافق على جميع الشروط والأحكام المذكورة أعلاه',
    'your_electronic_signature_is_legally_bin': '• توقيعك الإلكتروني ملزم قانونًا',
    'you_will_receive_a_signed_copy_via_email': '• سوف تتلقى نسخة موقعة عبر البريد الإلكتروني',
    'you_can_download_the_signed_contract_any': '• يمكنك تنزيل العقد الموقع في أي وقت من بوابتك',
    'cancel_32': 'إلغاء',
    'sign_contract_2': 'توقيع العقد',
    'units_3': 'وحدات',
    'unit_18': 'وحدة',
    'tenant_14': 'المستأجر:',
    'empty_key_19': '· $',
    'mo_6': '/ مو',
    'no_properties_found_in_your_portfolio': 'لم يتم العثور على خصائص في محفظتك.',
    'my_ledger': 'دفتر الأستاذ الخاص بي',
    'complete_history_of_your_financial_trans': 'التاريخ الكامل للمعاملات المالية الخاصة بك',
    'current_balance_1': 'الرصيد الحالي',
    'no_ledger_entries_yet_1': 'لا توجد إدخالات دفتر الأستاذ حتى الآن',
    'transactions_will_appear_here_once_recor': 'ستظهر المعاملات هنا بمجرد تسجيلها.',
    'unit_19': 'وحدة',
    'bal': 'بال',
    'professional_access': 'الوصول المهني',
    'owner_2': 'المالك',
    'secure_identify_for_property_executives': 'تحديد آمن للمديرين التنفيذيين وإدارة الممتلكات.',
    'email_or_phone_number': 'البريد الإلكتروني أو رقم الهاتف',
    'secure_password': 'كلمة مرور آمنة',
    'switch_to_resident_login': 'التبديل إلى تسجيل الدخول المقيم',
    'institutional_oversight': 'الرقابة المؤسسية',
    'portfolio_suite': 'جناح المحفظة',
    'full_control_over_your': 'السيطرة الكاملة على الخاص بك',
    'property_assets': 'الأصول العقارية.',
    'audited_secure_compliant': 'مدققة. يؤمن. متوافق.',
    'empty_key_20': ': $',
    'per_unit_p_l_last_12_months': 'الربح والخسارة لكل وحدة - آخر 12 شهرًا',
    'loading_report': 'جارٍ تحميل التقرير…',
    'no_properties_found': 'لم يتم العثور على خصائص',
    'unit_20': '· الوحدة رقم',
    'mo_lease_ends': '/ شهر · ينتهي عقد الإيجار',
    '12_mo_noi': '12 شهر أمة الإسلام',
    'empty_key_21': '▾',
    'monthly_collections_last_6_months': 'التحصيلات الشهرية (آخر 6 أشهر)',
    'tax_documents': 'المستندات الضريبية',
    'annual_payment_summary_for_tax_reporting': 'ملخص الدفع السنوي لإعداد التقارير الضريبية (1099-NEC)',
    'total_paid_1': 'إجمالي المبلغ المدفوع',
    'this_is_your_personal_payment_summary_fo': 'هذا هو ملخص الدفع الشخصي الخاص بك. للحصول على نموذج 1099-NEC الرسمي، يرجى الاتصال بمدير العقار الخاص بك. يتم الإبلاغ فقط عن المدفوعات التي تبلغ 600 دولار أو أكثر في السنة التقويمية إلى مصلحة الضرائب الأمريكية.',
    'unit_21': 'وحدة',
    'no_payments_recorded_for': 'لم يتم تسجيل أي مدفوعات ل',
    'select_a_different_year_to_view_your_pay': 'حدد سنة مختلفة لعرض سجل الدفع الخاص بك.',
    'browse_facilities_and_book_time_slots': 'تصفح المرافق وحجز فترات زمنية',
    'no_amenities_available_in_your_building': 'لا تتوفر وسائل الراحة في المبنى الخاص بك',
    'mo_7': '/ مو',
    'capacity_1': 'القدرة:',
    'book_time_slot': 'فتحة وقت الكتاب',
    'book_an_amenity': 'حجز وسائل الراحة',
    'amenity_1': 'وسائل الراحة *',
    'select_amenity_1': 'اختر وسائل الراحة',
    'date_2': 'التاريخ *',
    'start_time_1': 'وقت البدء *',
    'end_time_1': 'وقت الانتهاء *',
    'notes_optional_1': 'ملاحظات (اختياري)',
    'cancel_33': 'إلغاء',
    'no_upcoming_bookings': 'لا توجد حجوزات قادمة',
    'browse_amenities': 'تصفح وسائل الراحة',
    'cancel_34': 'إلغاء',
    'history_1': 'التاريخ',
    'property_assistant': 'مساعد الملكية',
    'ask_about_your_account': 'اسأل عن حسابك',
    'lease_history': 'تاريخ الإيجار',
    'your_current_and_past_lease_agreements': 'اتفاقيات الإيجار الحالية والسابقة الخاصة بك',
    'active_lease': 'الإيجار النشط',
    'unit_22': 'وحدة',
    'building_10': 'بناء',
    'monthly_rent_4': 'الإيجار الشهري',
    'expires_1': 'تنتهي',
    'open_ended': 'مفتوحة',
    'start_date_4': 'تاريخ البدء',
    'security_deposit_1': 'إيداع الضمان',
    'type_3': 'اكتب',
    'no_active_lease_on_file': 'لا يوجد عقد إيجار نشط في الملف',
    'history_2': 'التاريخ',
    'mo_8': '/ مو',
    'no_lease_records_found': 'لم يتم العثور على سجلات الإيجار',
    'secure_access': 'الوصول الآمن',
    'hello_1': 'مرحبا',
    'again': 'مرة أخرى.',
    'enter_your_details_to_manage_your_home_a': 'أدخل التفاصيل الخاصة بك لإدارة منزلك والمدفوعات.',
    'your_email': 'البريد الإلكتروني الخاص بك',
    'your_password': 'كلمة المرور الخاصة بك',
    'switch_to_owner_login': 'التبديل إلى تسجيل دخول المالك',
    'everything_in_one_place': 'كل شيء في مكان واحد.',
    'tools_for_you': 'أدوات لك',
    'everything_you_need': 'كل ما تحتاجه',
    'to_manage_your_home': 'لإدارة منزلك.',
    'safe_private_reliable': 'آمن. خاص. موثوق.',
    'we_use_professional_grade_encryption_to': 'نحن نستخدم تشفيرًا احترافيًا لضمان حماية بياناتك ومدفوعاتك دائمًا.',
    'empty_key_22': ': #',
    'auto_pay_is_on': 'الدفع التلقائي قيد التشغيل',
    'your_rent_is_charged_automatically_on_th': '· يتم تحصيل الإيجار تلقائيًا في تاريخ الاستحقاق.',
    'enable_auto_pay': 'تمكين الدفع التلقائي',
    'save_a_card_or_bank_account_and_never_mi': 'احفظ بطاقتك أو حسابك البنكي ولا تفوت أي دفعة إيجار مرة أخرى.',

    'autopay_enabled_toast': 'تم تفعيل الدفع التلقائي! سيتم خصم الإيجار تلقائُاً في تاريخ الاستحقاق.',
    'autopay_setup_canceled': 'تم إلغاء إعداد الدفع التلقائي.',
    'autopay_setup_failed': 'تعذّر بدء إعداد الدفع التلقائي.',
    'autopay_start_failed': 'فشل بدء إعداد الدفع التلقائي.',
    'confirm_disable_autopay': 'هل أنت متأكد من إيقاف الدفع التلقائي؟ ستتم إزالة وسيلة الدفع المحفوظة.',
    'autopay_disabled_success': 'تم تعطيل الدفع التلقائي.',
    'autopay_disable_failed': 'فشل تعطيل الدفع التلقائي.',
    'card_ending_label': '{{brand}} تنتهي بـ ••••{{last4}}',
    'payment_method_saved': 'تم حفظ وسيلة الدفع',
    'disable_auto_pay': 'تعطيل الدفع التلقائي',
    'set_up_auto_pay': 'إعداد الدفع التلقائي',
    'due_colon': 'مستحق:',
    'disabling': 'جارِي التعطيل…',
    'renewal_offers': 'عروض التجديد',
    'review_and_respond_to_lease_renewal_offe': 'قم بمراجعة عروض تجديد عقد الإيجار المقدمة من مالك العقار والرد عليها',
    'no_renewal_offers_yet': 'لا توجد عروض تجديد حتى الآن',
    'your_property_manager_will_send_a_renewa': 'سيرسل مدير العقار الخاص بك عرضًا للتجديد هنا عندما يقترب عقد الإيجار من تاريخ انتهائه.',
    'unit_23': 'وحدة',
    'offer_sent_1': 'تم إرسال العرض',
    'per_month': 'شهريا',
    'offered_rent': 'الإيجار المعروض',
    'per_month_1': 'شهريا',
    'new_term': 'مصطلح جديد:',
    'note_from_management': 'ملحوظة من الإدارة',
    'decline': 'رفض',
    'past_offers': 'العروض الماضية',
    'unit_24': 'وحدة',
    'mo_9': '/ مو',
    'responded': 'استجاب',
    'share_feedback': 'مشاركة التعليقات',
    'your_opinion_helps_us_improve': 'رأيك يساعدنا على التحسن',
    'thank_you': 'شكرا لك!',
    'your_feedback_has_been_submitted': 'لقد تم تقديم ملاحظاتك.',
    'submit_another': 'إرسال آخر',
    'category_5': 'الفئة',
    'your_rating': 'تقييمك',
    'comment_optional': 'تعليق (اختياري)',
    'your_past_feedback': 'تعليقاتك الماضية',

    'general': 'عام',
    'submit_feedback': 'إرسال التقييم',
    'please_select_rating': 'يرجى اختيار تقييم بالنجوم',
    'submission_failed': 'فشل الإرسال',
    'tell_us_placeholder': 'أخبرنا برأيك…',
    'rating_very_poor': 'سيء جداً',
    'rating_poor': 'سيء',
    'rating_okay': 'مقبول',
    'rating_good': 'جيد',
    'rating_excellent': 'ممتاز',
    'utility_bills_1': 'فواتير المرافق',
    'electricity_water_gas_and_other_utility': 'رسوم الكهرباء والماء والغاز ورسوم المرافق الأخرى',
    'paid_on_time': 'تدفع في الوقت المحدد',
    'monthly_utility_spend': 'الإنفاق الشهري على المرافق',
    'no_utility_bills_yet': 'لا توجد فواتير المرافق حتى الآن',
    'bills_will_appear_here_once_issued_by_ma': 'ستظهر الفواتير هنا بمجرد إصدارها من قبل الإدارة.',
    'due_now': 'مستحق الآن (',
    'history_3': 'التاريخ (',
    'due_1': 'مستحق',
    'violations_notices_1': 'المخالفات والإشعارات',
    'view_violations_and_official_notices_iss': 'عرض المخالفات والإشعارات الرسمية الصادرة لك',
    'no_violations_on_record': 'لا توجد انتهاكات في السجل',
    'you_have_a_clean_record_keep_it_up': 'لديك سجل نظيف – حافظ عليه!',
    'fine': 'غرامة:',
    'resolution': 'القرار',
    'unit_25': 'وحدة',
    'no_notices': 'لا إشعارات',
    'no_official_notices_have_been_issued_to': 'لم يتم إصدار أي إشعارات رسمية لك.',
    'here_s_an_overview_of_your_operations_to': 'فيما يلي نظرة عامة على عملياتك اليوم.',
    'system_live': 'النظام لايف',
    'active_operations': 'العمليات النشطة',
    'priority_task_queue': 'قائمة انتظار المهام ذات الأولوية',
    'no_active_tasks_in_your_queue': 'لا توجد مهام نشطة في قائمة الانتظار الخاصة بك.',
    'compliance_alert': 'تنبيه الامتثال',
    'insurance_expires_in_12_days_please_uplo': 'تنتهي صلاحية التأمين خلال 12 يومًا. يرجى تحميل المستندات المحدثة.',
    'upgrade_1': 'ترقية',
    'service_score': 'نقاط الخدمة',
    'detailed_analysis': 'تحليل مفصل',
    'system_activity': 'نشاط النظام',
    'profile_load_error': 'خطأ في تحميل ملف التعريف',
    'the_registry_could_not_verify_your_ident': 'لم يتمكن التسجيل من التحقق من هويتك. اتصل بمسؤولي النظام.',
    'operator': 'المشغل',
    'tier_platinum': 'الطبقة: البلاتينية',
    'identity_matrix': 'مصفوفة الهوية',
    'logistical_data': 'البيانات اللوجستية',
    'verified_credentials': 'أوراق اعتماد تم التحقق منها',
    'profile_modifications_are_managed_by_ins': 'تتم إدارة تعديلات الملف الشخصي بواسطة بروتوكولات الأمان المؤسسية. طلب التحديثات عبر مكتب التحكم لسلامة الشبكة.',
    'invalid_or_expired_link': 'رابط غير صالح أو منتهي الصلاحية',
    'security_established': 'تم تأسيس الأمن',
    'your_portal_access_key_has_been_successf': 'لقد تم إنشاء مفتاح الوصول إلى البوابة الإلكترونية بنجاح.',
    'proceed_to_login': 'انتقل إلى تسجيل الدخول',
    'access_setup': 'إعداد الوصول',
    'finalize_your_credentials_for': 'وضع اللمسات الأخيرة على بيانات الاعتماد الخاصة بك ل',
    'new_access_key': 'مفتاح الوصول الجديد',
    'confirm_authorization': 'تأكيد التفويض',
    'finalize_connection': 'إنهاء الاتصال',
    'w_9_tax_form': 'نموذج الضريبة W-9',
    'request_for_taxpayer_identification_numb': 'طلب رقم تعريف دافع الضرائب - مطلوب لتقديم طلب 1099-NEC',
    'w_9_on_file': 'W-9 في الملف',
    'certified_on': 'معتمد على',
    'you_can_update_and_re_certify_at_any_tim': '. يمكنك التحديث وإعادة الاعتماد في أي وقت.',
    'this_form_is_required_by_the_irs_if_you': 'هذا النموذج مطلوب من قبل مصلحة الضرائب الأمريكية. إذا تلقيت 600 دولار أو أكثر في سنة تقويمية، فسيتم إصدار 1099-NEC باستخدام هذه المعلومات. لا يتم تخزين رقم التأمين الاجتماعي (SSN) الكامل الخاص بك مطلقًا — فقط آخر 4 أرقام إذا تم توفيره.',
    '1_legal_name_as_shown_on_income_tax_retu': '1. الاسم القانوني (كما هو موضح في إقرار ضريبة الدخل) *',
    '3_federal_tax_classification': '3. التصنيف الضريبي الفيدرالي *',
    'employer_id_number_ein': 'رقم هوية صاحب العمل (EIN)',
    'ssn_last_4_digits_only': 'SSN - آخر 4 أرقام فقط',
    'we_only_store_the_last_4_for_your_privac': 'نقوم بتخزين آخر 4 فقط لخصوصيتك',
    '5_address': '5. العنوان',
    'city': 'المدينة',
    'state': 'الدولة',
    'certification': 'شهادة',
    'under_penalties_of_perjury_i_certify_tha': 'بموجب عقوبات الحنث باليمين، أشهد بما يلي: (1) الرقم الموضح هو رقم تعريف دافع الضرائب الصحيح الخاص بي؛ (2) لا أخضع للاقتطاع الضريبي الاحتياطي؛ (3) أنا مواطن أمريكي أو أي شخص أمريكي آخر؛ (4) أنا معفي من الإبلاغ عن قانون الالتزام الضريبي للحسابات الأجنبية (إن وجد).',
    'by_clicking': 'عن طريق النقر',
    'save_certify': 'حفظ واعتماد',
    'you_are_electronically_signing_this_w_9': 'أنت تقوم بالتوقيع إلكترونيًا على نموذج W-9 هذا. سيتم تسجيل عنوان IP الخاص بك والطابع الزمني.',
    'core_operations': 'العمليات الأساسية',
    'work_orders_1': 'أوامر العمل',
    'execute_your_assignments_with_efficiency': 'قم بتنفيذ مهامك بكفاءة ودقة.',
    'all_assignments': 'جميع الواجبات',
    'assigned_tasks': 'المهام المعينة',
    'currently_active': 'نشط حاليا',
    'completed_history': 'التاريخ المكتمل',
    'no_assignments_found': 'لم يتم العثور على أي مهام',
    'your_current_view_filters_haven_t_matche': 'لم تتطابق عوامل تصفية العرض الحالية مع أي سجلات.',
    'unit_26': 'وحدة',
    'task_description_1': 'وصف المهمة',
    'completion_evidence': 'أدلة الإكمال',
    'logistics_control': 'التحكم اللوجستي',
    'start_mission': 'ابدأ المهمة',
    'mark_finished': 'انتهى مارك',
    'submit_invoice': 'إرسال الفاتورة',
    'view_brief': 'عرض موجز',
    'notice_1': 'إشعار',
    'safety_protocols_are_active_wear_authori': 'بروتوكولات السلامة نشطة. ارتداء معدات الوقاية الشخصية المصرح بها في جميع الأوقات.',
    'page_1': 'الصفحة',
    'of_6': 'من',
    'next_4': 'التالي',
    'submit_settlement': 'تقديم التسوية',
    'claim_amount_for': 'مبلغ المطالبة ل',
    'cancel_35': 'إلغاء',
    'live': 'مباشر',
    'sign_out_1': 'تسجيل الخروج',
    'sign_out_2': 'تسجيل الخروج',

    // Missing translations added
    'active_agreements': 'العقود النشطة',
    'amount_due': 'المبلغ المستحق الحالي',
    'bill_charged': 'تم احتساب الفاتورة على حساب المستأجر',
    'billing_day': 'يوم إصدار الفاتورة من الشهر',
    'building_meter_hint': 'عداد المبنى — استخدم نظام RUBS لتوزيع التكلفة على جميع المستأجرين',
    'calculating': 'جارٍ الحساب…',
    'charge_all': 'تحصيل الكل',
    'charging': 'جارٍ التحصيل…',
    'complete_signing': 'إتمام التوقيع',
    'confirm_booking_question_ar': 'تأكيد الحجز: هل أنت متأكد من رغبتك في تثبيت هذا الحجز وحجز الوحدة لهذا العميل؟',
    'confirm_booking_question_ku': 'پشتڕاستکردنەوەی حجز: ئایا دڵنیایت کە دەتەوێت ئەم حجزە پشتڕاست بکەیتەوە و یەکەکە بۆ ئەم کڕیارە دابنێیت؟',
    'confirmation_statement': '"أنا {{name}}، أؤكد بموجب هذا أنني اطلعت على جميع شروط عقد الإيجار للمبنى {{building}}، الوحدة {{unit}}، وأوافق عليها."',
    'contract_progress': 'سير العقد',
    'custom': 'مخصص',
    'date': 'التاريخ',
    'digital_trace': 'الأثر الرقمي',
    'digital_verification_required': 'التحقق من التوقيع الرقمي مطلوب',
    'electronic_lease_signing': 'التوقيع الإلكتروني على عقد الإيجار',
    'electronic_signature_recorded': 'تم تسجيل التوقيع الإلكتروني',
    'ent_f1': 'وحدات وإداريون غير محدودين',
    'ent_f10': 'الوصول إلى API والـ Webhook',
    'ent_f11': 'التحقق الثنائي عبر WhatsApp OTP',
    'ent_f2': 'بوابات المستأجرين والملاك',
    'ent_f3': 'مراسلة آمنة ثنائية الاتجاه',
    'ent_f4': 'مدفوعات الإيجار عبر Stripe',
    'ent_f5': 'نظام البريد الإلكتروني الآلي',
    'ent_f6': 'التوقيع الرقمي على العقود',
    'ent_f7': 'دعم متعدد المؤسسات',
    'ent_f8': 'قوالب تقارير مخصصة',
    'ent_f9': 'سجلات النشاط المتقدمة',
    'enterprise_desc': 'تحكم على مستوى المؤسسات مع بوابات خدمة ذاتية متكاملة.',
    'first_payment_message': 'سيظهر سجل مدفوعاتك هنا بعد إجراء أول دفعة.',
    'generate_bills': 'إنشاء الفواتير',
    'generate_bills_now': 'إنشاء الفواتير الآن',
    'individual_meter_hint': 'عداد فردي — أنشئ فاتورة لهذه الوحدة',
    'installment_details': 'تفاصيل الأقساط',
    'installment_plan': 'خطة الأقساط',
    'lease_not_found_subtitle': 'تواصل مع الإدارة إذا كنت تعتقد أن هذا خطأ.',
    'management_agreements': 'اتفاقيات الإدارة',
    'management_fees_subtitle': 'نظرة عامة على إيرادات الملاك ورسوم الإدارة وجداولها.',
    'next_installment': 'القسط القادم',
    'payments_subtitle': 'إدارة مدفوعات الإيجار وعرض سجل المعاملات.',
    'pro_desc': 'للشركات المتخصصة ذات سير عمل إداري آلي.',
    'pro_f1': 'حتى 150 وحدة',
    'pro_f10': 'دعم ذو أولوية قياسية',
    'pro_f2': '5 مقاعد للمديرين',
    'pro_f3': 'مركز الصيانة الشامل',
    'pro_f4': 'الامتثال لضمانات الإيداع الأمني',
    'pro_f5': 'كشوفات شهرية آلية',
    'pro_f6': 'تذكيرات WhatsApp',
    'pro_f7': 'إدارة الملاك وأوامر العمل',
    'pro_f8': 'تحليلات الإشغال',
    'pro_f9': 'الحجز وقوائم الانتظار والتحويلات',
    'property_info': 'معلومات العقار',
    'purchase_agreement': 'عقد البيع',
    'redirecting_to_payment': 'جارٍ التحويل إلى بوابة الدفع الآمنة...',
    'remaining_balance': 'الرصيد المتبقي',
    'run_rubs_btn': 'تشغيل توزيع RUBS',
    'save_20_annual': 'وفّر 20% · ${{amount}}/سنة عند الدفع السنوي',
    'service_agreement': 'اتفاقية الخدمة',
    'settings_subtitle': 'إدارة حسابك وتفضيلات النظام',
    'starter_desc': 'للملاك المستقلين الذين يديرون السجلات الداخلية.',
    'starter_f1': 'حتى 100 وحدة',
    'starter_f2': 'مقعدان للمديرين',
    'starter_f3': 'إدارة المباني والوحدات',
    'starter_f4': 'دفتر أستاذ مزدوج القيد',
    'starter_f5': 'تتبع الإيجار اليدوي',
    'starter_f6': 'تقارير مالية أساسية',
    'starter_f7': 'إشعارات البريد الإلكتروني',
    'starter_plan': 'الباقة الأساسية',
    'total_contract_value': 'إجمالي قيمة العقد',
    'total_service_fees': 'إجمالي رسوم الخدمة',
    'type_full_name': 'اكتب الاسم الكامل للتوقيع',
    'unknown': 'غير معروف',
    'utility_step1': 'أضف حساب مرفق (كهرباء، ماء، غاز…)',
    'utility_step2': 'سجّل قراءة العداد',
    'utility_step3': 'أنشئ الفواتير من القراءات',
    'utility_step4': 'احتسب الفواتير مباشرةً على حساب المستأجر',
    'view_application': 'عرض الطلب',

    'confirm_charge_bill': 'هل تريد احتساب فاتورة المرفق هذه على حساب المستأجر؟',

    'all_tenants_compliant_desc': 'جميع المستأجرين ممتثلون حالياً',
    'audit_compliance': 'تدقيق الامتثال',
    'compliant': 'ممتثل',
    'confirm_delete_policy': 'هل تريد حذف هذه الوثيقة؟',
    'entity_name': 'اسم الجهة',
    'error_loading_insurance': 'فشل تحميل وثائق التأمين',
    'expiration': 'تاريخ الانتهاء',
    'no_insurance_records': 'لا توجد سجلات تأمين',
    'non_compliant': 'غير ممتثل',
    'policy_added': 'تمت إضافة الوثيقة',
    'policy_updated': 'تم تحديث الوثيقة',
    'send_notice': 'إرسال إشعار',
    'view_policy': 'عرض السياسة',

    'generate_drafts': 'إنشاء المسودات الآن',

    // Evictions
    'ev_initiated': 'مبادر',
    'ev_notice_served': 'تم تسليم الإشعار',
    'ev_court_filed': 'تم الرفع للمحكمة',
    'ev_court_ruling': 'قرار المحكمة',
    'ev_completed': 'مكتمل',
    'ev_dismissed': 'مرفوض',
    'ev_notice_pay_or_quit': 'الدفع أو الإخلاء',
    'ev_notice_cure_or_quit': 'الإصلاح أو الإخلاء',
    'ev_notice_unconditional': 'إخلاء غير مشروط',
    'ev_active_cases': 'الحالات النشطة',
    'ev_notice_served': 'تم تسليم الإشعار',
    'ev_court_filed': 'تم الرفع للمحكمة',
    'ev_total_owed': 'إجمالي المستحق',
    'ev_notice_type': 'نوع الإشعار',
    'ev_amount_owed': 'المبلغ المستحق',
    'ev_status_updated': 'تم تحديث الحالة',
    'ev_dismiss_case': 'رفض القضية',
    'ev_dismiss_confirm': 'هل أنت متأكد أنك تريد رفض قضية الإخلاء هذه؟ لا يمكن التراجع عن هذا.',
    'ev_case_dismissed': 'تم رفض قضية الإخلاء',
    'ev_dismiss_failed': 'فشل رفض القضية',
    'ev_case_timeline': 'الجدول الزمني للقضية',
    'ev_notice_served_date': 'تاريخ تسليم الإشعار',
    'ev_court_filing_date': 'تاريخ رفع الدعوى',
    'ev_court_date': 'تاريخ الجلسة',
    'ev_ruling': 'القرار',
    'ev_ruling_date': 'تاريخ القرار',
    'ev_vacate_date': 'الإخلاء بحلول',
    'ev_edit_notes': 'تعديل الملاحظات',
    'ev_save_notes': 'حفظ الملاحظات',
    'ev_add_notes': 'إضافة ملاحظات',
    'ev_notes_saved': 'تم حفظ الملاحظات',
    'ev_save_failed': 'فشل الحفظ',
    'filed': 'تاريخ التقديم',

    // Inspections
    'insp_move_in': 'تسجيل الدخول',
    'insp_move_out': 'تسجيل الخروج',
    'insp_periodic': 'دوري',
    'insp_maintenance': 'صيانة',
    'total': 'الإجمالي',
    'draft': 'مسودة',
    'completed': 'مكتمل',
    'signed': 'موقع',
    'all_types': 'جميع الأنواع',
    'all_status': 'جميع الحالات',
    'unit_building': 'الوحدة / المبنى',
    'checklist_progress': 'تقدم قائمة التفتيش',
    'condition_1': 'الحالة',
    'date': 'التاريخ',

    // Violations
    'tenant_unit': 'المستأجر / الوحدة',
    'title': 'العنوان',
    'severity': 'الخطورة',
    'fine': 'الغرامة',

    // Leases
    'start': 'البداية',
    'end': 'النهاية',
    'expiry': 'انتهاء الصلاحية',
    'rent_mo': 'الإيجار/شهر',
    'deposit': 'التأمين',
    'open_ended': 'مفتوح',

    // Renewals
    'current_rent': 'الإيجار الحالي',
    'offered_rent': 'الإيجار المعروض',
    'risk': 'المخاطرة',
    'offer_expires': 'انتهاء العرض',

    // Lease Applications
    'applicant': 'المتقدم',
    'contact': 'التواصل',
    'move_in': 'تاريخ الانتقال',
    'income': 'الدخل',
    'employment': 'جهة العمل',

    // Application Links
    'total_links': 'إجمالي الروابط',
    'active_links': 'الروابط النشطة',
    'total_uses': 'إجمالي الاستخدامات',
    'generating': 'جارٍ الإنشاء...',
    'generate_link': 'إنشاء رابط',
    'deactivate_link': 'إلغاء تفعيل الرابط',
    'deactivate_link_confirm': 'هل تريد إلغاء تفعيل الرابط "{{label}}"؟ لن يقبل الطلبات بعد الآن.',
    'deactivate': 'إلغاء التفعيل',

    // Sales Wizard
    'sw_step_buyer': 'المشتري',
    'sw_step_terms': 'الشروط',
    'sw_step_schedule': 'الجدول',
    'sw_step_confirm': 'التأكيد',
    'back': 'رجوع',
    'creating': 'جارٍ الإنشاء...',
    'create_sale_contract': 'إنشاء عقد بيع',
    'hash': '#',
    'due_date': 'تاريخ الاستحقاق',
    'payment': 'الدفعة',
    'principal': 'رأس المال',
    'interest': 'الفائدة',
    'balance': 'الرصيد',
    'monthly_payment': 'الدفعة الشهرية',
    'total_interest': 'إجمالي الفائدة',
    'total_cost': 'التكلفة الإجمالية',
    'down_payment': 'الدفعة الأولى',
    'sale_price': 'سعر البيع',
    'financed_amount': 'المبلغ الممول',
    'interest_rate': 'سعر الفائدة',
    'term': 'المدة',

    // Validation errors
    'val_first_name_min': 'يجب أن يتكون الاسم الأول من حرفين على الأقل',
    'val_first_name_max': 'يجب ألا يتجاوز الاسم الأول 50 حرفاً',
    'val_last_name_min': 'يجب أن يتكون اسم العائلة من حرفين على الأقل',
    'val_last_name_max': 'يجب ألا يتجاوز اسم العائلة 50 حرفاً',
    'val_username_min': 'يجب أن يتكون اسم المستخدم من 3 أحرف على الأقل',
    'val_username_max': 'يجب ألا يتجاوز اسم المستخدم 30 حرفاً',
    'val_username_no_spaces': 'لا يمكن أن يحتوي اسم المستخدم على مسافات',
    'val_email_invalid': 'الرجاء إدخال عنوان بريد إلكتروني صحيح',
    'val_company_name_min': 'يجب أن يتكون اسم الشركة من حرفين على الأقل',
    'val_password_min': 'يجب أن تتكون كلمة المرور من 8 أحرف على الأقل',
    'val_password_max': 'يجب ألا تتجاوز كلمة المرور 128 حرفاً',
    'val_name_max_100': 'يجب ألا يتجاوز الاسم 100 حرف',
    'val_close_time_required': 'الرجاء تحديد وقت الإغلاق',
    'val_open_time_required': 'الرجاء تحديد وقت الفتح',
    'val_close_after_open': 'يجب أن يكون وقت الإغلاق بعد وقت الفتح',
    'val_title_max_200': 'يجب ألا يتجاوز العنوان 200 حرف',
    'val_description_max_2000': 'يجب ألا يتجاوز الوصف 2000 حرف',
    'val_fine_non_negative': 'يجب أن يكون مبلغ الغرامة صفراً أو أكثر',
    'val_prospect_name_max': 'يجب ألا يتجاوز اسم العميل المحتمل 200 حرف',
    'val_end_after_start': 'يجب أن يكون وقت الانتهاء بعد وقت البدء',
    'val_notes_max_2000': 'يجب ألا تتجاوز الملاحظات 2000 حرف',
    'val_expiry_after_start': 'يجب أن يكون تاريخ الانتهاء بعد تاريخ البدء',
    'val_url_invalid': 'يجب أن يبدأ عنوان URL بـ http:// أو https://',
    'val_notes_max_1000': 'يجب ألا تتجاوز الملاحظات 1000 حرف',
    'val_webhook_url_https': 'يجب أن يبدأ عنوان Webhook بـ https://',

    'error_loading_violations': 'خطأ في تحميل المخالفات',
    'marked_as_resolved': 'تم التعليم كمحلول',
    'error_updating_violation': 'خطأ في تحديث المخالفة',
    'title_and_notice_body_required': 'العنوان ومحتوى الإشعار مطلوبان',
    'notice_issued': 'تم إصدار الإشعار',
    'error_issuing_notice': 'خطأ في إصدار الإشعار',
    'search_violations': 'البحث بالمستأجر أو العنوان أو الوصف...',
    'loading_violations': 'جارٍ تحميل المخالفات...',
    'no_violations_recorded': 'لا توجد مخالفات مسجلة',
    'no_status_violations': 'لا توجد مخالفات {{status}}',
    'notice_type_required': 'نوع الإشعار *',
    'delivery_method_required': 'طريقة التسليم *',
    'notice_title_required': 'عنوان الإشعار *',
    'notice_deadline_optional': 'الموعد النهائي للامتثال (اختياري)',
    'notice_body_required': 'نص الإشعار *',
    'issuing': 'جارٍ الإصدار...',
    'issue_notice_btn': 'إصدار إشعار',
    'violations_count': '{{count}} مخالفة',
    'open_tickets': 'تذاكر مفتوحة',
    'has_balance': 'يوجد رصيد',
    'perfect_payments': 'مدفوعات مثالية',
    'risk_score': 'درجة المخاطرة',

    'failed_to_load_evictions': 'فشل تحميل قضايا الإخلاء',
    'failed_to_update_status': 'فشل تحديث الحالة',
    'please_select_a_tenant': 'الرجاء اختيار مستأجر',
    'tenant_must_have_apartment': 'يجب أن يكون للمستأجر المحدد شقة ومبنى معينان لإجراء الإخلاء.',
    'reason_is_required': 'السبب مطلوب',
    'eviction_case_opened': 'تم فتح قضية الإخلاء',
    'failed_to_create_eviction': 'فشل إنشاء قضية الإخلاء',

    'wo_stat_total': 'المجموع',
    'wo_stat_assigned': 'مُسند',
    'wo_stat_in_progress': 'قيد التنفيذ',
    'wo_stat_completed': 'مكتمل',
    'wo_col_title': 'العنوان',
    'wo_col_vendor': 'المورد',
    'wo_col_priority': 'الأولوية',
    'wo_col_status': 'الحالة',
    'wo_col_scheduled': 'المجدول',
    'wo_col_invoice': 'الفاتورة',
    'wo_col_assigned_by': 'أُسند بواسطة',
    'wo_detail_scheduled': 'المجدول',
    'wo_detail_completed': 'مكتمل',
    'wo_detail_created': 'تاريخ الإنشاء',
    'wo_failed_to_load': 'فشل تحميل أوامر العمل',
    'wo_invoice_approved': 'تمت الموافقة على الفاتورة بنجاح!',
    'wo_confirm_approval': 'تأكيد الموافقة',
    'wo_status_assigned': 'مُعيَّن',
    'wo_status_in_progress': 'قيد التنفيذ',
    'wo_status_on_hold': 'معلّق',
    'inv_status_received': 'مستلمة',
    'view_detail': 'عرض التفاصيل',
    'wo_failed_approve': 'فشل الموافقة على الفاتورة',
    'wo_failed_load_vendors': 'فشل تحميل قائمة الموردين',
    'wo_vendor_required': 'المورد مطلوب',
    'wo_title_required': 'العنوان مطلوب',
    'wo_created': 'تم إنشاء أمر العمل بنجاح',
    'wo_failed_to_create': 'فشل إنشاء أمر العمل',
    'wo_title_placeholder': 'مثال: إصلاح أنبوب مسرب في المبنى A وحدة 302',
    'wo_description_placeholder': 'قدم تعليمات تفصيلية للمورد...',
    'wo_linked_id_placeholder': 'معرف مرتبط اختياري',
    'wo_nothing_to_update': 'لا يوجد شيء للتحديث',
    'wo_updated': 'تم تحديث أمر العمل',
    'wo_update_failed': 'فشل التحديث',
    'sch_col_title': 'العنوان',
    'sch_col_building': 'المبنى',
    'sch_col_frequency': 'التكرار',
    'sch_col_next_due': 'الموعد التالي',
    'sch_col_est_cost': 'التكلفة التقديرية',
    'sch_col_status': 'الحالة',
    'sch_col_actions': 'الإجراءات',
    'sch_error_loading': 'خطأ في تحميل الجداول الزمنية',
    'sch_mark_complete_success': 'تم التحديد كمكتمل، تم تقديم الموعد التالي',
    'sch_error_complete': 'خطأ في إكمال الجدول الزمني',
    'sch_confirm_remove': 'هل تريد إزالة هذا الجدول الزمني؟',
    'sch_removed': 'تمت إزالة الجدول الزمني',
    'sch_error_remove': 'خطأ في إزالة الجدول الزمني',
    'sch_error_history': 'خطأ في تحميل السجل',
    'sch_search_placeholder': 'البحث في الجداول الزمنية...',
    'sch_status_active': 'نشط',
    'sch_status_inactive': 'غير نشط',
    'sch_edit_success': 'تم تحديث الجدول الزمني',
    'sch_error_edit': 'خطأ في تحديث الجدول الزمني',
    'sch_edit_schedule': 'تعديل الجدول الزمني',
    'sch_title_freq_due_required': 'العنوان والتكرار وتاريخ الاستحقاق الأول مطلوبة',
    'schedule_created': 'تم إنشاء الجدول',
    'sch_failed_to_create': 'فشل إنشاء الجدول',
    'sch_history_title': 'السجل',
    'sch_remove_title': 'حذف',
    'describe_task_placeholder': 'وصف مهمة الصيانة...',
    'vendor_instructions_placeholder': 'تعليمات محددة للمورد...',
    'freq_daily': 'يومي',
    'freq_weekly': 'أسبوعي',
    'freq_biweekly': 'كل أسبوعين',
    'freq_monthly': 'شهري',
    'freq_quarterly': 'ربع سنوي',
    'freq_semiannual': 'نصف سنوي',
    'freq_biannual': 'نصف سنوي',
    'freq_annual': 'سنوي',

    'search_conversations': 'البحث في المحادثات...',
    'load_more': 'تحميل المزيد',
    'no_results': 'لا توجد نتائج',
    'failed_to_update_document_status': 'فشل تحديث حالة الوثيقة',

    // Auto injected missing keys
    'hw_record_violation': '1. تسجيل المخالفة',
    'hw_record_violation_desc': 'سجّل مخالفة بالنوع والخطورة والغرامة الاختيارية. تُضاف الغرامة تلقائياً إلى حساب المستأجر.',
    'hw_issue_notice': '2. إصدار إشعار رسمي',
    'hw_issue_notice_desc': 'أرفق إشعاراً قانونياً (ادفع أو أخلِ، صحّح أو أخلِ) وأرسله عبر البريد الإلكتروني أو واتساب.',
    'hw_track_resolution': '3. متابعة الحل',
    'hw_track_resolution_desc': 'حدّث الحالة: تم الإقرار ← تصعيد ← تم الحل. يُحتفظ بسجل تدقيق كامل.',
    'hw_escalate': '4. التصعيد عند الحاجة',
    'hw_escalate_desc': 'يمكن لمخالفات التصعيد أن تُغذّي سير عمل تقديم طلب الإخلاء.',
    'notice_title_placeholder': 'مثال: إشعار الدفع أو الإخلاء — الإيجار مستحق',
    'notice_body_placeholder': 'أدخل النص الكامل للإشعار القانوني...',
    'failed_to_load_tenants': 'فشل تحميل المستأجرين. يرجى التحقق من اتصالك.',
    'please_select_tenant': 'يرجى اختيار مستأجر أولاً',
    'title_is_required': 'العنوان مطلوب',
    'violation_recorded_notice_sent': 'تم تسجيل المخالفة — تم إرسال الإشعار تلقائياً إلى المستأجر',
    'violation_recorded': 'تم تسجيل المخالفة',
    'error_creating_violation': 'خطأ في إنشاء المخالفة',
    'select_tenant_placeholder': 'اختر مستأجراً...',
    'violation_title_placeholder': 'مثال: شكوى ضوضاء — موسيقى صاخبة بعد منتصف الليل',
    'violation_desc_placeholder': 'صف المخالفة بالتفصيل...',
    'saving_ellipsis': 'جارٍ الحفظ...',
    'violation_status_open': 'مفتوح',
    'violation_status_acknowledged': 'تم الإقرار',
    'violation_status_resolved': 'تم الحل',
    'violation_status_escalated': 'تم التصعيد',
    'violation_status_closed': 'مغلق',
    'violation_type_noise': 'ضوضاء',
    'violation_type_pets': 'حيوانات أليفة',
    'violation_type_damage': 'ضرر',
    'violation_type_unauthorized_occupant': 'ساكن غير مرخص',
    'violation_type_parking': 'وقوف السيارات',
    'violation_type_smoking': 'تدخين',
    'violation_type_cleanliness': 'نظافة',
    'violation_type_lease_breach': 'انتهاك العقد',
    'violation_type_late_payment': 'دفعة متأخرة',
    'violation_type_general': 'عام',
    'violation_severity_warning': 'تحذير',
    'violation_severity_minor': 'بسيط',
    'violation_severity_major': 'جسيم',
    'violation_severity_critical': 'حرج',
    'notice_type_pay_or_quit': 'ادفع أو أخلِ',
    'notice_type_cure_or_quit': 'صحّح أو أخلِ',
    'notice_type_unconditional_quit': 'إخلاء غير مشروط',
    'notice_type_entry_notice': 'إشعار دخول',
    'notice_type_non_renewal': 'عدم التجديد',
    'notice_type_eviction_filing': 'تقديم طلب إخلاء',
    'notice_type_lease_termination': 'إنهاء عقد الإيجار',
    'notice_type_rent_increase': 'زيادة الإيجار',
    'notice_type_general': 'عام',
    'delivery_method_email': 'بريد إلكتروني',
    'delivery_method_whatsapp': 'واتساب',
    'delivery_method_hand_delivered': 'تسليم يدوي',
    'delivery_method_certified_mail': 'بريد مسجل',
    'delivery_method_posted_on_door': 'منشور على الباب',
    'delivery_method_sms': 'رسالة نصية',
    'ev_reason_placeholder': 'عدم دفع الإيجار، انتهاك العقد، إلخ.',
    'select_placeholder': 'اختر...',
    'opening_ellipsis': 'جارٍ الفتح...',
    'err_loading_tenants': 'خطأ في تحميل المستأجرين',
    'identity_link_opened': 'تم فتح رابط التحقق من الهوية — شاركه مع المستأجر',
    'failed_identity_verification': 'فشل بدء التحقق من الهوية',
    'fcra_consent_required_toast': 'يجب تأكيد موافقة FCRA قبل إجراء فحص الخلفية',
    'bg_invitation_sent': 'تم إرسال دعوة فحص الخلفية إلى بريد المستأجر الإلكتروني',
    'failed_bg_check': 'فشل بدء فحص الخلفية',
    'screening_decision_set': 'تم تعيين قرار الفحص إلى: ',
    'failed_to_save_decision': 'فشل حفظ القرار',
    'search_tenants_placeholder': 'البحث عن المستأجرين...',
    'loading_ellipsis': 'جارٍ التحميل...',
    'loading_screening_data': 'جارٍ تحميل بيانات الفحص...',
    'dob_optional': 'تاريخ الميلاد (اختياري)',
    'zipcode_optional': 'الرمز البريدي (اختياري)',
    'state_optional': 'الولاية (اختياري)',
    'country_label': 'الدولة',
    'sending_ellipsis': 'جارٍ الإرسال...',
    'send_to_tenant': 'إرسال إلى المستأجر',
    'decision_label': 'القرار',
    'add_notes_decision_placeholder': 'أضف أي ملاحظات حول هذا القرار...',
    'save_decision': 'حفظ القرار',
    'badge_not_started': 'لم يبدأ',
    'badge_verified': 'تم التحقق',
    'badge_action_needed': 'يتطلب إجراء',
    'badge_canceled': 'ملغى',
    'badge_clear': 'خالٍ',
    'badge_consider': 'للدراسة',
    'badge_dispute': 'متنازع عليه',
    'badge_suspended': 'موقوف',
    'badge_approved': 'مقبول',
    'badge_rejected': 'مرفوض',
    'badge_manual_review': 'مراجعة يدوية',
}
};
